var zo = Object.defineProperty;
var Oo = (e, t, i) => t in e ? zo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var Tt = (e, t, i) => (Oo(e, typeof t != "symbol" ? t + "" : t, i), i);
import { defineComponent as F, openBlock as d, createElementBlock as A, createVNode as U, unref as b, renderSlot as it, createBlock as K, createCommentVNode as _, resolveComponent as B, normalizeClass as J, createElementVNode as l, toDisplayString as Y, ref as k, onMounted as St, onBeforeUnmount as ki, createTextVNode as nt, computed as et, normalizeStyle as Ft, onUpdated as bo, watch as jt, nextTick as je, Fragment as gt, renderList as wt, withDirectives as Mi, vModelCheckbox as cs, withCtx as X, markRaw as Yo, withKeys as re, onUnmounted as Un, Teleport as vo, reactive as Qn, provide as Zt, inject as Bt, onBeforeMount as Ls, vModelRadio as _o, withModifiers as ko, vModelText as js, Transition as Dn, onBeforeUpdate as Uo, resolveDynamicComponent as Qo, createApp as Wo } from "vue";
import Po from "primevue/blockui";
import $o from "primevue/progressspinner";
import { defineStore as gs, createPinia as Vo } from "pinia";
import { useRouter as Kt, useRoute as Ui, createRouter as Go, createWebHistory as Zo } from "vue-router";
import Bo from "axios";
import Nu from "primevue/button";
import Jo from "primevue/overlaypanel";
import { useToast as Qi } from "primevue/usetoast";
import { useConfirm as Fo } from "primevue/useconfirm";
const Ro = { class: "intranet-page container-fluid" }, Xo = {
  key: 0,
  class: "k-page-overlay-content-centered"
}, Ho = /* @__PURE__ */ F({
  __name: "Page",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, i) => (d(), A("div", Ro, [
      U(b(Po), {
        blocked: e.loading,
        fullScreen: !0
      }, null, 8, ["blocked"]),
      e.loading ? (d(), A("div", Xo, [
        it(t.$slots, "loading-content", {}, () => [
          e.loading ? (d(), K(b($o), { key: 0 })) : _("", !0)
        ])
      ])) : _("", !0),
      it(t.$slots, "default")
    ]));
  }
}), Ko = { class: "d-flex align-items-center mb-2" }, qo = { class: "ms-auto" }, ta = /* @__PURE__ */ F({
  __name: "PageHeader",
  props: {
    title: { default: "" },
    sticky: { type: Boolean, default: !1 },
    showBackButton: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e;
    return (i, n) => {
      const u = B("KBackButton");
      return d(), A("div", {
        class: J({ sticky: e.sticky, "k-page-header-sticky": e.sticky })
      }, [
        t.showBackButton ? (d(), K(u, {
          key: 0,
          class: "pb-1"
        })) : _("", !0),
        l("div", Ko, [
          l("div", null, [
            l("h2", null, Y(e.title), 1)
          ]),
          l("div", qo, [
            it(i.$slots, "primary-actions")
          ])
        ]),
        l("div", null, [
          it(i.$slots, "secondary-actions")
        ])
      ], 2);
    };
  }
});
var Wn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ea(e) {
  var t = e.default;
  if (typeof t == "function") {
    var i = function() {
      return t.apply(this, arguments);
    };
    i.prototype = t.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var u = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(i, n, u.get ? u : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), i;
}
var Pn = { exports: {} };
(function(e, t) {
  (function(i, n) {
    e.exports = n();
  })(Wn, function() {
    var i = 1e3, n = 6e4, u = 36e5, s = "millisecond", o = "second", a = "minute", M = "hour", r = "day", L = "week", c = "month", j = "quarter", g = "year", I = "date", y = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, x = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, p = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, T = function(w, f, S) {
      var D = String(w);
      return !D || D.length >= f ? w : "" + Array(f + 1 - D.length).join(S) + w;
    }, E = { s: T, z: function(w) {
      var f = -w.utcOffset(), S = Math.abs(f), D = Math.floor(S / 60), N = S % 60;
      return (f <= 0 ? "+" : "-") + T(D, 2, "0") + ":" + T(N, 2, "0");
    }, m: function w(f, S) {
      if (f.date() < S.date())
        return -w(S, f);
      var D = 12 * (S.year() - f.year()) + (S.month() - f.month()), N = f.clone().add(D, c), m = S - N < 0, z = f.clone().add(D + (m ? -1 : 1), c);
      return +(-(D + (S - N) / (m ? N - z : z - N)) || 0);
    }, a: function(w) {
      return w < 0 ? Math.ceil(w) || 0 : Math.floor(w);
    }, p: function(w) {
      return { M: c, y: g, w: L, d: r, D: I, h: M, m: a, s: o, ms: s, Q: j }[w] || String(w || "").toLowerCase().replace(/s$/, "");
    }, u: function(w) {
      return w === void 0;
    } }, O = "en", v = {};
    v[O] = p;
    var V = function(w) {
      return w instanceof Q;
    }, Z = function w(f, S, D) {
      var N;
      if (!f)
        return O;
      if (typeof f == "string") {
        var m = f.toLowerCase();
        v[m] && (N = m), S && (v[m] = S, N = m);
        var z = f.split("-");
        if (!N && z.length > 1)
          return w(z[0]);
      } else {
        var P = f.name;
        v[P] = f, N = P;
      }
      return !D && N && (O = N), N || !D && O;
    }, $ = function(w, f) {
      if (V(w))
        return w.clone();
      var S = typeof f == "object" ? f : {};
      return S.date = w, S.args = arguments, new Q(S);
    }, h = E;
    h.l = Z, h.i = V, h.w = function(w, f) {
      return $(w, { locale: f.$L, utc: f.$u, x: f.$x, $offset: f.$offset });
    };
    var Q = function() {
      function w(S) {
        this.$L = Z(S.locale, null, !0), this.parse(S);
      }
      var f = w.prototype;
      return f.parse = function(S) {
        this.$d = function(D) {
          var N = D.date, m = D.utc;
          if (N === null)
            return new Date(NaN);
          if (h.u(N))
            return new Date();
          if (N instanceof Date)
            return new Date(N);
          if (typeof N == "string" && !/Z$/i.test(N)) {
            var z = N.match(C);
            if (z) {
              var P = z[2] - 1 || 0, H = (z[7] || "0").substring(0, 3);
              return m ? new Date(Date.UTC(z[1], P, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, H)) : new Date(z[1], P, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, H);
            }
          }
          return new Date(N);
        }(S), this.$x = S.x || {}, this.init();
      }, f.init = function() {
        var S = this.$d;
        this.$y = S.getFullYear(), this.$M = S.getMonth(), this.$D = S.getDate(), this.$W = S.getDay(), this.$H = S.getHours(), this.$m = S.getMinutes(), this.$s = S.getSeconds(), this.$ms = S.getMilliseconds();
      }, f.$utils = function() {
        return h;
      }, f.isValid = function() {
        return this.$d.toString() !== y;
      }, f.isSame = function(S, D) {
        var N = $(S);
        return this.startOf(D) <= N && N <= this.endOf(D);
      }, f.isAfter = function(S, D) {
        return $(S) < this.startOf(D);
      }, f.isBefore = function(S, D) {
        return this.endOf(D) < $(S);
      }, f.$g = function(S, D, N) {
        return h.u(S) ? this[D] : this.set(N, S);
      }, f.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, f.valueOf = function() {
        return this.$d.getTime();
      }, f.startOf = function(S, D) {
        var N = this, m = !!h.u(D) || D, z = h.p(S), P = function(It, Nt) {
          var Ut = h.w(N.$u ? Date.UTC(N.$y, Nt, It) : new Date(N.$y, Nt, It), N);
          return m ? Ut : Ut.endOf(r);
        }, H = function(It, Nt) {
          return h.w(N.toDate()[It].apply(N.toDate("s"), (m ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Nt)), N);
        }, tt = this.$W, rt = this.$M, Ct = this.$D, G = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case g:
            return m ? P(1, 0) : P(31, 11);
          case c:
            return m ? P(1, rt) : P(0, rt + 1);
          case L:
            var st = this.$locale().weekStart || 0, ot = (tt < st ? tt + 7 : tt) - st;
            return P(m ? Ct - ot : Ct + (6 - ot), rt);
          case r:
          case I:
            return H(G + "Hours", 0);
          case M:
            return H(G + "Minutes", 1);
          case a:
            return H(G + "Seconds", 2);
          case o:
            return H(G + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, f.endOf = function(S) {
        return this.startOf(S, !1);
      }, f.$set = function(S, D) {
        var N, m = h.p(S), z = "set" + (this.$u ? "UTC" : ""), P = (N = {}, N[r] = z + "Date", N[I] = z + "Date", N[c] = z + "Month", N[g] = z + "FullYear", N[M] = z + "Hours", N[a] = z + "Minutes", N[o] = z + "Seconds", N[s] = z + "Milliseconds", N)[m], H = m === r ? this.$D + (D - this.$W) : D;
        if (m === c || m === g) {
          var tt = this.clone().set(I, 1);
          tt.$d[P](H), tt.init(), this.$d = tt.set(I, Math.min(this.$D, tt.daysInMonth())).$d;
        } else
          P && this.$d[P](H);
        return this.init(), this;
      }, f.set = function(S, D) {
        return this.clone().$set(S, D);
      }, f.get = function(S) {
        return this[h.p(S)]();
      }, f.add = function(S, D) {
        var N, m = this;
        S = Number(S);
        var z = h.p(D), P = function(rt) {
          var Ct = $(m);
          return h.w(Ct.date(Ct.date() + Math.round(rt * S)), m);
        };
        if (z === c)
          return this.set(c, this.$M + S);
        if (z === g)
          return this.set(g, this.$y + S);
        if (z === r)
          return P(1);
        if (z === L)
          return P(7);
        var H = (N = {}, N[a] = n, N[M] = u, N[o] = i, N)[z] || 1, tt = this.$d.getTime() + S * H;
        return h.w(tt, this);
      }, f.subtract = function(S, D) {
        return this.add(-1 * S, D);
      }, f.format = function(S) {
        var D = this, N = this.$locale();
        if (!this.isValid())
          return N.invalidDate || y;
        var m = S || "YYYY-MM-DDTHH:mm:ssZ", z = h.z(this), P = this.$H, H = this.$m, tt = this.$M, rt = N.weekdays, Ct = N.months, G = function(Nt, Ut, Fi, Ii) {
          return Nt && (Nt[Ut] || Nt(D, m)) || Fi[Ut].slice(0, Ii);
        }, st = function(Nt) {
          return h.s(P % 12 || 12, Nt, "0");
        }, ot = N.meridiem || function(Nt, Ut, Fi) {
          var Ii = Nt < 12 ? "AM" : "PM";
          return Fi ? Ii.toLowerCase() : Ii;
        }, It = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: tt + 1, MM: h.s(tt + 1, 2, "0"), MMM: G(N.monthsShort, tt, Ct, 3), MMMM: G(Ct, tt), D: this.$D, DD: h.s(this.$D, 2, "0"), d: String(this.$W), dd: G(N.weekdaysMin, this.$W, rt, 2), ddd: G(N.weekdaysShort, this.$W, rt, 3), dddd: rt[this.$W], H: String(P), HH: h.s(P, 2, "0"), h: st(1), hh: st(2), a: ot(P, H, !0), A: ot(P, H, !1), m: String(H), mm: h.s(H, 2, "0"), s: String(this.$s), ss: h.s(this.$s, 2, "0"), SSS: h.s(this.$ms, 3, "0"), Z: z };
        return m.replace(x, function(Nt, Ut) {
          return Ut || It[Nt] || z.replace(":", "");
        });
      }, f.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, f.diff = function(S, D, N) {
        var m, z = h.p(D), P = $(S), H = (P.utcOffset() - this.utcOffset()) * n, tt = this - P, rt = h.m(this, P);
        return rt = (m = {}, m[g] = rt / 12, m[c] = rt, m[j] = rt / 3, m[L] = (tt - H) / 6048e5, m[r] = (tt - H) / 864e5, m[M] = tt / u, m[a] = tt / n, m[o] = tt / i, m)[z] || tt, N ? rt : h.a(rt);
      }, f.daysInMonth = function() {
        return this.endOf(c).$D;
      }, f.$locale = function() {
        return v[this.$L];
      }, f.locale = function(S, D) {
        if (!S)
          return this.$L;
        var N = this.clone(), m = Z(S, D, !0);
        return m && (N.$L = m), N;
      }, f.clone = function() {
        return h.w(this.$d, this);
      }, f.toDate = function() {
        return new Date(this.valueOf());
      }, f.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, f.toISOString = function() {
        return this.$d.toISOString();
      }, f.toString = function() {
        return this.$d.toUTCString();
      }, w;
    }(), W = Q.prototype;
    return $.prototype = W, [["$ms", s], ["$s", o], ["$m", a], ["$H", M], ["$W", r], ["$M", c], ["$y", g], ["$D", I]].forEach(function(w) {
      W[w[1]] = function(f) {
        return this.$g(f, w[0], w[1]);
      };
    }), $.extend = function(w, f) {
      return w.$i || (w(f, Q, $), w.$i = !0), $;
    }, $.locale = Z, $.isDayjs = V, $.unix = function(w) {
      return $(1e3 * w);
    }, $.en = v[O], $.Ls = v, $.p = {}, $;
  });
})(Pn);
const At = Pn.exports;
var ia = { exports: {} };
(function(e, t) {
  (function(i, n) {
    e.exports = n(Pn.exports);
  })(Wn, function(i) {
    function n(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var u = n(i), s = { name: "it", weekdays: "domenica_luned\xEC_marted\xEC_mercoled\xEC_gioved\xEC_venerd\xEC_sabato".split("_"), weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "qualche secondo", m: "un minuto", mm: "%d minuti", h: "un' ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" }, ordinal: function(o) {
      return o + "\xBA";
    } };
    return u.default.locale(s, null, !0), s;
  });
})(ia);
At.locale("it");
function Is() {
  return {
    capitalize: (c) => c == null ? "" : c.toUpperCase(),
    currency: (c) => isNaN(c) ? "-" : "\u20AC" + c.toFixed(2),
    fileIcon: (c) => {
      let j = "it-file";
      switch (c.split(".").pop()) {
        case "pdf":
          j = "it-file-pdf";
          break;
        case "xml":
          j = "it-file-xml";
          break;
        case "csv":
          j = "it-file-csv";
          break;
        case "xls":
        case "xlsx":
          j = "it-file-sheet";
          break;
        case "ppt":
        case "pptx":
          j = "it-file-slides";
          break;
        case "zip":
        case "rar":
        case "7z":
          j = " it-file-compressed";
          break;
      }
      return j;
    },
    toDateTimeString: (c) => c != null ? At(c).format("DD/MM/YYYY HH:mm") : "",
    toDateString: (c) => c != null ? At(c).format("DD/MM/YYYY") : "",
    toDateTimeLongString: (c) => c != null ? At(c).locale("it").format("dddd, DD MMMM YYYY") : "",
    toTimeHMString: (c) => c != null ? At(c).format("HH:mm") : "",
    toDDMMMMString: (c) => c != null ? At(c).format("DD MMMM") : "",
    toStringDecimalNumber: (c) => c != null ? c.toFixed(2).replace(".", ",") : "",
    toDateTimeStringWithOptions: (c, j = !0) => c != null ? j ? At.utc(c).local().format("DD/MM/YYYY HH:mm") : At(c).format("DD/MM/YYYY HH:mm") : "",
    toTimeStringWithOptions: (c, j = !1, g = !0) => {
      if (c != null) {
        const I = g ? At.utc(c).local() : At(c).utc();
        return j ? I.format("HH:mm:ss") : I.format("HH:mm");
      }
      return "";
    }
  };
}
const na = { class: "c-line lightgrey-bg-c1 k-page-header-full" }, ua = { class: "d-flex align-items-center exit-menu" }, sa = { class: "top-text" }, oa = { class: "row" }, aa = { class: "title-text" }, Ma = { class: "title-text-underline" }, ra = { class: "row focus-text m-0" }, la = /* @__PURE__ */ F({
  __name: "PageHeaderFull",
  props: {
    title: null,
    titleUnderline: null
  },
  setup(e) {
    const { toDateTimeLongString: t, toTimeHMString: i } = Is(), n = k(new Date()), u = k(0);
    return St(() => {
      u.value = setInterval(() => {
        n.value = new Date();
      }, 59e3);
    }), ki(() => clearInterval(u.value)), (s, o) => (d(), A("div", na, [
      l("div", ua, [
        it(s.$slots, "primary-actions")
      ]),
      l("div", sa, Y(b(t)(n.value)) + " - " + Y(b(i)(n.value)), 1),
      l("div", oa, [
        l("div", null, [
          l("h3", aa, [
            nt(Y(e.title) + " ", 1),
            l("span", Ma, Y(e.titleUnderline), 1)
          ])
        ])
      ]),
      l("div", ra, [
        it(s.$slots, "secondary-actions")
      ])
    ]));
  }
});
var Ns = { exports: {} };
(function(e, t) {
  (function(i, n) {
    e.exports = n();
  })(Wn, function() {
    var i = "minute", n = /[+-]\d\d(?::?\d\d)?/g, u = /([+-]|\d\d)/g;
    return function(s, o, a) {
      var M = o.prototype;
      a.utc = function(y) {
        var C = { date: y, utc: !0, args: arguments };
        return new o(C);
      }, M.utc = function(y) {
        var C = a(this.toDate(), { locale: this.$L, utc: !0 });
        return y ? C.add(this.utcOffset(), i) : C;
      }, M.local = function() {
        return a(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var r = M.parse;
      M.parse = function(y) {
        y.utc && (this.$u = !0), this.$utils().u(y.$offset) || (this.$offset = y.$offset), r.call(this, y);
      };
      var L = M.init;
      M.init = function() {
        if (this.$u) {
          var y = this.$d;
          this.$y = y.getUTCFullYear(), this.$M = y.getUTCMonth(), this.$D = y.getUTCDate(), this.$W = y.getUTCDay(), this.$H = y.getUTCHours(), this.$m = y.getUTCMinutes(), this.$s = y.getUTCSeconds(), this.$ms = y.getUTCMilliseconds();
        } else
          L.call(this);
      };
      var c = M.utcOffset;
      M.utcOffset = function(y, C) {
        var x = this.$utils().u;
        if (x(y))
          return this.$u ? 0 : x(this.$offset) ? c.call(this) : this.$offset;
        if (typeof y == "string" && (y = function(O) {
          O === void 0 && (O = "");
          var v = O.match(n);
          if (!v)
            return null;
          var V = ("" + v[0]).match(u) || ["-", 0, 0], Z = V[0], $ = 60 * +V[1] + +V[2];
          return $ === 0 ? 0 : Z === "+" ? $ : -$;
        }(y), y === null))
          return this;
        var p = Math.abs(y) <= 16 ? 60 * y : y, T = this;
        if (C)
          return T.$offset = p, T.$u = y === 0, T;
        if (y !== 0) {
          var E = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (T = this.local().add(p + E, i)).$offset = p, T.$x.$localOffset = E;
        } else
          T = this.utc();
        return T;
      };
      var j = M.format;
      M.format = function(y) {
        var C = y || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return j.call(this, C);
      }, M.valueOf = function() {
        var y = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * y;
      }, M.isUTC = function() {
        return !!this.$u;
      }, M.toISOString = function() {
        return this.toDate().toISOString();
      }, M.toString = function() {
        return this.toDate().toUTCString();
      };
      var g = M.toDate;
      M.toDate = function(y) {
        return y === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : g.call(this);
      };
      var I = M.diff;
      M.diff = function(y, C, x) {
        if (y && this.$u === y.$u)
          return I.call(this, y, C, x);
        var p = this.local(), T = a(y).local();
        return I.call(p, T, C, x);
      };
    };
  });
})(Ns);
const ca = Ns.exports;
var Ti = /* @__PURE__ */ ((e) => (e.info = "info", e.success = "success", e.warning = "warning", e.danger = "danger", e))(Ti || {}), Wt = /* @__PURE__ */ ((e) => (e.oneOne = "oneOne", e.twoOne = "twoOne", e.oneTwo = "oneTwo", e))(Wt || {}), Ge = /* @__PURE__ */ ((e) => (e[e.text = 0] = "text", e[e.email = 1] = "email", e))(Ge || {}), Ze = /* @__PURE__ */ ((e) => (e.xl = "xl", e.lg = "lg", e.sm = "sm", e))(Ze || {});
const La = /* @__PURE__ */ F({
  __name: "K2ColContainer",
  props: {
    rowClass: { default: "" },
    col1Class: { default: "" },
    col2Class: { default: "" },
    ratio: { default: Wt.oneOne }
  },
  setup(e) {
    const t = e, i = et(
      () => {
        let u = "col-lg-6";
        switch (t.ratio) {
          case Wt.oneOne:
            u = "col-lg-6";
            break;
          case Wt.twoOne:
            u = "col-lg-9";
            break;
          case Wt.oneTwo:
            u = "col-lg-3";
            break;
        }
        return u;
      }
    ), n = et(
      () => {
        let u = "col-lg-6";
        switch (t.ratio) {
          case Wt.oneOne:
            u = "col-lg-6";
            break;
          case Wt.twoOne:
            u = "col-lg-3";
            break;
          case Wt.oneTwo:
            u = "col-lg-9";
            break;
        }
        return u;
      }
    );
    return (u, s) => (d(), A("div", {
      class: J(["row", e.rowClass])
    }, [
      l("div", {
        class: J(["col-12 col-md-12", [b(i), e.col1Class]])
      }, [
        it(u.$slots, "col1")
      ], 2),
      l("div", {
        class: J(["col-12 col-md-12", [b(n), e.col2Class]])
      }, [
        it(u.$slots, "col2")
      ], 2)
    ], 2));
  }
}), ja = /* @__PURE__ */ F({
  __name: "K3ColContainer",
  props: {
    rowClass: { default: "" },
    col1Class: { default: "" },
    col2Class: { default: "" },
    col3Class: { default: "" }
  },
  setup(e) {
    return (t, i) => (d(), A("div", {
      class: J(["row", e.rowClass])
    }, [
      l("div", {
        class: J(["col-12 col-md-12 col-lg-4", e.col1Class])
      }, [
        it(t.$slots, "col1")
      ], 2),
      l("div", {
        class: J(["col-12 col-md-12 col-lg-4", e.col2Class])
      }, [
        it(t.$slots, "col2")
      ], 2),
      l("div", {
        class: J(["col-12 col-md-12 col-lg-4", e.col3Class])
      }, [
        it(t.$slots, "col3")
      ], 2)
    ], 2));
  }
}), ga = /* @__PURE__ */ F({
  __name: "KBackButton",
  setup(e) {
    const t = k(null);
    Kt();
    const i = () => {
      history.back();
    };
    return (n, u) => {
      const s = B("KIcon");
      return d(), A("a", {
        href: "#",
        ref_key: "kBackButton",
        ref: t,
        onClick: i,
        class: "go-back",
        "data-bs-toggle": "historyback"
      }, [
        U(s, {
          class: "icon-sm icon-primary me-2",
          icon: "it-arrow-left"
        }),
        nt(" Torna indietro")
      ], 512);
    };
  }
}), Ia = { class: "card-space" }, Na = {
  key: 0,
  class: "flag-icon",
  style: { "margin-left": "24px" }
}, ya = {
  key: 1,
  class: "etichetta"
}, da = { class: "card-body pt-0" }, Sa = { class: "fw-bold m-0" }, Da = {
  key: 3,
  class: "it-card-footer mt-4"
}, Aa = ["title"], fa = { class: "visually-hidden" }, Ta = ["title"], Ea = { class: "text text-uppercase" }, xa = { class: "visually-hidden" }, Ca = /* @__PURE__ */ F({
  __name: "KCard",
  props: {
    class: { default: "" },
    style: { default: "" },
    title: { default: "" },
    titleClass: { default: "" },
    titleStyle: { default: "" },
    text: { default: "" },
    textClass: { default: "" },
    textStyle: { default: "" },
    topTitle: { default: "" },
    topTitleIcon: { default: "" },
    labelDetailButton: { default: "" },
    showDetailButton: { type: Boolean, default: !1 },
    labelCmdButton: { default: "" },
    showCmdButton: { type: Boolean, default: !1 },
    showFlagIcon: { type: Boolean, default: !1 },
    tagIcon: { default: "" },
    tagTitle: { default: "" }
  },
  emits: ["cmd-button-click", "detail-button-click"],
  setup(e, { emit: t }) {
    const i = e, n = () => {
      t("detail-button-click");
    }, u = () => {
      t("cmd-button-click");
    }, s = et(() => !!(i.tagTitle || i.tagIcon)), o = et(() => !!(i.topTitle || i.topTitleIcon)), a = et(() => !!(i.showCmdButton || i.showDetailButton)), M = et(() => i.topTitleIcon ? "categoryicon-top" : "category-top");
    return (r, L) => {
      const c = B("KIcon");
      return d(), A("div", Ia, [
        l("div", {
          class: J(["card card-bg rounded shadow", i.class]),
          style: Ft(e.style)
        }, [
          e.showFlagIcon ? (d(), A("div", Na)) : _("", !0),
          b(s) ? (d(), A("div", ya, [
            U(c, { icon: e.tagIcon }, null, 8, ["icon"]),
            l("span", null, Y(e.tagTitle), 1)
          ])) : _("", !0),
          l("div", da, [
            b(o) ? (d(), A("div", {
              key: 0,
              class: J(b(M))
            }, [
              U(c, {
                class: "icon-primary icon-xs",
                icon: e.topTitleIcon
              }, null, 8, ["icon"]),
              l("h6", Sa, Y(i.topTitle), 1)
            ], 2)) : _("", !0),
            i.title ? (d(), A("span", {
              key: 1,
              class: J(["card-title text-truncate text-truncate-multiline", e.titleClass]),
              style: Ft(e.titleStyle)
            }, Y(i.title), 7)) : _("", !0),
            i.text ? (d(), A("p", {
              key: 2,
              class: J(["text-truncate text-truncate-multiline pt-0 mb-0", e.textClass]),
              style: Ft(e.textStyle)
            }, Y(i.text), 7)) : _("", !0),
            it(r.$slots, "custom-content"),
            b(a) ? (d(), A("div", Da, [
              e.showCmdButton ? (d(), A("a", {
                key: 0,
                role: "button",
                class: "btn btn-primary btn-sm text-uppercase",
                title: e.labelCmdButton,
                onClick: u
              }, [
                nt(Y(e.labelCmdButton) + " ", 1),
                l("span", fa, Y(e.labelCmdButton), 1)
              ], 8, Aa)) : _("", !0),
              e.showDetailButton ? (d(), A("a", {
                key: 1,
                class: "read-more",
                role: "button",
                title: e.labelDetailButton,
                onClick: n
              }, [
                l("span", Ea, [
                  nt(Y(e.labelDetailButton), 1),
                  l("span", xa, Y(i.title), 1)
                ]),
                U(c, {
                  class: "icon-primary icon-xs",
                  icon: "it-arrow-right"
                })
              ], 8, Ta)) : _("", !0)
            ])) : _("", !0)
          ])
        ], 6)
      ]);
    };
  }
});
/*!
 * Splide.js
 * Version  : 3.6.12
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
const dt = "splide", $n = `data-${dt}`, de = 1, pa = 2, Ei = 3, xi = 4, Ci = 5, ha = {
  CREATED: de,
  MOUNTED: pa,
  IDLE: Ei,
  MOVING: xi,
  DESTROYED: Ci
}, Vn = 10, ma = 20;
function ve(e) {
  e.length = 0;
}
function qe(e) {
  return !Zn(e) && typeof e == "object";
}
function ys(e) {
  return Array.isArray(e);
}
function wa(e) {
  return typeof e == "function";
}
function Rt(e) {
  return typeof e == "string";
}
function Gn(e) {
  return typeof e > "u";
}
function Zn(e) {
  return e === null;
}
function Bn(e) {
  return e instanceof HTMLElement;
}
function ri(e) {
  return ys(e) ? e : [e];
}
function qt(e, t) {
  ri(e).forEach(t);
}
function Wi(e, t) {
  return e.indexOf(t) > -1;
}
function Je(e, t) {
  return e.push(...ri(t)), e;
}
const za = Array.prototype;
function _e(e, t, i) {
  return za.slice.call(e, t, i);
}
function Oa(e, t) {
  return _e(e).filter(t)[0];
}
function Ae(e, t, i) {
  e && qt(t, (n) => {
    n && e.classList[i ? "add" : "remove"](n);
  });
}
function Xt(e, t) {
  Ae(e, Rt(t) ? t.split(" ") : t, !0);
}
function Pi(e, t) {
  qt(t, e.appendChild.bind(e));
}
function Jn(e, t) {
  qt(e, (i) => {
    const n = t.parentNode;
    n && n.insertBefore(i, t);
  });
}
function Fn(e, t) {
  return Bn(e) && (e.msMatchesSelector || e.matches).call(e, t);
}
function ds(e, t) {
  return e ? _e(e.children).filter((i) => Fn(i, t)) : [];
}
function Yt(e, t) {
  return t ? ds(e, t)[0] : e.firstElementChild;
}
function le(e, t, i) {
  if (e) {
    let n = Object.keys(e);
    n = i ? n.reverse() : n;
    for (let u = 0; u < n.length; u++) {
      const s = n[u];
      if (s !== "__proto__" && t(e[s], s) === !1)
        break;
    }
  }
  return e;
}
function An(e) {
  return _e(arguments, 1).forEach((t) => {
    le(t, (i, n) => {
      e[n] = t[n];
    });
  }), e;
}
function ae(e, t) {
  return le(t, (i, n) => {
    ys(i) ? e[n] = i.slice() : qe(i) ? e[n] = ae(qe(e[n]) ? e[n] : {}, i) : e[n] = i;
  }), e;
}
function zt(e, t) {
  e && qt(t, (i) => {
    e.removeAttribute(i);
  });
}
function ut(e, t, i) {
  qe(t) ? le(t, (n, u) => {
    ut(e, u, n);
  }) : Zn(i) ? zt(e, t) : e.setAttribute(t, String(i));
}
function Te(e, t, i) {
  const n = document.createElement(e);
  return t && (Rt(t) ? Xt(n, t) : ut(n, t)), i && Pi(i, n), n;
}
function Et(e, t, i) {
  if (Gn(i))
    return getComputedStyle(e)[t];
  if (!Zn(i)) {
    const { style: n } = e;
    i = `${i}`, n[t] !== i && (n[t] = i);
  }
}
function pi(e, t) {
  Et(e, "display", t);
}
function ba(e) {
  e.setActive && e.setActive() || e.focus({ preventScroll: !0 });
}
function ti(e, t) {
  return e.getAttribute(t);
}
function yu(e, t) {
  return e && e.classList.contains(t);
}
function ft(e) {
  return e.getBoundingClientRect();
}
function ke(e) {
  qt(e, (t) => {
    t && t.parentNode && t.parentNode.removeChild(t);
  });
}
function Ya(e, t) {
  if (Rt(t)) {
    const i = Te("div", { style: `width: ${t}; position: absolute;` }, e);
    t = ft(i).width, ke(i);
  }
  return t;
}
function Ss(e) {
  return Yt(new DOMParser().parseFromString(e, "text/html").body);
}
function $t(e, t) {
  e.preventDefault(), t && (e.stopPropagation(), e.stopImmediatePropagation());
}
function ue(e, t) {
  return e && e.querySelector(t);
}
function Rn(e, t) {
  return _e(e.querySelectorAll(t));
}
function ei(e, t) {
  Ae(e, t, !1);
}
function Pt(e) {
  return Rt(e) ? e : e ? `${e}px` : "";
}
function ii(e, t = "") {
  if (!e)
    throw new Error(`[${dt}] ${t}`);
}
function fn(e) {
  setTimeout(e);
}
const Tn = () => {
};
function du(e) {
  return requestAnimationFrame(e);
}
const { min: ni, max: ui, floor: En, ceil: si, abs: xt } = Math;
function va(e, t, i) {
  return xt(e - t) < i;
}
function Fe(e, t, i, n) {
  const u = ni(t, i), s = ui(t, i);
  return n ? u < e && e < s : u <= e && e <= s;
}
function Be(e, t, i) {
  const n = ni(t, i), u = ui(t, i);
  return ni(ui(n, e), u);
}
function Su(e) {
  return +(e > 0) - +(e < 0);
}
function Ds(e, t) {
  return qt(t, (i) => {
    e = e.replace("%s", `${i}`);
  }), e;
}
function Xn(e) {
  return e < 10 ? `0${e}` : `${e}`;
}
const Du = {};
function _a(e) {
  return `${e}${Xn(Du[e] = (Du[e] || 0) + 1)}`;
}
function ka() {
  let e = {};
  function t(a, M, r, L = Vn) {
    o(a, (c, j) => {
      e[c] = e[c] || [], Je(e[c], {
        _event: c,
        _callback: M,
        _namespace: j,
        _priority: L,
        _key: r
      }).sort((g, I) => g._priority - I._priority);
    });
  }
  function i(a, M) {
    o(a, (r, L) => {
      const c = e[r];
      e[r] = c && c.filter((j) => j._key ? j._key !== M : M || j._namespace !== L);
    });
  }
  function n(a) {
    le(e, (M, r) => {
      i(r, a);
    });
  }
  function u(a) {
    (e[a] || []).forEach((M) => {
      M._callback.apply(M, _e(arguments, 1));
    });
  }
  function s() {
    e = {};
  }
  function o(a, M) {
    ri(a).join(" ").split(" ").forEach((r) => {
      const L = r.split(".");
      M(L[0], L[1]);
    });
  }
  return {
    on: t,
    off: i,
    offBy: n,
    emit: u,
    destroy: s
  };
}
const kt = "mounted", Au = "ready", Ht = "move", oi = "moved", As = "shifted", fs = "click", Ua = "active", Qa = "inactive", Wa = "visible", Pa = "hidden", Ts = "slide:keydown", at = "refresh", Dt = "updated", pe = "resize", Es = "resized", xs = "repositioned", $a = "drag", Va = "dragging", Ga = "dragged", Cs = "scroll", li = "scrolled", ps = "destroy", Za = "arrows:mounted", Ba = "arrows:updated", Ja = "pagination:mounted", Fa = "pagination:updated", hs = "navigation:mounted", Ra = "autoplay:play", Xa = "autoplay:playing", Ha = "autoplay:pause", ms = "lazyload:loaded";
function Mt(e) {
  const { event: t } = e, i = {};
  let n = [];
  function u(L, c, j) {
    t.on(L, c, i, j);
  }
  function s(L) {
    t.off(L, i);
  }
  function o(L, c, j, g) {
    M(L, c, (I, y) => {
      n.push([I, y, j, g]), I.addEventListener(y, j, g);
    });
  }
  function a(L, c, j) {
    M(L, c, (g, I) => {
      n = n.filter((y) => y[0] === g && y[1] === I && (!j || y[2] === j) ? (g.removeEventListener(I, y[2], y[3]), !1) : !0);
    });
  }
  function M(L, c, j) {
    qt(L, (g) => {
      g && c.split(" ").forEach(j.bind(null, g));
    });
  }
  function r() {
    n = n.filter((L) => a(L[0], L[1])), t.offBy(i);
  }
  return t.on(ps, r, i), {
    on: u,
    off: s,
    emit: t.emit,
    bind: o,
    unbind: a,
    destroy: r
  };
}
function Hn(e, t, i, n) {
  const { now: u } = Date;
  let s, o = 0, a, M = !0, r = 0;
  function L() {
    if (!M) {
      const x = u() - s;
      if (x >= e ? (o = 1, s = u()) : o = x / e, i && i(o), o === 1 && (t(), n && ++r >= n))
        return j();
      du(L);
    }
  }
  function c(x) {
    !x && I(), s = u() - (x ? o * e : 0), M = !1, du(L);
  }
  function j() {
    M = !0;
  }
  function g() {
    s = u(), o = 0, i && i(o);
  }
  function I() {
    cancelAnimationFrame(a), o = 0, a = 0, M = !0;
  }
  function y(x) {
    e = x;
  }
  function C() {
    return M;
  }
  return {
    start: c,
    rewind: g,
    pause: j,
    cancel: I,
    set: y,
    isPaused: C
  };
}
function Ka(e) {
  let t = e;
  function i(u) {
    t = u;
  }
  function n(u) {
    return Wi(ri(u), t);
  }
  return { set: i, is: n };
}
function ws(e, t) {
  let i;
  function n() {
    i || (i = Hn(t || 0, () => {
      e.apply(this, arguments), i = null;
    }, null, 1), i.start());
  }
  return n;
}
function qa(e, t, i) {
  const n = ws(L);
  let u, s, o;
  function a() {
    try {
      ae(i, JSON.parse(ti(e.root, $n)));
    } catch (g) {
      ii(!1, g.message);
    }
    u = ae({}, i);
    const { breakpoints: j } = i;
    if (j) {
      const g = i.mediaQuery === "min";
      s = Object.keys(j).sort((I, y) => g ? +y - +I : +I - +y).map((I) => [
        I,
        matchMedia(`(${g ? "min" : "max"}-width:${I}px)`)
      ]), L();
    }
  }
  function M() {
    s && addEventListener("resize", n);
  }
  function r(j) {
    j && removeEventListener("resize", n);
  }
  function L() {
    const j = Oa(s, (g) => g[1].matches) || [];
    j[0] !== o && c(o = j[0]);
  }
  function c(j) {
    const g = i.breakpoints[j] || u;
    g.destroy ? (e.options = u, e.destroy(g.destroy === "completely")) : (e.state.is(Ci) && (r(!0), e.mount()), e.options = g);
  }
  return {
    setup: a,
    mount: M,
    destroy: r
  };
}
const fu = "rtl", Kn = "ttb", tM = {
  marginRight: ["marginBottom", "marginLeft"],
  autoWidth: ["autoHeight"],
  fixedWidth: ["fixedHeight"],
  paddingLeft: ["paddingTop", "paddingRight"],
  paddingRight: ["paddingBottom", "paddingLeft"],
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: ["ArrowUp", "ArrowRight"],
  ArrowRight: ["ArrowDown", "ArrowLeft"]
};
function eM(e, t, i) {
  function n(s, o) {
    const { direction: a } = i, M = a === fu && !o ? 1 : a === Kn ? 0 : -1;
    return tM[s][M] || s;
  }
  function u(s) {
    return s * (i.direction === fu ? 1 : -1);
  }
  return {
    resolve: n,
    orient: u
  };
}
const Ni = dt, iM = `${dt}__slider`, nM = `${dt}__track`, uM = `${dt}__list`, $i = `${dt}__slide`, zs = `${$i}--clone`, sM = `${$i}__container`, Os = `${dt}__arrows`, qn = `${dt}__arrow`, bs = `${qn}--prev`, Ys = `${qn}--next`, vs = `${dt}__pagination`, oM = `${vs}__page`, _s = `${dt}__progress`, aM = `${_s}__bar`, MM = `${dt}__autoplay`, rM = `${dt}__play`, lM = `${dt}__pause`, cM = `${dt}__spinner`, LM = "is-initialized", he = "is-active", ks = "is-prev", Us = "is-next", xn = "is-visible", Cn = "is-loading", jM = [he, xn, ks, Us, Cn], gM = {
  slide: $i,
  clone: zs,
  arrows: Os,
  arrow: qn,
  prev: bs,
  next: Ys,
  pagination: vs,
  page: oM,
  spinner: cM
};
function IM(e, t, i) {
  const { on: n } = Mt(e), { root: u } = e, s = {}, o = [];
  let a, M, r, L;
  function c() {
    C(), x(), Xt(u, a = T());
  }
  function j() {
    n(at, I, Vn - 2), n(Dt, y);
  }
  function g() {
    [u, r, L].forEach((E) => {
      zt(E, "style");
    }), ve(o), ei(u, a);
  }
  function I() {
    g(), c();
  }
  function y() {
    ei(u, a), Xt(u, a = T());
  }
  function C() {
    M = Yt(u, `.${iM}`), r = ue(u, `.${nM}`), L = Yt(r, `.${uM}`), ii(r && L, "A track/list element is missing."), Je(o, ds(L, `.${$i}:not(.${zs})`));
    const E = p(`.${MM}`), O = p(`.${Os}`);
    An(s, {
      root: u,
      slider: M,
      track: r,
      list: L,
      slides: o,
      arrows: O,
      autoplay: E,
      prev: ue(O, `.${bs}`),
      next: ue(O, `.${Ys}`),
      bar: ue(p(`.${_s}`), `.${aM}`),
      play: ue(E, `.${rM}`),
      pause: ue(E, `.${lM}`)
    });
  }
  function x() {
    const E = u.id || _a(dt);
    u.id = E, r.id = r.id || `${E}-track`, L.id = L.id || `${E}-list`;
  }
  function p(E) {
    return Yt(u, E) || Yt(M, E);
  }
  function T() {
    return [
      `${Ni}--${i.type}`,
      `${Ni}--${i.direction}`,
      i.drag && `${Ni}--draggable`,
      i.isNavigation && `${Ni}--nav`,
      he
    ];
  }
  return An(s, {
    setup: c,
    mount: j,
    destroy: g
  });
}
const Vi = "role", me = "aria-controls", hi = "aria-current", we = "aria-label", Qs = "aria-hidden", ai = "tabindex", NM = "disabled", Ws = "aria-orientation", mi = [
  Vi,
  me,
  hi,
  we,
  Qs,
  Ws,
  ai,
  NM
], ci = "slide", Ue = "loop", Gi = "fade";
function yM(e, t, i, n) {
  const { on: u, emit: s, bind: o, destroy: a } = Mt(e), { Components: M, root: r, options: L } = e, { isNavigation: c, updateOnMove: j } = L, { resolve: g } = M.Direction, I = ti(n, "style"), y = i > -1, C = Yt(n, `.${sM}`), x = L.focusableNodes && Rn(n, L.focusableNodes);
  let p;
  function T() {
    y || (n.id = `${r.id}-slide${Xn(t + 1)}`), o(n, "click keydown", (S) => {
      s(S.type === "click" ? fs : Ts, f, S);
    }), u([at, xs, As, oi, li], V), u(hs, O), j && u(Ht, v);
  }
  function E() {
    p = !0, a(), ei(n, jM), zt(n, mi), ut(n, "style", I);
  }
  function O() {
    const S = y ? i : t, D = Ds(L.i18n.slideX, S + 1), N = e.splides.map((m) => m.splide.root.id).join(" ");
    ut(n, we, D), ut(n, me, N), ut(n, Vi, "menuitem"), Z(Q());
  }
  function v() {
    p || V();
  }
  function V() {
    if (!p) {
      const { index: S } = e;
      Z(Q()), $(W()), Ae(n, ks, t === S - 1), Ae(n, Us, t === S + 1);
    }
  }
  function Z(S) {
    S !== yu(n, he) && (Ae(n, he, S), c && ut(n, hi, S || null), s(S ? Ua : Qa, f));
  }
  function $(S) {
    const D = !S && (!Q() || y);
    ut(n, Qs, D || null), ut(n, ai, !D && L.slideFocus ? 0 : null), x && x.forEach((N) => {
      ut(N, ai, D ? -1 : null);
    }), S !== yu(n, xn) && (Ae(n, xn, S), s(S ? Wa : Pa, f));
  }
  function h(S, D, N) {
    Et(N && C || n, S, D);
  }
  function Q() {
    const { index: S } = e;
    return S === t || L.cloneStatus && S === i;
  }
  function W() {
    if (e.is(Gi))
      return Q();
    const S = ft(M.Elements.track), D = ft(n), N = g("left"), m = g("right");
    return En(S[N]) <= si(D[N]) && En(D[m]) <= si(S[m]);
  }
  function w(S, D) {
    let N = xt(S - t);
    return !y && (L.rewind || e.is(Ue)) && (N = ni(N, e.length - N)), N <= D;
  }
  const f = {
    index: t,
    slideIndex: i,
    slide: n,
    container: C,
    isClone: y,
    mount: T,
    destroy: E,
    update: V,
    style: h,
    isWithin: w
  };
  return f;
}
function dM(e, t, i) {
  const { on: n, emit: u, bind: s } = Mt(e), { slides: o, list: a } = t.Elements, M = [];
  function r() {
    L(), n(at, j), n([kt, at], () => {
      M.sort((h, Q) => h.index - Q.index);
    });
  }
  function L() {
    o.forEach((h, Q) => {
      I(h, Q, -1);
    });
  }
  function c() {
    E((h) => {
      h.destroy();
    }), ve(M);
  }
  function j() {
    c(), L();
  }
  function g() {
    E((h) => {
      h.update();
    });
  }
  function I(h, Q, W) {
    const w = yM(e, Q, W, h);
    w.mount(), M.push(w);
  }
  function y(h) {
    return h ? O((Q) => !Q.isClone) : M;
  }
  function C(h) {
    const { Controller: Q } = t, W = Q.toIndex(h), w = Q.hasFocus() ? 1 : i.perPage;
    return O((f) => Fe(f.index, W, W + w - 1));
  }
  function x(h) {
    return O(h)[0];
  }
  function p(h, Q) {
    qt(h, (W) => {
      if (Rt(W) && (W = Ss(W)), Bn(W)) {
        const w = o[Q];
        w ? Jn(W, w) : Pi(a, W), Xt(W, i.classes.slide), V(W, u.bind(null, pe));
      }
    }), u(at);
  }
  function T(h) {
    ke(O(h).map((Q) => Q.slide)), u(at);
  }
  function E(h, Q) {
    y(Q).forEach(h);
  }
  function O(h) {
    return M.filter(wa(h) ? h : (Q) => Rt(h) ? Fn(Q.slide, h) : Wi(ri(h), Q.index));
  }
  function v(h, Q, W) {
    E((w) => {
      w.style(h, Q, W);
    });
  }
  function V(h, Q) {
    const W = Rn(h, "img");
    let { length: w } = W;
    w ? W.forEach((f) => {
      s(f, "load error", () => {
        --w || Q();
      });
    }) : Q();
  }
  function Z(h) {
    return h ? o.length : M.length;
  }
  function $() {
    return M.length > i.perPage;
  }
  return {
    mount: r,
    destroy: c,
    update: g,
    register: I,
    get: y,
    getIn: C,
    getAt: x,
    add: p,
    remove: T,
    forEach: E,
    filter: O,
    style: v,
    getLength: Z,
    isEnough: $
  };
}
function SM(e, t, i) {
  const { on: n, bind: u, emit: s } = Mt(e), { Slides: o } = t, { resolve: a } = t.Direction, { root: M, track: r, list: L } = t.Elements, { getAt: c } = o;
  let j, g;
  function I() {
    y(), u(window, "resize load", ws(s.bind(this, pe))), n([Dt, at], y), n(pe, C);
  }
  function y() {
    g = null, j = i.direction === Kn, Et(M, "maxWidth", Pt(i.width)), Et(r, a("paddingLeft"), p(!1)), Et(r, a("paddingRight"), p(!0)), C();
  }
  function C() {
    const f = ft(M);
    (!g || g.width !== f.width || g.height !== f.height) && (Et(r, "height", T()), o.style(a("marginRight"), Pt(i.gap)), o.style("width", O() || null), x(), g = f, s(Es));
  }
  function x() {
    o.style("height", v() || null, !0);
  }
  function p(f) {
    const { padding: S } = i, D = a(f ? "right" : "left");
    return S && Pt(S[D] || (qe(S) ? 0 : S)) || "0px";
  }
  function T() {
    let f = "";
    return j && (f = E(), ii(f, "height or heightRatio is missing."), f = `calc(${f} - ${p(!1)} - ${p(!0)})`), f;
  }
  function E() {
    return Pt(i.height || ft(L).width * i.heightRatio);
  }
  function O() {
    return i.autoWidth ? "" : Pt(i.fixedWidth) || (j ? "" : V());
  }
  function v() {
    return Pt(i.fixedHeight) || (j ? i.autoHeight ? "" : V() : E());
  }
  function V() {
    const f = Pt(i.gap);
    return `calc((100%${f && ` + ${f}`})/${i.perPage || 1}${f && ` - ${f}`})`;
  }
  function Z() {
    return ft(L)[a("width")];
  }
  function $(f, S) {
    const D = c(f || 0);
    return D ? ft(D.slide)[a("width")] + (S ? 0 : W()) : 0;
  }
  function h(f, S) {
    const D = c(f);
    if (D) {
      const N = ft(D.slide)[a("right")], m = ft(L)[a("left")];
      return xt(N - m) + (S ? 0 : W());
    }
    return 0;
  }
  function Q() {
    return h(e.length - 1, !0) - h(-1, !0);
  }
  function W() {
    const f = c(0);
    return f && parseFloat(Et(f.slide, a("marginRight"))) || 0;
  }
  function w(f) {
    return parseFloat(Et(r, a(`padding${f ? "Right" : "Left"}`))) || 0;
  }
  return {
    mount: I,
    listSize: Z,
    slideSize: $,
    sliderSize: Q,
    totalSize: h,
    getPadding: w
  };
}
function DM(e, t, i) {
  const { on: n, emit: u } = Mt(e), { Elements: s, Slides: o } = t, { resolve: a } = t.Direction, M = [];
  let r;
  function L() {
    c(), n(at, g), n([Dt, pe], I);
  }
  function c() {
    (r = x()) && (y(r), u(pe));
  }
  function j() {
    ke(M), ve(M);
  }
  function g() {
    j(), c();
  }
  function I() {
    r < x() && u(at);
  }
  function y(p) {
    const T = o.get().slice(), { length: E } = T;
    if (E) {
      for (; T.length < p; )
        Je(T, T);
      Je(T.slice(-p), T.slice(0, p)).forEach((O, v) => {
        const V = v < p, Z = C(O.slide, v);
        V ? Jn(Z, T[0].slide) : Pi(s.list, Z), Je(M, Z), o.register(Z, v - p + (V ? 0 : E), O.index);
      });
    }
  }
  function C(p, T) {
    const E = p.cloneNode(!0);
    return Xt(E, i.classes.clone), E.id = `${e.root.id}-clone${Xn(T + 1)}`, E;
  }
  function x() {
    let { clones: p } = i;
    if (!e.is(Ue))
      p = 0;
    else if (!p) {
      const T = Ya(s.list, i[a("fixedWidth")]);
      p = (T && si(ft(s.track)[a("width")] / T) || i[a("autoWidth")] && e.length || i.perPage) * (i.drag ? (i.flickMaxPages || 1) + 1 : 2);
    }
    return p;
  }
  return {
    mount: L,
    destroy: j
  };
}
function AM(e, t, i) {
  const { on: n, emit: u } = Mt(e), { slideSize: s, getPadding: o, totalSize: a, listSize: M, sliderSize: r } = t.Layout, { resolve: L, orient: c } = t.Direction, { list: j, track: g } = t.Elements;
  let I;
  function y() {
    I = t.Transition, n([kt, Es, Dt, at], x);
  }
  function C() {
    zt(j, "style");
  }
  function x() {
    f() || (t.Scroll.cancel(), T(e.index), u(xs));
  }
  function p(D, N, m, z) {
    if (!f()) {
      const { set: P } = e.state, H = h();
      D !== N && (I.cancel(), E(v(H, D > N), !0)), P(xi), u(Ht, N, m, D), I.start(N, () => {
        P(Ei), u(oi, N, m, D), i.trimSpace === "move" && D !== m && H === h() ? t.Controller.go(D > m ? ">" : "<", !1, z) : z && z();
      });
    }
  }
  function T(D) {
    E($(D, !0));
  }
  function E(D, N) {
    if (!e.is(Gi)) {
      const m = N ? D : O(D);
      j.style.transform = `translate${L("X")}(${m}px)`, D !== m && u(As);
    }
  }
  function O(D) {
    if (e.is(Ue)) {
      const N = c(D - h()), m = S(!1, D) && N < 0, z = S(!0, D) && N > 0;
      (m || z) && (D = v(D, z));
    }
    return D;
  }
  function v(D, N) {
    const m = D - w(N), z = r();
    return D -= c(z * (si(xt(m) / z) || 1)) * (N ? 1 : -1), D;
  }
  function V() {
    E(h()), I.cancel();
  }
  function Z(D) {
    const N = t.Slides.get();
    let m = 0, z = 1 / 0;
    for (let P = 0; P < N.length; P++) {
      const H = N[P].index, tt = xt($(H, !0) - D);
      if (tt <= z)
        z = tt, m = H;
      else
        break;
    }
    return m;
  }
  function $(D, N) {
    const m = c(a(D - 1) - W(D));
    return N ? Q(m) : m;
  }
  function h() {
    const D = L("left");
    return ft(j)[D] - ft(g)[D] + c(o(!1));
  }
  function Q(D) {
    return i.trimSpace && e.is(ci) && (D = Be(D, 0, c(r() - M()))), D;
  }
  function W(D) {
    const { focus: N } = i;
    return N === "center" ? (M() - s(D, !0)) / 2 : +N * s(D) || 0;
  }
  function w(D) {
    return $(D ? t.Controller.getEnd() : 0, !!i.trimSpace);
  }
  function f() {
    return e.state.is(xi) && i.waitForTransition;
  }
  function S(D, N) {
    N = Gn(N) ? h() : N;
    const m = D !== !0 && c(N) < c(w(!1)), z = D !== !1 && c(N) > c(w(!0));
    return m || z;
  }
  return {
    mount: y,
    destroy: C,
    move: p,
    jump: T,
    translate: E,
    shift: v,
    cancel: V,
    toIndex: Z,
    toPosition: $,
    getPosition: h,
    getLimit: w,
    isBusy: f,
    exceededLimit: S
  };
}
function fM(e, t, i) {
  const { on: n } = Mt(e), { Move: u } = t, { getPosition: s, getLimit: o } = u, { isEnough: a, getLength: M } = t.Slides, r = e.is(Ue), L = e.is(ci);
  let c = i.start || 0, j = c, g, I, y;
  function C() {
    x(), n([Dt, at], x, Vn - 1);
  }
  function x() {
    g = M(!0), I = i.perMove, y = i.perPage, c = Be(c, 0, g - 1);
  }
  function p(N, m, z) {
    const P = E(N);
    if (i.useScroll)
      T(P, !0, !0, i.speed, z);
    else {
      const H = h(P);
      H > -1 && !u.isBusy() && (m || H !== c) && (f(H), u.move(P, H, j, z));
    }
  }
  function T(N, m, z, P, H) {
    const tt = m ? N : w(N);
    t.Scroll.scroll(m || z ? u.toPosition(tt, !0) : N, P, () => {
      f(u.toIndex(u.getPosition())), H && H();
    });
  }
  function E(N) {
    let m = c;
    if (Rt(N)) {
      const [, z, P] = N.match(/([+\-<>])(\d+)?/) || [];
      z === "+" || z === "-" ? m = Z(c + +`${z}${+P || 1}`, c, !0) : z === ">" ? m = P ? Q(+P) : O(!0) : z === "<" && (m = v(!0));
    } else
      m = r ? N : Be(N, 0, $());
    return m;
  }
  function O(N) {
    return V(!1, N);
  }
  function v(N) {
    return V(!0, N);
  }
  function V(N, m) {
    const z = I || (D() ? 1 : y), P = Z(c + z * (N ? -1 : 1), c);
    return P === -1 && L && !va(s(), o(!N), 1) ? N ? 0 : $() : m ? P : h(P);
  }
  function Z(N, m, z) {
    if (a()) {
      const P = $();
      N < 0 || N > P ? Fe(0, N, m, !0) || Fe(P, m, N, !0) ? N = Q(W(N)) : r ? N = I || D() ? N : N < 0 ? -(g % y || y) : g : i.rewind ? N = N < 0 ? P : 0 : N = -1 : !z && N !== m && (N = I ? N : Q(W(m) + (N < m ? -1 : 1)));
    } else
      N = -1;
    return N;
  }
  function $() {
    let N = g - y;
    return (D() || r && I) && (N = g - 1), ui(N, 0);
  }
  function h(N) {
    return r ? a() ? N % g + (N < 0 ? g : 0) : -1 : N;
  }
  function Q(N) {
    return Be(D() ? N : y * N, 0, $());
  }
  function W(N) {
    return D() || (N = Fe(N, g - y, g - 1) ? g - 1 : N, N = En(N / y)), N;
  }
  function w(N) {
    const m = u.toIndex(N);
    return L ? Be(m, 0, $()) : m;
  }
  function f(N) {
    N !== c && (j = c, c = N);
  }
  function S(N) {
    return N ? j : c;
  }
  function D() {
    return !Gn(i.focus) || i.isNavigation;
  }
  return {
    mount: C,
    go: p,
    scroll: T,
    getNext: O,
    getPrev: v,
    getAdjacent: V,
    getEnd: $,
    setIndex: f,
    getIndex: S,
    toIndex: Q,
    toPage: W,
    toDest: w,
    hasFocus: D
  };
}
const TM = "http://www.w3.org/2000/svg", EM = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", yi = 40;
function xM(e, t, i) {
  const { on: n, bind: u, emit: s } = Mt(e), { classes: o, i18n: a } = i, { Elements: M, Controller: r } = t;
  let L = M.arrows, c = M.prev, j = M.next, g;
  const I = {};
  function y() {
    C(), n(Dt, C);
  }
  function C() {
    if (i.arrows && (!c || !j) && T(), c && j)
      if (I.prev)
        pi(L, i.arrows === !1 ? "none" : "");
      else {
        const { id: v } = M.track;
        ut(c, me, v), ut(j, me, v), I.prev = c, I.next = j, p(), s(Za, c, j);
      }
  }
  function x() {
    g ? ke(L) : (zt(c, mi), zt(j, mi));
  }
  function p() {
    const { go: v } = r;
    n([kt, oi, Dt, at, li], O), u(j, "click", () => {
      v(">", !0);
    }), u(c, "click", () => {
      v("<", !0);
    });
  }
  function T() {
    L = Te("div", o.arrows), c = E(!0), j = E(!1), g = !0, Pi(L, [c, j]), Jn(L, Yt(i.arrows === "slider" && M.slider || e.root));
  }
  function E(v) {
    const V = `<button class="${o.arrow} ${v ? o.prev : o.next}" type="button"><svg xmlns="${TM}" viewBox="0 0 ${yi} ${yi}" width="${yi}" height="${yi}"><path d="${i.arrowPath || EM}" />`;
    return Ss(V);
  }
  function O() {
    const v = e.index, V = r.getPrev(), Z = r.getNext(), $ = V > -1 && v < V ? a.last : a.prev, h = Z > -1 && v > Z ? a.first : a.next;
    c.disabled = V < 0, j.disabled = Z < 0, ut(c, we, $), ut(j, we, h), s(Ba, c, j, V, Z);
  }
  return {
    arrows: I,
    mount: y,
    destroy: x
  };
}
const CM = `${$n}-interval`;
function pM(e, t, i) {
  const { on: n, bind: u, emit: s } = Mt(e), o = Hn(i.interval, e.go.bind(e, ">"), p), { isPaused: a } = o, { Elements: M } = t;
  let r, L, c;
  function j() {
    const { autoplay: E } = i;
    E && (g(!0), g(!1), I(), E !== "pause" && y());
  }
  function g(E) {
    const O = E ? "pause" : "play", v = M[O];
    v && (ut(v, me, M.track.id), ut(v, we, i.i18n[O]), u(v, "click", E ? C : y));
  }
  function I() {
    const { root: E } = M;
    i.pauseOnHover && u(E, "mouseenter mouseleave", (O) => {
      r = O.type === "mouseenter", x();
    }), i.pauseOnFocus && u(E, "focusin focusout", (O) => {
      L = O.type === "focusin", x();
    }), n([Ht, Cs, at], o.rewind), n(Ht, T);
  }
  function y() {
    a() && t.Slides.isEnough() && (o.start(!i.resetProgress), L = r = c = !1, s(Ra));
  }
  function C(E = !0) {
    a() || (o.pause(), s(Ha)), c = E;
  }
  function x() {
    c || (!r && !L ? y() : C(!1));
  }
  function p(E) {
    const { bar: O } = M;
    O && Et(O, "width", `${E * 100}%`), s(Xa, E);
  }
  function T() {
    const E = t.Slides.getAt(e.index);
    o.set(E && +ti(E.slide, CM) || i.interval);
  }
  return {
    mount: j,
    destroy: o.cancel,
    play: y,
    pause: C,
    isPaused: a
  };
}
function hM(e, t, i) {
  const { on: n } = Mt(e);
  function u() {
    i.cover && (n(ms, (M, r) => {
      a(!0, M, r);
    }), n([kt, Dt, at], o.bind(null, !0)));
  }
  function s() {
    o(!1);
  }
  function o(M) {
    t.Slides.forEach((r) => {
      const L = Yt(r.container || r.slide, "img");
      L && L.src && a(M, L, r);
    });
  }
  function a(M, r, L) {
    L.style("background", M ? `center/cover no-repeat url("${r.src}")` : "", !0), pi(r, M ? "none" : "");
  }
  return {
    mount: u,
    destroy: s
  };
}
const mM = 10, wM = 600, zM = 0.6, OM = 1.5, bM = 800;
function YM(e, t, i) {
  const { on: n, emit: u } = Mt(e), { Move: s } = t, { getPosition: o, getLimit: a, exceededLimit: M } = s;
  let r, L;
  function c() {
    n(Ht, C), n([Dt, at], x);
  }
  function j(T, E, O, v) {
    const V = o();
    let Z = 1;
    E = E || y(xt(T - V)), L = O, C(), r = Hn(E, I, ($) => {
      const h = o(), W = (V + (T - V) * p($) - o()) * Z;
      s.translate(h + W), e.is(ci) && !v && M() && (Z *= zM, xt(W) < mM && g(M(!1)));
    }, 1), u(Cs), r.start();
  }
  function g(T) {
    j(a(!T), wM, null, !0);
  }
  function I() {
    const T = o(), E = s.toIndex(T);
    Fe(E, 0, e.length - 1) || s.translate(s.shift(T, E > 0), !0), L && L(), u(li);
  }
  function y(T) {
    return ui(T / OM, bM);
  }
  function C() {
    r && r.cancel();
  }
  function x() {
    r && !r.isPaused() && (C(), I());
  }
  function p(T) {
    const { easingFunc: E } = i;
    return E ? E(T) : 1 - Math.pow(1 - T, 4);
  }
  return {
    mount: c,
    destroy: C,
    scroll: j,
    cancel: x
  };
}
const Se = { passive: !1, capture: !0 }, vM = 5, Tu = 200, _M = "touchstart mousedown", Ri = "touchmove mousemove", Xi = "touchend touchcancel mouseup";
function kM(e, t, i) {
  const { on: n, emit: u, bind: s, unbind: o } = Mt(e), { Move: a, Scroll: M, Controller: r } = t, { track: L } = t.Elements, { resolve: c, orient: j } = t.Direction, { getPosition: g, exceededLimit: I } = a;
  let y, C, x, p, T, E, O = !1, v, V, Z;
  function $() {
    s(L, Ri, Tn, Se), s(L, Xi, Tn, Se), s(L, _M, Q, Se), s(L, "click", S, { capture: !0 }), s(L, "dragstart", $t), n([kt, Dt], h);
  }
  function h() {
    const { drag: G } = i;
    Ct(!G), T = G === "free";
  }
  function Q(G) {
    if (!V) {
      const { noDrag: st } = i, ot = tt(G), It = !st || !Fn(G.target, st);
      v = !1, It && (ot || !G.button) && (a.isBusy() ? $t(G, !0) : (Z = ot ? L : window, x = null, p = null, s(Z, Ri, W, Se), s(Z, Xi, w, Se), a.cancel(), M.cancel(), f(G)));
    }
  }
  function W(G) {
    if (p || u($a), p = G, G.cancelable) {
      const st = z(G) - z(C);
      if (E) {
        a.translate(y + H(st));
        const ot = P(G) - P(C) > Tu, It = O !== (O = I());
        (ot || It) && f(G), u(Va), v = !0, $t(G);
      } else {
        let { dragMinThreshold: ot } = i;
        ot = qe(ot) ? ot : { mouse: 0, touch: +ot || 10 }, E = xt(st) > (tt(G) ? ot.touch : ot.mouse), D() && $t(G);
      }
    }
  }
  function w(G) {
    o(Z, Ri, W), o(Z, Xi, w);
    const { index: st } = e;
    if (p) {
      if (E || G.cancelable && D()) {
        const ot = N(G), It = m(ot);
        T ? r.scroll(It) : e.is(Gi) ? r.go(st + j(Su(ot))) : r.go(r.toDest(It), !0), $t(G);
      }
      u(Ga);
    } else
      !T && g() !== a.toPosition(st) && r.go(st, !0);
    E = !1;
  }
  function f(G) {
    x = C, C = G, y = g();
  }
  function S(G) {
    !V && v && $t(G, !0);
  }
  function D() {
    const G = xt(z(p) - z(C)), st = xt(z(p, !0) - z(C, !0));
    return G > st;
  }
  function N(G) {
    if (e.is(Ue) || !O) {
      const st = C === p && x || C, ot = z(p) - z(st), It = P(G) - P(st), Nt = P(G) - P(p) < Tu;
      if (It && Nt)
        return ot / It;
    }
    return 0;
  }
  function m(G) {
    return g() + Su(G) * ni(xt(G) * (i.flickPower || 600), T ? 1 / 0 : t.Layout.listSize() * (i.flickMaxPages || 1));
  }
  function z(G, st) {
    return (tt(G) ? G.touches[0] : G)[`page${c(st ? "Y" : "X")}`];
  }
  function P(G) {
    return G.timeStamp;
  }
  function H(G) {
    return G / (O && e.is(ci) ? vM : 1);
  }
  function tt(G) {
    return typeof TouchEvent < "u" && G instanceof TouchEvent;
  }
  function rt() {
    return E;
  }
  function Ct(G) {
    V = G;
  }
  return {
    mount: $,
    disable: Ct,
    isDragging: rt
  };
}
const UM = ["Left", "Right", "Up", "Down"], Eu = "keydown";
function QM(e, t, i) {
  const { on: n, bind: u, unbind: s } = Mt(e), { root: o } = e, { resolve: a } = t.Direction;
  let M, r;
  function L() {
    c(), n(Dt, y), n(Ht, I);
  }
  function c() {
    const { keyboard: x } = i;
    x && (x === "focused" ? (M = o, ut(o, ai, 0)) : M = window, u(M, Eu, C));
  }
  function j() {
    s(M, Eu), Bn(M) && zt(M, ai);
  }
  function g(x) {
    r = x;
  }
  function I() {
    const x = r;
    r = !0, fn(() => {
      r = x;
    });
  }
  function y() {
    j(), c();
  }
  function C(x) {
    if (!r) {
      const { key: p } = x, T = Wi(UM, p) ? `Arrow${p}` : p;
      T === a("ArrowLeft") ? e.go("<") : T === a("ArrowRight") && e.go(">");
    }
  }
  return {
    mount: L,
    destroy: j,
    disable: g
  };
}
const wi = `${$n}-lazy`, pn = `${wi}-srcset`, WM = `[${wi}], [${pn}]`;
function PM(e, t, i) {
  const { on: n, off: u, bind: s, emit: o } = Mt(e), a = i.lazyLoad === "sequential";
  let M = [], r = 0;
  function L() {
    i.lazyLoad && (j(), n(at, c), a || n([kt, at, oi, li], I));
  }
  function c() {
    g(), j();
  }
  function j() {
    t.Slides.forEach((p) => {
      Rn(p.slide, WM).forEach((T) => {
        const E = ti(T, wi), O = ti(T, pn);
        if (E !== T.src || O !== T.srcset) {
          const v = i.classes.spinner, V = T.parentElement, Z = Yt(V, `.${v}`) || Te("span", v, V);
          ut(Z, Vi, "presentation"), M.push({ _img: T, _Slide: p, src: E, srcset: O, _spinner: Z }), !T.src && pi(T, "none");
        }
      });
    }), a && x();
  }
  function g() {
    r = 0, M = [];
  }
  function I() {
    M = M.filter((p) => {
      const T = i.perPage * ((i.preloadPages || 1) + 1) - 1;
      return p._Slide.isWithin(e.index, T) ? y(p) : !0;
    }), M.length || u(oi);
  }
  function y(p) {
    const { _img: T } = p;
    Xt(p._Slide.slide, Cn), s(T, "load error", (E) => {
      C(p, E.type === "error");
    }), ["srcset", "src"].forEach((E) => {
      p[E] && (ut(T, E, p[E]), zt(T, E === "src" ? wi : pn));
    });
  }
  function C(p, T) {
    const { _Slide: E } = p;
    ei(E.slide, Cn), T || (ke(p._spinner), pi(p._img, ""), o(ms, p._img, E), o(pe)), a && x();
  }
  function x() {
    r < M.length && y(M[r++]);
  }
  return {
    mount: L,
    destroy: g
  };
}
function $M(e, t, i) {
  const { on: n, emit: u, bind: s, unbind: o } = Mt(e), { Slides: a, Elements: M, Controller: r } = t, { hasFocus: L, getIndex: c } = r, j = [];
  let g;
  function I() {
    y(), n([Dt, at], y), n([Ht, li], E);
  }
  function y() {
    C(), i.pagination && a.isEnough() && (x(), u(Ja, { list: g, items: j }, T(e.index)), E());
  }
  function C() {
    g && (ke(g), j.forEach((O) => {
      o(O.button, "click");
    }), ve(j), g = null);
  }
  function x() {
    const { length: O } = e, { classes: v, i18n: V, perPage: Z } = i, $ = i.pagination === "slider" && M.slider || M.root, h = L() ? O : si(O / Z);
    g = Te("ul", v.pagination, $);
    for (let Q = 0; Q < h; Q++) {
      const W = Te("li", null, g), w = Te("button", { class: v.page, type: "button" }, W), f = a.getIn(Q).map((D) => D.slide.id), S = !L() && Z > 1 ? V.pageX : V.slideX;
      s(w, "click", p.bind(null, Q)), ut(w, me, f.join(" ")), ut(w, we, Ds(S, Q + 1)), j.push({ li: W, button: w, page: Q });
    }
  }
  function p(O) {
    r.go(`>${O}`, !0, () => {
      const v = a.getAt(r.toIndex(O));
      v && ba(v.slide);
    });
  }
  function T(O) {
    return j[r.toPage(O)];
  }
  function E() {
    const O = T(c(!0)), v = T(c());
    O && (ei(O.button, he), zt(O.button, hi)), v && (Xt(v.button, he), ut(v.button, hi, !0)), u(Fa, { list: g, items: j }, O, v);
  }
  return {
    items: j,
    mount: I,
    destroy: C,
    getAt: T,
    update: E
  };
}
const VM = [" ", "Enter", "Spacebar"];
function GM(e, t, i) {
  const { list: n } = t.Elements, u = [];
  function s() {
    e.splides.forEach((g) => {
      !g.isParent && M(g.splide);
    }), i.isNavigation && r();
  }
  function o() {
    zt(n, mi), u.forEach((g) => {
      g.destroy();
    }), ve(u);
  }
  function a() {
    o(), s();
  }
  function M(g) {
    [e, g].forEach((I) => {
      const y = Mt(I), C = I === e ? g : e;
      y.on(Ht, (x, p, T) => {
        C.go(C.is(Ue) ? T : x);
      }), u.push(y);
    });
  }
  function r() {
    const g = Mt(e), { on: I } = g;
    I(fs, c), I(Ts, j), I([kt, Dt], L), ut(n, Vi, "menu"), u.push(g), g.emit(hs, e.splides);
  }
  function L() {
    ut(n, Ws, i.direction !== Kn ? "horizontal" : null);
  }
  function c(g) {
    e.go(g.index);
  }
  function j(g, I) {
    Wi(VM, I.key) && (c(g), $t(I));
  }
  return {
    mount: s,
    destroy: o,
    remount: a
  };
}
function ZM(e, t, i) {
  const { bind: n } = Mt(e);
  function u() {
    i.wheel && n(t.Elements.track, "wheel", s, Se);
  }
  function s(a) {
    if (a.cancelable) {
      const { deltaY: M } = a;
      if (M) {
        const r = M < 0;
        e.go(r ? "<" : ">"), o(r) && $t(a);
      }
    }
  }
  function o(a) {
    return !i.releaseWheel || e.state.is(xi) || t.Controller.getAdjacent(a) !== -1;
  }
  return {
    mount: u
  };
}
var BM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Options: qa,
  Direction: eM,
  Elements: IM,
  Slides: dM,
  Layout: SM,
  Clones: DM,
  Move: AM,
  Controller: fM,
  Arrows: xM,
  Autoplay: pM,
  Cover: hM,
  Scroll: YM,
  Drag: kM,
  Keyboard: QM,
  LazyLoad: PM,
  Pagination: $M,
  Sync: GM,
  Wheel: ZM
});
const JM = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay"
}, xu = {
  type: "slide",
  speed: 400,
  waitForTransition: !0,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  keyboard: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  slideFocus: !0,
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  classes: gM,
  i18n: JM
};
function FM(e, t, i) {
  const { on: n } = Mt(e);
  function u() {
    n([kt, at], () => {
      fn(() => {
        t.Slides.style("transition", `opacity ${i.speed}ms ${i.easing}`);
      });
    });
  }
  function s(o, a) {
    const { track: M } = t.Elements;
    Et(M, "height", Pt(ft(M).height)), fn(() => {
      a(), Et(M, "height", "");
    });
  }
  return {
    mount: u,
    start: s,
    cancel: Tn
  };
}
function RM(e, t, i) {
  const { bind: n } = Mt(e), { Move: u, Controller: s } = t, { list: o } = t.Elements;
  let a;
  function M() {
    n(o, "transitionend", (g) => {
      g.target === o && a && (L(), a());
    });
  }
  function r(g, I) {
    const y = u.toPosition(g, !0), C = u.getPosition(), x = c(g);
    xt(y - C) >= 1 && x >= 1 ? (j(`transform ${x}ms ${i.easing}`), u.translate(y, !0), a = I) : (u.jump(g), I());
  }
  function L() {
    j("");
  }
  function c(g) {
    const { rewindSpeed: I } = i;
    if (e.is(ci) && I) {
      const y = s.getIndex(!0), C = s.getEnd();
      if (y === 0 && g >= C || y >= C && g === 0)
        return I;
    }
    return i.speed;
  }
  function j(g) {
    Et(o, "transition", g);
  }
  return {
    mount: M,
    start: r,
    cancel: L
  };
}
const Ps = class {
  constructor(e, t) {
    this.event = ka(), this.Components = {}, this.state = Ka(de), this.splides = [], this._options = {}, this._Extensions = {};
    const i = Rt(e) ? ue(document, e) : e;
    ii(i, `${i} is invalid.`), this.root = i, ae(xu, Ps.defaults), ae(ae(this._options, xu), t || {});
  }
  mount(e, t) {
    const { state: i, Components: n } = this;
    ii(i.is([de, Ci]), "Already mounted!"), i.set(de), this._Components = n, this._Transition = t || this._Transition || (this.is(Gi) ? FM : RM), this._Extensions = e || this._Extensions;
    const u = An({}, BM, this._Extensions, { Transition: this._Transition });
    return le(u, (s, o) => {
      const a = s(this, n, this._options);
      n[o] = a, a.setup && a.setup();
    }), le(n, (s) => {
      s.mount && s.mount();
    }), this.emit(kt), Xt(this.root, LM), i.set(Ei), this.emit(Au), this;
  }
  sync(e) {
    return this.splides.push({ splide: e }), e.splides.push({ splide: this, isParent: !0 }), this.state.is(Ei) && (this._Components.Sync.remount(), e.Components.Sync.remount()), this;
  }
  go(e) {
    return this._Components.Controller.go(e), this;
  }
  on(e, t) {
    return this.event.on(e, t, null, ma), this;
  }
  off(e) {
    return this.event.off(e), this;
  }
  emit(e) {
    return this.event.emit(e, ..._e(arguments, 1)), this;
  }
  add(e, t) {
    return this._Components.Slides.add(e, t), this;
  }
  remove(e) {
    return this._Components.Slides.remove(e), this;
  }
  is(e) {
    return this._options.type === e;
  }
  refresh() {
    return this.emit(at), this;
  }
  destroy(e = !0) {
    const { event: t, state: i } = this;
    return i.is(de) ? t.on(Au, this.destroy.bind(this, e), this) : (le(this._Components, (n) => {
      n.destroy && n.destroy(e);
    }, !0), t.emit(ps), t.destroy(), e && ve(this.splides), i.set(Ci)), this;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    const { _options: t } = this;
    ae(t, e), this.state.is(de) || this.emit(Dt, t);
  }
  get length() {
    return this._Components.Slides.getLength(!0);
  }
  get index() {
    return this._Components.Controller.getIndex();
  }
};
let tu = Ps;
tu.defaults = {};
tu.STATES = ha;
const Qt = /* @__PURE__ */ new Map(), Hi = {
  set(e, t, i) {
    Qt.has(e) || Qt.set(e, /* @__PURE__ */ new Map());
    const n = Qt.get(e);
    if (!n.has(t) && n.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
      return;
    }
    n.set(t, i);
  },
  get(e, t) {
    return Qt.has(e) && Qt.get(e).get(t) || null;
  },
  remove(e, t) {
    if (!Qt.has(e))
      return;
    const i = Qt.get(e);
    i.delete(t), i.size === 0 && Qt.delete(e);
  }
}, XM = 1e3, hn = "transitionend", HM = (e) => e == null ? `${e}` : Object.prototype.toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase(), $s = (e) => {
  let t = e.getAttribute("data-bs-target");
  if (!t || t === "#") {
    let i = e.getAttribute("href");
    if (!i || !i.includes("#") && !i.startsWith("."))
      return null;
    i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), t = i && i !== "#" ? i.trim() : null;
  }
  return t;
}, Vs = (e) => {
  const t = $s(e);
  return t && document.querySelector(t) ? t : null;
}, ce = (e) => {
  const t = $s(e);
  return t ? document.querySelector(t) : null;
}, KM = (e) => {
  if (!e)
    return 0;
  let { transitionDuration: t, transitionDelay: i } = window.getComputedStyle(e);
  const n = Number.parseFloat(t), u = Number.parseFloat(i);
  return !n && !u ? 0 : (t = t.split(",")[0], i = i.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(i)) * XM);
}, qM = (e) => {
  e.dispatchEvent(new Event(hn));
}, Ee = (e) => !e || typeof e != "object" ? !1 : (typeof e.jquery < "u" && (e = e[0]), typeof e.nodeType < "u"), zi = (e) => Ee(e) ? e.jquery ? e[0] : e : typeof e == "string" && e.length > 0 ? document.querySelector(e) : null, Gs = (e) => {
  if (!Ee(e) || e.getClientRects().length === 0)
    return !1;
  const t = getComputedStyle(e).getPropertyValue("visibility") === "visible", i = e.closest("details:not([open])");
  if (!i)
    return t;
  if (i !== e) {
    const n = e.closest("summary");
    if (n && n.parentNode !== i || n === null)
      return !1;
  }
  return t;
}, Qe = (e) => !e || e.nodeType !== Node.ELEMENT_NODE || e.classList.contains("disabled") ? !0 : typeof e.disabled < "u" ? e.disabled : e.hasAttribute("disabled") && e.getAttribute("disabled") !== "false", eu = (e) => {
  e.offsetHeight;
}, Zs = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, Ki = [], tr = (e) => {
  document.readyState === "loading" ? (Ki.length || document.addEventListener("DOMContentLoaded", () => {
    for (const t of Ki)
      t();
  }), Ki.push(e)) : e();
}, Cu = () => document.documentElement.dir === "rtl", Zi = (e) => {
  tr(() => {
    const t = Zs();
    if (t) {
      const i = e.NAME, n = t.fn[i];
      t.fn[i] = e.jQueryInterface, t.fn[i].Constructor = e, t.fn[i].noConflict = () => (t.fn[i] = n, e.jQueryInterface);
    }
  });
}, se = (e) => {
  typeof e == "function" && e();
}, Bs = (e, t, i = !0) => {
  if (!i) {
    se(e);
    return;
  }
  const n = 5, u = KM(t) + n;
  let s = !1;
  const o = ({ target: a }) => {
    a === t && (s = !0, t.removeEventListener(hn, o), se(e));
  };
  t.addEventListener(hn, o), setTimeout(() => {
    s || qM(t);
  }, u);
}, Js = (e, t, i, n) => {
  const u = e.length;
  let s = e.indexOf(t);
  return s === -1 ? !i && n ? e[u - 1] : e[0] : (s += i ? 1 : -1, n && (s = (s + u) % u), e[Math.max(0, Math.min(s, u - 1))]);
}, er = /[^.]*(?=\..*)\.|.*/, ir = /\..*/, nr = /::\d+$/, qi = {};
let pu = 1;
const Fs = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, ur = /* @__PURE__ */ new Set([
  "click",
  "dblclick",
  "mouseup",
  "mousedown",
  "contextmenu",
  "mousewheel",
  "DOMMouseScroll",
  "mouseover",
  "mouseout",
  "mousemove",
  "selectstart",
  "selectend",
  "keydown",
  "keypress",
  "keyup",
  "orientationchange",
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  "pointerdown",
  "pointermove",
  "pointerup",
  "pointerleave",
  "pointercancel",
  "gesturestart",
  "gesturechange",
  "gestureend",
  "focus",
  "blur",
  "change",
  "reset",
  "select",
  "submit",
  "focusin",
  "focusout",
  "load",
  "unload",
  "beforeunload",
  "resize",
  "move",
  "DOMContentLoaded",
  "readystatechange",
  "error",
  "abort",
  "scroll"
]);
function Rs(e, t) {
  return t && `${t}::${pu++}` || e.uidEvent || pu++;
}
function Xs(e) {
  const t = Rs(e);
  return e.uidEvent = t, qi[t] = qi[t] || {}, qi[t];
}
function sr(e, t) {
  return function i(n) {
    return iu(n, { delegateTarget: e }), i.oneOff && R.off(e, n.type, t), t.apply(e, [n]);
  };
}
function or(e, t, i) {
  return function n(u) {
    const s = e.querySelectorAll(t);
    for (let { target: o } = u; o && o !== this; o = o.parentNode)
      for (const a of s)
        if (a === o)
          return iu(u, { delegateTarget: o }), n.oneOff && R.off(e, u.type, t, i), i.apply(o, [u]);
  };
}
function Hs(e, t, i = null) {
  return Object.values(e).find((n) => n.callable === t && n.delegationSelector === i);
}
function Ks(e, t, i) {
  const n = typeof t == "string", u = n ? i : t || i;
  let s = qs(e);
  return ur.has(s) || (s = e), [n, u, s];
}
function hu(e, t, i, n, u) {
  if (typeof t != "string" || !e)
    return;
  let [s, o, a] = Ks(t, i, n);
  t in Fs && (o = ((I) => function(y) {
    if (!y.relatedTarget || y.relatedTarget !== y.delegateTarget && !y.delegateTarget.contains(y.relatedTarget))
      return I.call(this, y);
  })(o));
  const M = Xs(e), r = M[a] || (M[a] = {}), L = Hs(r, o, s ? i : null);
  if (L) {
    L.oneOff = L.oneOff && u;
    return;
  }
  const c = Rs(o, t.replace(er, "")), j = s ? or(e, i, o) : sr(e, o);
  j.delegationSelector = s ? i : null, j.callable = o, j.oneOff = u, j.uidEvent = c, r[c] = j, e.addEventListener(a, j, s);
}
function mn(e, t, i, n, u) {
  const s = Hs(t[i], n, u);
  !s || (e.removeEventListener(i, s, Boolean(u)), delete t[i][s.uidEvent]);
}
function ar(e, t, i, n) {
  const u = t[i] || {};
  for (const s of Object.keys(u))
    if (s.includes(n)) {
      const o = u[s];
      mn(e, t, i, o.callable, o.delegationSelector);
    }
}
function qs(e) {
  return e = e.replace(ir, ""), Fs[e] || e;
}
const R = {
  on(e, t, i, n) {
    hu(e, t, i, n, !1);
  },
  one(e, t, i, n) {
    hu(e, t, i, n, !0);
  },
  off(e, t, i, n) {
    if (typeof t != "string" || !e)
      return;
    const [u, s, o] = Ks(t, i, n), a = o !== t, M = Xs(e), r = M[o] || {}, L = t.startsWith(".");
    if (typeof s < "u") {
      if (!Object.keys(r).length)
        return;
      mn(e, M, o, s, u ? i : null);
      return;
    }
    if (L)
      for (const c of Object.keys(M))
        ar(e, M, c, t.slice(1));
    for (const c of Object.keys(r)) {
      const j = c.replace(nr, "");
      if (!a || t.includes(j)) {
        const g = r[c];
        mn(e, M, o, g.callable, g.delegationSelector);
      }
    }
  },
  trigger(e, t, i) {
    if (typeof t != "string" || !e)
      return null;
    const n = Zs(), u = qs(t), s = t !== u;
    let o = null, a = !0, M = !0, r = !1;
    s && n && (o = n.Event(t, i), n(e).trigger(o), a = !o.isPropagationStopped(), M = !o.isImmediatePropagationStopped(), r = o.isDefaultPrevented());
    let L = new Event(t, { bubbles: a, cancelable: !0 });
    return L = iu(L, i), r && L.preventDefault(), M && e.dispatchEvent(L), L.defaultPrevented && o && o.preventDefault(), L;
  }
};
function iu(e, t) {
  for (const [i, n] of Object.entries(t || {}))
    try {
      e[i] = n;
    } catch {
      Object.defineProperty(e, i, {
        configurable: !0,
        get() {
          return n;
        }
      });
    }
  return e;
}
function mu(e) {
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  if (e === Number(e).toString())
    return Number(e);
  if (e === "" || e === "null")
    return null;
  if (typeof e != "string")
    return e;
  try {
    return JSON.parse(decodeURIComponent(e));
  } catch {
    return e;
  }
}
function tn(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
const Re = {
  setDataAttribute(e, t, i) {
    e.setAttribute(`data-bs-${tn(t)}`, i);
  },
  removeDataAttribute(e, t) {
    e.removeAttribute(`data-bs-${tn(t)}`);
  },
  getDataAttributes(e) {
    if (!e)
      return {};
    const t = {}, i = Object.keys(e.dataset).filter((n) => n.startsWith("bs") && !n.startsWith("bsConfig"));
    for (const n of i) {
      let u = n.replace(/^bs/, "");
      u = u.charAt(0).toLowerCase() + u.slice(1, u.length), t[u] = mu(e.dataset[n]);
    }
    return t;
  },
  getDataAttribute(e, t) {
    return mu(e.getAttribute(`data-bs-${tn(t)}`));
  }
};
class nu {
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t;
  }
  _mergeConfigObj(t, i) {
    const n = Ee(i) ? Re.getDataAttribute(i, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof n == "object" ? n : {},
      ...Ee(i) ? Re.getDataAttributes(i) : {},
      ...typeof t == "object" ? t : {}
    };
  }
  _typeCheckConfig(t, i = this.constructor.DefaultType) {
    for (const n of Object.keys(i)) {
      const u = i[n], s = t[n], o = Ee(s) ? "element" : HM(s);
      if (!new RegExp(u).test(o))
        throw new TypeError(
          `${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${o}" but expected type "${u}".`
        );
    }
  }
}
const Mr = "5.2.3";
class Li extends nu {
  constructor(t, i) {
    super(), t = zi(t), t && (this._element = t, this._config = this._getConfig(i), Hi.set(this._element, this.constructor.DATA_KEY, this));
  }
  dispose() {
    Hi.remove(this._element, this.constructor.DATA_KEY), R.off(this._element, this.constructor.EVENT_KEY);
    for (const t of Object.getOwnPropertyNames(this))
      this[t] = null;
  }
  _queueCallback(t, i, n = !0) {
    Bs(t, i, n);
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  static getInstance(t) {
    return Hi.get(zi(t), this.DATA_KEY);
  }
  static getOrCreateInstance(t, i = {}) {
    return this.getInstance(t) || new this(t, typeof i == "object" ? i : null);
  }
  static get VERSION() {
    return Mr;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(t) {
    return `${t}${this.EVENT_KEY}`;
  }
}
const ct = {
  find(e, t = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(t, e));
  },
  findOne(e, t = document.documentElement) {
    return Element.prototype.querySelector.call(t, e);
  },
  children(e, t) {
    return [].concat(...e.children).filter((i) => i.matches(t));
  },
  parents(e, t) {
    const i = [];
    let n = e.parentNode.closest(t);
    for (; n; )
      i.push(n), n = n.parentNode.closest(t);
    return i;
  },
  prev(e, t) {
    let i = e.previousElementSibling;
    for (; i; ) {
      if (i.matches(t))
        return [i];
      i = i.previousElementSibling;
    }
    return [];
  },
  next(e, t) {
    let i = e.nextElementSibling;
    for (; i; ) {
      if (i.matches(t))
        return [i];
      i = i.nextElementSibling;
    }
    return [];
  },
  focusableChildren(e) {
    const t = [
      "a",
      "button",
      "input",
      "textarea",
      "select",
      "details",
      "[tabindex]",
      '[contenteditable="true"]'
    ].map((i) => `${i}:not([tabindex^="-"])`).join(",");
    return this.find(t, e).filter((i) => !Qe(i) && Gs(i));
  }
}, rr = "carousel", lr = "bs.carousel", cr = `.${lr}`, Lr = ".data-api", jr = `load${cr}${Lr}`, gr = "[data-bs-carousel-splide]", Ir = {
  slideFocus: !0,
  i18n: {
    prev: "Slide precedente",
    next: "Slide successiva",
    first: "Vai alla prima slide",
    last: "Vai all\u2019ultima slide",
    slideX: "Vai alla slide %s",
    pageX: "Vai a pagina %s",
    play: "Attiva autoplay",
    pause: "Pausa autoplay"
  }
}, wu = {
  "it-carousel-landscape-abstract-three-cols": {
    type: "slide",
    perPage: 3,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      }
    }
  },
  "it-carousel-landscape-abstract-three-cols-arrow-visible": {
    type: "slide",
    perPage: 3,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !0,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !0
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !0
      }
    }
  },
  "it-big-img": {
    type: "loop",
    perPage: 1,
    gap: 48,
    padding: { left: 320, right: 320 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 1,
        gap: 24,
        padding: { left: 160, right: 160 },
        arrows: !1
      }
    }
  },
  "it-standard-image": {
    type: "loop",
    perPage: 3,
    gap: 24,
    padding: { left: 48, right: 48 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 48, right: 48 },
        arrows: !1
      }
    }
  },
  "it-carousel-landscape-abstract": {
    type: "slide",
    perPage: 1,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 1,
        gap: 24,
        padding: { left: 24, right: 24 },
        arrows: !1
      }
    }
  },
  "it-calendar-wrapper": {
    type: "slide",
    perPage: 4,
    gap: 0,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      560: {
        perPage: 1,
        gap: 0,
        padding: { left: 24, right: 24 },
        arrows: !1
      },
      768: {
        perPage: 2,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 3,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      }
    }
  }
};
class to extends Li {
  constructor(t) {
    super(t), this._config = this._getConfig(), this._splide = new tu(this._element, this._config), this._init();
  }
  dispose() {
    this._splide.destroy(), super.dispose();
  }
  static get NAME() {
    return rr;
  }
  _init() {
    this._splide.mount();
  }
  _getConfig() {
    let t = Object.assign({}, Ir);
    return Object.keys(wu).forEach((i) => {
      this._element.classList.contains(i) && (t = Object.assign({}, t, wu[i]));
    }), t;
  }
}
R.on(window, jr, () => {
  ct.find(gr).forEach((t) => {
    to.getOrCreateInstance(t);
  });
});
const Nr = "inputlabel", yr = "bs.inputlabel", uu = `.${yr}`, dr = `focus${uu}`, zu = `blur${uu}`, Sr = `change${uu}`, en = "active";
class Bi {
  constructor(t) {
    this._element = t, this._init();
  }
  static get NAME() {
    return Nr;
  }
  _init() {
    const t = this._getLabel();
    t && !t.classList.contains(en) && (this._labelOut(), this._labelOver()), this._bindEvents();
  }
  _bindEvents() {
    ["date", "time"].includes(this._element.getAttribute("type")) || (this._element.getAttribute("type") === "file" ? R.on(this._element, zu, () => {
      this._labelOut();
    }) : (R.on(this._element, dr, () => {
      this._labelOut();
    }), R.on(this._element, zu, () => {
      this._labelOver();
    }), R.on(this._element, Sr, () => {
      this._labelToggle();
    })));
  }
  _getLabel() {
    return ct.findOne('label[for="' + this._element.getAttribute("id") + '"]');
  }
  _isEmpty() {
    return !this._element.value && !this._element.getAttribute("placeholder");
  }
  _labelOut() {
    const t = this._getLabel();
    t && t.classList.add(en);
  }
  _labelOver() {
    if (this._isEmpty()) {
      const t = this._getLabel();
      t && t.classList.remove(en);
    }
  }
  _labelToggle() {
    this._isEmpty() ? this._labelOver() : this._labelOut();
  }
}
Tt(Bi, "getInputFromLabel", (t) => document.querySelector("#" + t.getAttribute("for")));
const Dr = (e, t = "hide") => {
  const i = `click.dismiss${e.EVENT_KEY}`, n = e.NAME;
  R.on(document, i, `[data-bs-dismiss="${n}"]`, function(u) {
    if (["A", "AREA"].includes(this.tagName) && u.preventDefault(), Qe(this))
      return;
    const s = ce(this) || this.closest(`.${n}`);
    e.getOrCreateInstance(s)[t]();
  });
}, Ar = "input", fr = "bs.input", su = `.${fr}`, eo = ".data-api", Tr = `mousedown${su}${eo}`, Er = `keyup${su}${eo}`, xr = `change${su}`;
class vt extends Li {
  constructor(t) {
    super(t), this._label = new Bi(t), this._bindEvents();
  }
  static get NAME() {
    return Ar;
  }
  _bindEvents() {
    this._element.getAttribute("type") === "file" && R.on(this._element, xr, () => {
      this._handleFileDescription();
    });
  }
  _handleFileDescription() {
    const t = [];
    let i = "";
    Array.from(this._element.files).forEach((u) => {
      const s = Math.round(parseInt(u.size, 10) / 1024);
      t.push(u.name + " (" + s + "kb)");
    }), this._element.files.length > 1 && (i = this._element.files.length + " file da caricare: ");
    const n = ct.findOne('label[for="' + this._element.getAttribute("id") + '"] label.form-file-name', this._element);
    n && (n.innerText = i + t.join("; "));
  }
}
const Cr = [
  "select",
  'input[data-bs-input][type="password"]',
  "input.input-password[data-bs-input]",
  'input[data-bs-autocomplete][type="search"]',
  'input[type="time"]'
], io = (e) => {
  const t = !!Cr.find((n) => e.matches(n)), i = !!(e.getAttribute("type") === "number" && e.parentNode.querySelector('button[class^="input-number-"]'));
  return !t && !i ? vt.getOrCreateInstance(e) : null;
};
R.on(document, Tr, "input, textarea, label", function() {
  const e = Bi.getInputFromLabel(this) || this;
  io(e);
});
R.on(document, Er, "input, textarea, label", function() {
  const e = Bi.getInputFromLabel(this) || this, t = io(e);
  t && t._label && t._label._labelOut();
});
const pr = "collapse", hr = "bs.collapse", ji = `.${hr}`, mr = ".data-api", wr = `show${ji}`, zr = `shown${ji}`, Or = `hide${ji}`, br = `hidden${ji}`, Yr = `click${ji}${mr}`, nn = "show", fe = "collapse", di = "collapsing", vr = "collapsed", _r = `:scope .${fe} .${fe}`, kr = "collapse-horizontal", Ur = "width", Qr = "height", Wr = ".collapse.show, .collapse.collapsing", wn = '[data-bs-toggle="collapse"]', Pr = {
  parent: null,
  toggle: !0
}, $r = {
  parent: "(null|element)",
  toggle: "boolean"
};
class ze extends Li {
  constructor(t, i) {
    super(t, i), this._isTransitioning = !1, this._triggerArray = [];
    const n = ct.find(wn);
    for (const u of n) {
      const s = Vs(u), o = ct.find(s).filter((a) => a === this._element);
      s !== null && o.length && this._triggerArray.push(u);
    }
    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
  }
  static get Default() {
    return Pr;
  }
  static get DefaultType() {
    return $r;
  }
  static get NAME() {
    return pr;
  }
  toggle() {
    this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (this._isTransitioning || this._isShown())
      return;
    let t = [];
    if (this._config.parent && (t = this._getFirstLevelChildren(Wr).filter((a) => a !== this._element).map((a) => ze.getOrCreateInstance(a, { toggle: !1 }))), t.length && t[0]._isTransitioning || R.trigger(this._element, wr).defaultPrevented)
      return;
    for (const a of t)
      a.hide();
    const n = this._getDimension();
    this._element.classList.remove(fe), this._element.classList.add(di), this._element.style[n] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
    const u = () => {
      this._isTransitioning = !1, this._element.classList.remove(di), this._element.classList.add(fe, nn), this._element.style[n] = "", R.trigger(this._element, zr);
    }, o = `scroll${n[0].toUpperCase() + n.slice(1)}`;
    this._queueCallback(u, this._element, !0), this._element.style[n] = `${this._element[o]}px`;
  }
  hide() {
    if (this._isTransitioning || !this._isShown() || R.trigger(this._element, Or).defaultPrevented)
      return;
    const i = this._getDimension();
    this._element.style[i] = `${this._element.getBoundingClientRect()[i]}px`, eu(this._element), this._element.classList.add(di), this._element.classList.remove(fe, nn);
    for (const u of this._triggerArray) {
      const s = ce(u);
      s && !this._isShown(s) && this._addAriaAndCollapsedClass([u], !1);
    }
    this._isTransitioning = !0;
    const n = () => {
      this._isTransitioning = !1, this._element.classList.remove(di), this._element.classList.add(fe), R.trigger(this._element, br);
    };
    this._element.style[i] = "", this._queueCallback(n, this._element, !0);
  }
  _isShown(t = this._element) {
    return t.classList.contains(nn);
  }
  _configAfterMerge(t) {
    return t.toggle = Boolean(t.toggle), t.parent = zi(t.parent), t;
  }
  _getDimension() {
    return this._element.classList.contains(kr) ? Ur : Qr;
  }
  _initializeChildren() {
    if (!this._config.parent)
      return;
    const t = this._getFirstLevelChildren(wn);
    for (const i of t) {
      const n = ce(i);
      n && this._addAriaAndCollapsedClass([i], this._isShown(n));
    }
  }
  _getFirstLevelChildren(t) {
    const i = ct.find(_r, this._config.parent);
    return ct.find(t, this._config.parent).filter((n) => !i.includes(n));
  }
  _addAriaAndCollapsedClass(t, i) {
    if (!!t.length)
      for (const n of t)
        n.classList.toggle(vr, !i), n.setAttribute("aria-expanded", i);
  }
  static jQueryInterface(t) {
    const i = {};
    return typeof t == "string" && /show|hide/.test(t) && (i.toggle = !1), this.each(function() {
      const n = ze.getOrCreateInstance(this, i);
      if (typeof t == "string") {
        if (typeof n[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        n[t]();
      }
    });
  }
}
R.on(document, Yr, wn, function(e) {
  (e.target.tagName === "A" || e.delegateTarget && e.delegateTarget.tagName === "A") && e.preventDefault();
  const t = Vs(this), i = ct.find(t);
  for (const n of i)
    ze.getOrCreateInstance(n, { toggle: !1 }).toggle();
});
Zi(ze);
class Vr extends ze {
}
const Ou = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", bu = ".sticky-top", Si = "padding-right", Yu = "margin-right";
class Gr {
  constructor() {
    this._element = document.body;
  }
  getWidth() {
    const t = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - t);
  }
  hide() {
    const t = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, Si, (i) => i + t), this._setElementAttributes(Ou, Si, (i) => i + t), this._setElementAttributes(bu, Yu, (i) => i - t);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, Si), this._resetElementAttributes(Ou, Si), this._resetElementAttributes(bu, Yu);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(t, i, n) {
    const u = this.getWidth(), s = (o) => {
      if (o !== this._element && window.innerWidth > o.clientWidth + u)
        return;
      this._saveInitialAttribute(o, i);
      const a = window.getComputedStyle(o).getPropertyValue(i);
      o.style.setProperty(i, `${n(Number.parseFloat(a))}px`);
    };
    this._applyManipulationCallback(t, s);
  }
  _saveInitialAttribute(t, i) {
    const n = t.style.getPropertyValue(i);
    n && Re.setDataAttribute(t, i, n);
  }
  _resetElementAttributes(t, i) {
    const n = (u) => {
      const s = Re.getDataAttribute(u, i);
      if (s === null) {
        u.style.removeProperty(i);
        return;
      }
      Re.removeDataAttribute(u, i), u.style.setProperty(i, s);
    };
    this._applyManipulationCallback(t, n);
  }
  _applyManipulationCallback(t, i) {
    if (Ee(t)) {
      i(t);
      return;
    }
    for (const n of ct.find(t, this._element))
      i(n);
  }
}
const no = "backdrop", Zr = "fade", vu = "show", _u = `mousedown.bs.${no}`, Br = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  rootElement: "body"
}, Jr = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class Fr extends nu {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isAppended = !1, this._element = null;
  }
  static get Default() {
    return Br;
  }
  static get DefaultType() {
    return Jr;
  }
  static get NAME() {
    return no;
  }
  show(t) {
    if (!this._config.isVisible) {
      se(t);
      return;
    }
    this._append();
    const i = this._getElement();
    this._config.isAnimated && eu(i), i.classList.add(vu), this._emulateAnimation(() => {
      se(t);
    });
  }
  hide(t) {
    if (!this._config.isVisible) {
      se(t);
      return;
    }
    this._getElement().classList.remove(vu), this._emulateAnimation(() => {
      this.dispose(), se(t);
    });
  }
  dispose() {
    !this._isAppended || (R.off(this._element, _u), this._element.remove(), this._isAppended = !1);
  }
  _getElement() {
    if (!this._element) {
      const t = document.createElement("div");
      t.className = this._config.className, this._config.isAnimated && t.classList.add(Zr), this._element = t;
    }
    return this._element;
  }
  _configAfterMerge(t) {
    return t.rootElement = zi(t.rootElement), t;
  }
  _append() {
    if (this._isAppended)
      return;
    const t = this._getElement();
    this._config.rootElement.append(t), R.on(t, _u, () => {
      se(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(t) {
    Bs(t, this._getElement(), this._config.isAnimated);
  }
}
const Rr = "focustrap", Xr = "bs.focustrap", Oi = `.${Xr}`, Hr = `focusin${Oi}`, Kr = `keydown.tab${Oi}`, qr = "Tab", tl = "forward", ku = "backward", el = {
  autofocus: !0,
  trapElement: null
}, il = {
  autofocus: "boolean",
  trapElement: "element"
};
class nl extends nu {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isActive = !1, this._lastTabNavDirection = null;
  }
  static get Default() {
    return el;
  }
  static get DefaultType() {
    return il;
  }
  static get NAME() {
    return Rr;
  }
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), R.off(document, Oi), R.on(document, Hr, (t) => this._handleFocusin(t)), R.on(document, Kr, (t) => this._handleKeydown(t)), this._isActive = !0);
  }
  deactivate() {
    !this._isActive || (this._isActive = !1, R.off(document, Oi));
  }
  _handleFocusin(t) {
    const { trapElement: i } = this._config;
    if (t.target === document || t.target === i || i.contains(t.target))
      return;
    const n = ct.focusableChildren(i);
    n.length === 0 ? i.focus() : this._lastTabNavDirection === ku ? n[n.length - 1].focus() : n[0].focus();
  }
  _handleKeydown(t) {
    t.key === qr && (this._lastTabNavDirection = t.shiftKey ? ku : tl);
  }
}
const ul = "modal", sl = "bs.modal", pt = `.${sl}`, ol = ".data-api", al = "Escape", Ml = `hide${pt}`, rl = `hidePrevented${pt}`, uo = `hidden${pt}`, so = `show${pt}`, ll = `shown${pt}`, cl = `resize${pt}`, Ll = `click.dismiss${pt}`, jl = `mousedown.dismiss${pt}`, gl = `keydown.dismiss${pt}`, Il = `click${pt}${ol}`, Uu = "modal-open", Nl = "fade", Qu = "show", un = "modal-static", yl = ".modal.show", dl = ".modal-dialog", Sl = ".modal-body", Dl = '[data-bs-toggle="modal"]', Al = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, fl = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
class ge extends Li {
  constructor(t, i) {
    super(t, i), this._dialog = ct.findOne(dl, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new Gr(), this._addEventListeners();
  }
  static get Default() {
    return Al;
  }
  static get DefaultType() {
    return fl;
  }
  static get NAME() {
    return ul;
  }
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    this._isShown || this._isTransitioning || R.trigger(this._element, so, {
      relatedTarget: t
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(Uu), this._adjustDialog(), this._backdrop.show(() => this._showElement(t)));
  }
  hide() {
    !this._isShown || this._isTransitioning || R.trigger(this._element, Ml).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Qu), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    for (const t of [window, this._dialog])
      R.off(t, pt);
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  _initializeBackDrop() {
    return new Fr({
      isVisible: Boolean(this._config.backdrop),
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new nl({
      trapElement: this._element
    });
  }
  _showElement(t) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const i = ct.findOne(Sl, this._dialog);
    i && (i.scrollTop = 0), eu(this._element), this._element.classList.add(Qu);
    const n = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, R.trigger(this._element, ll, {
        relatedTarget: t
      });
    };
    this._queueCallback(n, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    R.on(this._element, gl, (t) => {
      if (t.key === al) {
        if (this._config.keyboard) {
          t.preventDefault(), this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), R.on(window, cl, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), R.on(this._element, jl, (t) => {
      R.one(this._element, Ll, (i) => {
        if (!(this._element !== t.target || this._element !== i.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(Uu), this._resetAdjustments(), this._scrollBar.reset(), R.trigger(this._element, uo);
    });
  }
  _isAnimated() {
    return this._element.classList.contains(Nl);
  }
  _triggerBackdropTransition() {
    if (R.trigger(this._element, rl).defaultPrevented)
      return;
    const i = this._element.scrollHeight > document.documentElement.clientHeight, n = this._element.style.overflowY;
    n === "hidden" || this._element.classList.contains(un) || (i || (this._element.style.overflowY = "hidden"), this._element.classList.add(un), this._queueCallback(() => {
      this._element.classList.remove(un), this._queueCallback(() => {
        this._element.style.overflowY = n;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  _adjustDialog() {
    const t = this._element.scrollHeight > document.documentElement.clientHeight, i = this._scrollBar.getWidth(), n = i > 0;
    if (n && !t) {
      const u = Cu() ? "paddingLeft" : "paddingRight";
      this._element.style[u] = `${i}px`;
    }
    if (!n && t) {
      const u = Cu() ? "paddingRight" : "paddingLeft";
      this._element.style[u] = `${i}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  static jQueryInterface(t, i) {
    return this.each(function() {
      const n = ge.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof n[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        n[t](i);
      }
    });
  }
}
R.on(document, Il, Dl, function(e) {
  const t = ce(this);
  ["A", "AREA"].includes(this.tagName) && e.preventDefault(), R.one(t, so, (u) => {
    u.defaultPrevented || R.one(t, uo, () => {
      Gs(this) && this.focus();
    });
  });
  const i = ct.findOne(yl);
  i && ge.getInstance(i).hide(), ge.getOrCreateInstance(t).toggle(this);
});
Dr(ge);
Zi(ge);
class ou extends ge {
}
const Tl = "tab", El = "bs.tab", Ne = `.${El}`, xl = `hide${Ne}`, Cl = `hidden${Ne}`, pl = `show${Ne}`, hl = `shown${Ne}`, ml = `click${Ne}`, wl = `keydown${Ne}`, zl = `load${Ne}`, Ol = "ArrowLeft", Wu = "ArrowRight", bl = "ArrowUp", Pu = "ArrowDown", Me = "active", $u = "fade", sn = "show", Yl = "dropdown", vl = ".dropdown-toggle", _l = ".dropdown-menu", on = ":not(.dropdown-toggle)", kl = '.list-group, .nav, [role="tablist"]', Ul = ".nav-item, .list-group-item", Ql = `.nav-link${on}, .list-group-item${on}, [role="tab"]${on}`, oo = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', an = `${Ql}, ${oo}`, Wl = `.${Me}[data-bs-toggle="tab"], .${Me}[data-bs-toggle="pill"], .${Me}[data-bs-toggle="list"]`;
class Ie extends Li {
  constructor(t) {
    super(t), this._parent = this._element.closest(kl), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), R.on(this._element, wl, (i) => this._keydown(i)));
  }
  static get NAME() {
    return Tl;
  }
  show() {
    const t = this._element;
    if (this._elemIsActive(t))
      return;
    const i = this._getActiveElem(), n = i ? R.trigger(i, xl, { relatedTarget: t }) : null;
    R.trigger(t, pl, { relatedTarget: i }).defaultPrevented || n && n.defaultPrevented || (this._deactivate(i, t), this._activate(t, i));
  }
  _activate(t, i) {
    if (!t)
      return;
    t.classList.add(Me), this._activate(ce(t));
    const n = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.add(sn);
        return;
      }
      t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), this._toggleDropDown(t, !0), R.trigger(t, hl, {
        relatedTarget: i
      });
    };
    this._queueCallback(n, t, t.classList.contains($u));
  }
  _deactivate(t, i) {
    if (!t)
      return;
    t.classList.remove(Me), t.blur(), this._deactivate(ce(t));
    const n = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.remove(sn);
        return;
      }
      t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, !1), R.trigger(t, Cl, { relatedTarget: i });
    };
    this._queueCallback(n, t, t.classList.contains($u));
  }
  _keydown(t) {
    if (![Ol, Wu, bl, Pu].includes(t.key))
      return;
    t.stopPropagation(), t.preventDefault();
    const i = [Wu, Pu].includes(t.key), n = Js(this._getChildren().filter((u) => !Qe(u)), t.target, i, !0);
    n && (n.focus({ preventScroll: !0 }), Ie.getOrCreateInstance(n).show());
  }
  _getChildren() {
    return ct.find(an, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((t) => this._elemIsActive(t)) || null;
  }
  _setInitialAttributes(t, i) {
    this._setAttributeIfNotExists(t, "role", "tablist");
    for (const n of i)
      this._setInitialAttributesOnChild(n);
  }
  _setInitialAttributesOnChild(t) {
    t = this._getInnerElement(t);
    const i = this._elemIsActive(t), n = this._getOuterElement(t);
    t.setAttribute("aria-selected", i), n !== t && this._setAttributeIfNotExists(n, "role", "presentation"), i || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
  }
  _setInitialAttributesOnTargetPanel(t) {
    const i = ce(t);
    !i || (this._setAttributeIfNotExists(i, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(i, "aria-labelledby", `#${t.id}`));
  }
  _toggleDropDown(t, i) {
    const n = this._getOuterElement(t);
    if (!n.classList.contains(Yl))
      return;
    const u = (s, o) => {
      const a = ct.findOne(s, n);
      a && a.classList.toggle(o, i);
    };
    u(vl, Me), u(_l, sn), n.setAttribute("aria-expanded", i);
  }
  _setAttributeIfNotExists(t, i, n) {
    t.hasAttribute(i) || t.setAttribute(i, n);
  }
  _elemIsActive(t) {
    return t.classList.contains(Me);
  }
  _getInnerElement(t) {
    return t.matches(an) ? t : ct.findOne(an, t);
  }
  _getOuterElement(t) {
    return t.closest(Ul) || t;
  }
  static jQueryInterface(t) {
    return this.each(function() {
      const i = Ie.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (i[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        i[t]();
      }
    });
  }
}
R.on(document, ml, oo, function(e) {
  ["A", "AREA"].includes(this.tagName) && e.preventDefault(), !Qe(this) && Ie.getOrCreateInstance(this).show();
});
R.on(window, zl, () => {
  for (const e of ct.find(Wl))
    Ie.getOrCreateInstance(e);
});
Zi(Ie);
const Pl = "bs.tab", ao = `.${Pl}`, $l = `click${ao}`, Vl = `load${ao}`, Gl = "ArrowLeft", Vu = "ArrowRight", Zl = "ArrowUp", Gu = "ArrowDown", Zu = "Enter", Bu = " ", Mn = "active", Bl = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', Jl = `.${Mn}[data-bs-toggle="tab"], .${Mn}[data-bs-toggle="pill"], .${Mn}[data-bs-toggle="list"]`;
class _t extends Ie {
  constructor(t) {
    super(t);
  }
  _keydown(t) {
    if (![Gl, Vu, Zl, Gu, Zu, Bu].includes(t.key))
      return;
    if (t.stopPropagation(), t.preventDefault(), t.key === Zu || t.key === Bu) {
      _t.getOrCreateInstance(t.target).show();
      return;
    }
    const i = [Vu, Gu].includes(t.key), n = Js(
      this._getChildren().filter((u) => !Qe(u)),
      t.target,
      i,
      !0
    );
    n && n.focus({ preventScroll: !0 });
  }
}
R.on(document, $l, Bl, function(e) {
  if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), Qe(this))
    return;
  _t.getOrCreateInstance(this).dispose(), _t.getOrCreateInstance(this).show();
});
R.on(window, Vl, () => {
  for (const e of ct.find(Jl))
    _t.getOrCreateInstance(e).dispose(), _t.getOrCreateInstance(e);
});
Zi(_t);
const Ju = "data-focus-mouse", Fu = "focus--mouse";
class Mo {
  constructor() {
    this._usingMouse = !1, this._bindEvents();
  }
  _bindEvents() {
    ["keydown", "mousedown"].forEach((i) => {
      document.addEventListener(i, (n) => {
        this._usingMouse = n.type === "mousedown";
      });
    }), document.addEventListener("focusin", (i) => {
      this._usingMouse && i.target && (i.target.classList.add(Fu), i.target.setAttribute(Ju, !0));
    }), document.addEventListener("focusout", (i) => {
      i.target && (i.target.classList.remove(Fu), i.target.setAttribute(Ju, !1));
    });
  }
}
new Mo();
const Fl = "2.3.2", Rl = () => {
  window.BOOTSTRAP_ITALIA_VERSION || (new Mo(), window.BOOTSTRAP_ITALIA_VERSION = Fl);
};
Rl();
const Xl = { class: "splide__track" }, Hl = { class: "splide__list" }, Kl = { class: "it-single-slide-wrapper" }, ql = /* @__PURE__ */ F({
  __name: "KCarousel",
  props: {
    items: null
  },
  setup(e) {
    const t = e, i = k(null);
    let n = null;
    return St(() => {
    }), bo(() => {
    }), jt(() => t.items, (u) => {
      !u || u.length <= 0 || je(() => {
        n != null && (n.dispose(), n = null), n = to.getOrCreateInstance(i.value);
      });
    }, { immediate: !0 }), (u, s) => (d(), A("div", {
      ref_key: "kCarousel",
      ref: i,
      class: "k-carousel it-carousel-wrapper it-carousel-landscape-abstract splide",
      "data-bs-carousel-splide": ""
    }, [
      l("div", Xl, [
        l("ul", Hl, [
          (d(!0), A(gt, null, wt(e.items, (o, a) => (d(), A("li", {
            class: "splide__slide",
            key: a
          }, [
            l("div", Kl, [
              it(u.$slots, "template", { data: o })
            ])
          ]))), 128))
        ])
      ])
    ], 512));
  }
}), tc = ["disabled", "id"], ec = ["for"], ic = /* @__PURE__ */ F({
  __name: "KCheckbox",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { type: Boolean, default: !1 },
    labelText: { default: "" },
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const i = e, n = k();
    jt(
      () => i.modelValue,
      async (o) => {
        n.value = o;
      },
      { immediate: !0 }
    );
    const u = (o) => {
      t("update:modelValue", o.target.checked);
    }, s = (o) => {
      t("change");
    };
    return (o, a) => (d(), A("div", {
      class: J(["form-check", e.formGroupClass])
    }, [
      Mi(l("input", {
        disabled: e.disabled,
        onInput: u,
        "onUpdate:modelValue": a[0] || (a[0] = (M) => n.value = M),
        onChange: s,
        class: J(e.class),
        id: e.id,
        type: "checkbox"
      }, null, 42, tc), [
        [cs, n.value]
      ]),
      l("label", { for: e.id }, Y(e.labelText), 9, ec)
    ], 2));
  }
}), nc = { class: "d-flex align-items-center" }, uc = {
  key: 0,
  class: "text-primary",
  style: { "font-size": "14px" }
}, sc = { class: "d-flex flex-column" }, oc = { class: "d-flex align-items-center" }, ac = /* @__PURE__ */ l("span", { class: "text-primary" }, "Dettaglio", -1), Mc = { class: "d-flex align-items-center" }, rc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Scarica", -1), lc = { class: "d-flex align-items-center" }, cc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Sposta in", -1), Lc = { class: "d-flex align-items-center" }, jc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Condividi", -1), gc = { class: "d-flex align-items-center" }, Ic = /* @__PURE__ */ l("span", { class: "text-primary" }, "Copia link", -1), Nc = { class: "d-flex align-items-center" }, yc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Elimina", -1), dc = { class: "d-flex align-items-center" }, Sc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Rimuovi dallo spazio", -1), Dc = { class: "d-flex align-items-center" }, Ac = /* @__PURE__ */ l("span", { class: "text-primary" }, "Rinomina cartella", -1), fc = { class: "d-flex align-items-center" }, Tc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Sposta cartella in", -1), Ec = { class: "d-flex align-items-center" }, xc = /* @__PURE__ */ l("span", { class: "text-primary" }, "Elimina cartella", -1), Cc = /* @__PURE__ */ F({
  __name: "KDataTableActions",
  props: {
    showActionLabel: { type: Boolean, default: !1 },
    showIcons: { type: Boolean, default: !1 },
    showDetail: { type: Boolean, default: !1 },
    showDownload: { type: Boolean, default: !1 },
    showMove: { type: Boolean, default: !1 },
    showShare: { type: Boolean, default: !1 },
    showCopyLink: { type: Boolean, default: !1 },
    showDelete: { type: Boolean, default: !1 },
    showRemoveFromSpace: { type: Boolean, default: !1 },
    showRenameFolder: { type: Boolean, default: !1 },
    showMoveFolder: { type: Boolean, default: !1 },
    showDeleteFolder: { type: Boolean, default: !1 }
  },
  emits: ["doc-detail", "doc-download", "doc-share", "doc-copylink", "doc-delete", "doc-move", "doc-remove-space", "doc-rename-folder", "doc-move-folder", "doc-delete-folder"],
  setup(e, { emit: t }) {
    const i = e, n = k(), u = k(), s = k(), o = k(), a = k(), M = k(), r = k(), L = k(), c = k(), j = k(), g = k(), I = (h) => {
      n.value.toggle(h), $();
    }, y = () => {
      t("doc-detail");
    }, C = () => {
      t("doc-download");
    }, x = () => {
      t("doc-share");
    }, p = () => {
      t("doc-move");
    }, T = () => {
      t("doc-copylink");
    }, E = () => {
      t("doc-delete");
    }, O = () => {
      t("doc-remove-space");
    }, v = () => {
      t("doc-rename-folder");
    }, V = () => {
      t("doc-move-folder");
    }, Z = () => {
      t("doc-delete-folder");
    }, $ = () => {
      je(() => {
        i.showDetail ? u.value.focus() : i.showDownload ? s.value.focus() : i.showDownload ? o.value.focus() : i.showShare ? a.value.focus() : i.showCopyLink ? M.value.focus() : i.showDelete ? r.value.focus() : i.showRemoveFromSpace ? L.value.focus() : i.showRenameFolder ? c.value.focus() : i.showMoveFolder ? j.value.focus() : i.showDeleteFolder && g.value.focus();
      });
    };
    return (h, Q) => {
      const W = B("KIcon"), w = B("OverlayPanel");
      return d(), A(gt, null, [
        l("button", {
          type: "button",
          class: "btn btn-icon",
          onClick: Q[0] || (Q[0] = (f) => I(f))
        }, [
          l("div", nc, [
            U(W, {
              icon: "it-more-items",
              class: "icon-primary mr-2"
            }),
            e.showActionLabel ? (d(), A("span", uc, "Vedi azioni")) : _("", !0)
          ])
        ]),
        U(w, {
          ref_key: "btnOverlayPanel",
          ref: n,
          class: "menu-panel"
        }, {
          default: X(() => [
            l("div", sc, [
              e.showDetail ? (d(), A("a", {
                key: 0,
                ref_key: "detailButton",
                ref: u,
                href: "#",
                class: "btn btn-xs btn-icon",
                onClick: y
              }, [
                l("div", oc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-search"
                  })) : _("", !0),
                  ac
                ])
              ], 512)) : _("", !0),
              e.showDownload ? (d(), A("button", {
                key: 1,
                ref_key: "moveButton",
                ref: o,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: C
              }, [
                l("div", Mc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-download"
                  })) : _("", !0),
                  rc
                ])
              ], 512)) : _("", !0),
              e.showMove ? (d(), A("button", {
                key: 2,
                ref_key: "shareButton",
                ref: a,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: p
              }, [
                l("div", lc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-chevron-right"
                  })) : _("", !0),
                  cc
                ])
              ], 512)) : _("", !0),
              e.showShare ? (d(), A("button", {
                key: 3,
                ref_key: "shareButton",
                ref: a,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: x
              }, [
                l("div", Lc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-share"
                  })) : _("", !0),
                  jc
                ])
              ], 512)) : _("", !0),
              e.showCopyLink ? (d(), A("button", {
                key: 4,
                ref_key: "copylinkButton",
                ref: M,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: T
              }, [
                l("div", gc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-link"
                  })) : _("", !0),
                  Ic
                ])
              ], 512)) : _("", !0),
              e.showDelete ? (d(), A("button", {
                key: 5,
                ref_key: "deleteButton",
                ref: r,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: E
              }, [
                l("div", Nc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-delete"
                  })) : _("", !0),
                  yc
                ])
              ], 512)) : _("", !0),
              e.showRemoveFromSpace ? (d(), A("button", {
                key: 6,
                ref_key: "removeFromSpaceButton",
                ref: L,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: O
              }, [
                l("div", dc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-close-circle"
                  })) : _("", !0),
                  Sc
                ])
              ], 512)) : _("", !0),
              e.showRenameFolder ? (d(), A("button", {
                key: 7,
                ref_key: "renameFolderButton",
                ref: c,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: v
              }, [
                l("div", Dc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-pencil"
                  })) : _("", !0),
                  Ac
                ])
              ], 512)) : _("", !0),
              e.showMoveFolder ? (d(), A("button", {
                key: 8,
                ref_key: "moveFolderButton",
                ref: j,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: V
              }, [
                l("div", fc, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-chevron-right"
                  })) : _("", !0),
                  Tc
                ])
              ], 512)) : _("", !0),
              e.showDeleteFolder ? (d(), A("button", {
                key: 9,
                ref_key: "deleteFolderButton",
                ref: g,
                type: "button",
                class: "btn btn-xs btn-icon",
                onClick: Z
              }, [
                l("div", Ec, [
                  e.showIcons ? (d(), K(W, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-delete"
                  })) : _("", !0),
                  xc
                ])
              ], 512)) : _("", !0)
            ])
          ]),
          _: 1
        }, 512)
      ], 64);
    };
  }
}), pc = { class: "input-group" }, hc = ["id", "for"], mc = /* @__PURE__ */ F({
  __name: "KDatePicker",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    inputId: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: null },
    labelText: { default: "" },
    class: { default: "" },
    disabled: { type: Boolean },
    dateFormat: { default: "dd/mm/yy" },
    useUTC: { type: Boolean, default: !0 },
    maxDate: { default: null },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const i = e;
    k(null);
    const n = k(), u = k(Math.floor(Math.random() * 65536).toString(16));
    jt(
      () => i.modelValue,
      async (o) => {
        o ? n.value = i.useUTC ? At.utc(o).local().toDate() : o : n.value = null, await je();
        var a = document.getElementById(i.inputId);
        if (new vt(a), !o) {
          var M = document.getElementById(u.value);
          M.classList.remove("active");
        }
      },
      { immediate: !0 }
    ), St(() => {
      var o = document.getElementById(i.inputId);
      new vt(o);
    });
    const s = (o) => {
      if (o) {
        var a = i.useUTC ? At(o).utc(!0).toDate() : o;
        t("update:modelValue", a);
      } else
        t("update:modelValue", null);
    };
    return (o, a) => {
      const M = B("Calendar");
      return d(), A("div", {
        class: J(["form-group", e.formGroupClass])
      }, [
        l("div", pc, [
          l("label", {
            id: u.value,
            for: e.inputId,
            class: "input-label-text"
          }, Y(e.labelText), 9, hc),
          U(M, {
            ref: "kdInputText",
            id: e.id,
            hideOnDateTimeSelect: !0,
            modelValue: n.value,
            "onUpdate:modelValue": [
              a[0] || (a[0] = (r) => n.value = r),
              a[1] || (a[1] = (r) => s(r))
            ],
            class: J(["k-datepicker-input", e.class]),
            inputId: e.inputId,
            "append-to": "self",
            maxDate: e.maxDate,
            selectionMode: "single",
            dateFormat: e.dateFormat,
            showIcon: !0,
            disabled: e.disabled,
            manualInput: !1,
            "show-button-bar": !0
          }, null, 8, ["id", "modelValue", "class", "inputId", "maxDate", "dateFormat", "disabled"])
        ])
      ], 2);
    };
  }
}), We = gs("kappa-global-search-store", {
  state: () => ({
    plugins: Yo([]),
    isSearchGlobalModalOpened: !1,
    results: [],
    searching: !1,
    searchingMore: !1,
    searchText: "",
    resultSourceSelected: [],
    lastSearchResultCount: -1
  }),
  getters: {
    sourcesFilters(e) {
      let t = [];
      return e.plugins.forEach((i) => {
        const n = {
          source: i.source.trim().toUpperCase(),
          resultsCount: e.results.filter((u) => u.source == i.source).length
        };
        t.push(n);
      }), t;
    },
    filteredResults(e) {
      return e.results.filter((i) => e.resultSourceSelected && e.resultSourceSelected.length > 0 ? e.resultSourceSelected.findIndex((n) => n.source == i.source.trim().toUpperCase()) >= 0 : !0);
    },
    totalResultsCount(e) {
      return e.results.length;
    }
  },
  actions: {
    addSearchPlugin(e) {
      if (e == null || e.source == null || e.searchAsync == null || e.source.trim().length == 0)
        throw new Error(`Global plugin not valid! => '${JSON.stringify(e)}'`);
      if (this.plugins.findIndex((t) => t.source.trim().toLowerCase() == e.source.trim().toLowerCase()) > -1)
        throw new Error(`Global plugin already registered for source '${e.source.trim()}'`);
      this.plugins.push(e);
    },
    async executeGlobalSearch(e) {
      let t = [];
      this.searching = !0;
      try {
        this.results = [], this.resultSourceSelected = [];
        let i = [];
        this.plugins.forEach((u) => i.push(u.searchAsync(e))), (await Promise.allSettled(i)).forEach((u) => {
          u.status === "fulfilled" && t.push(...u.value);
        }), this.lastSearchResultCount = t.length, this.results = t;
      } catch (i) {
        console.warn(i);
      } finally {
        this.searching = !1;
      }
      return t;
    },
    async executeGlobalSearchMoreResult() {
      let e = [];
      this.searchingMore = !0;
      try {
        let t = [];
        this.plugins.forEach((n) => t.push(n.loadMoreAsync())), (await Promise.allSettled(t)).forEach((n) => {
          n.status === "fulfilled" && e.push(...n.value);
        }), this.lastSearchResultCount = e.length, this.results.push(...e);
      } catch (t) {
        console.warn(t);
      } finally {
        this.searchingMore = !1;
      }
      return e;
    },
    resetSearch() {
      this.searchText = "", this.results = [], this.resultSourceSelected = [], this.lastSearchResultCount = -1;
    }
  }
}), wc = /* @__PURE__ */ F({
  __name: "KGlobalSearchBar",
  setup(e) {
    const t = We(), i = async () => {
      t.isSearchGlobalModalOpened = !0, await t.executeGlobalSearch(t.searchText);
    };
    return (n, u) => {
      const s = B("KInputText");
      return d(), K(s, {
        icon: "it-search",
        labelText: "Cerca",
        modelValue: b(t).searchText,
        "onUpdate:modelValue": u[0] || (u[0] = (o) => b(t).searchText = o),
        onEnterPressed: i
      }, {
        "append-container": X(() => [
          l("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: i
          }, "Cerca")
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), zc = "data:image/svg+xml;base64,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", Oc = ["xlink:href"], Ot = /* @__PURE__ */ F({
  __name: "KIcon",
  props: {
    class: { default: "" },
    svgStyle: { default: "" },
    icon: { default: "" }
  },
  setup(e) {
    return (t, i) => (d(), A("svg", {
      class: J(["icon", e.class]),
      style: Ft(e.svgStyle)
    }, [
      l("use", {
        "xlink:href": b(zc) + "#" + e.icon
      }, null, 8, Oc)
    ], 6));
  }
}), bc = { class: "chip-label" }, Yc = ["onClick"], vc = { class: "visually-hidden" }, _c = /* @__PURE__ */ F({
  __name: "KInputChips",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: null,
    type: { default: Ge.text },
    labelText: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const i = e, n = k(""), u = k([]);
    jt(
      () => n.value,
      (c) => {
        c && c !== "" && i.type === Ge.email && s();
      }
    ), jt(
      () => i.modelValue,
      (c) => {
        u.value = JSON.parse(JSON.stringify(c));
      }
    );
    const s = () => {
      if (n.value.includes(";") || n.value.includes(",") || n.value.includes(" ")) {
        let c = n.value.split(";");
        c.length == 1 && (c = n.value.split(",")), c.length == 1 && (c = n.value.split(" "));
        let j = 0;
        for (; j <= c.length; )
          c.forEach((g) => {
            a(g), j++;
          });
      }
    }, o = () => {
      a(n.value);
    }, a = (c) => {
      c !== "" && (i.type === Ge.email ? r(c) && (i.modelValue.push(c), n.value = "", M()) : (i.modelValue.push(c), n.value = "", M()));
    }, M = () => {
      t("update:modelValue", JSON.parse(JSON.stringify(i.modelValue)));
    }, r = (c) => !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(c), L = (c) => {
      i.modelValue.splice(i.modelValue.indexOf(c), 1), M();
    };
    return (c, j) => {
      const g = B("KIcon"), I = B("KInputText");
      return d(), A(gt, null, [
        (d(!0), A(gt, null, wt(i.modelValue, (y, C) => (d(), A("div", {
          class: "chip chip-lg alert",
          key: C
        }, [
          i.type === b(Ge).email ? (d(), K(g, {
            key: 0,
            icon: "it-user"
          })) : _("", !0),
          l("span", bc, Y(y), 1),
          l("button", {
            onClick: (x) => L(y)
          }, [
            U(g, { icon: "it-close" }),
            l("span", vc, "Elimina " + Y(y), 1)
          ], 8, Yc)
        ]))), 128)),
        U(I, {
          labelText: i.labelText,
          modelValue: n.value,
          "onUpdate:modelValue": j[0] || (j[0] = (y) => n.value = y),
          formGroupClass: i.labelText !== "" ? "mt-4 mb-0" : "mb-0",
          onEnterPressed: o
        }, null, 8, ["labelText", "modelValue", "formGroupClass"])
      ], 64);
    };
  }
}), kc = { class: "input-group" }, Uc = ["for"], Qc = ["id"], Wc = {
  class: "password-icon",
  "aria-hidden": "true"
}, Pc = /* @__PURE__ */ F({
  __name: "KInputPassword",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const i = e, n = k(null);
    return k(0), jt(
      () => i.modelValue,
      async () => {
        await je(), new vt(n.value);
      }
    ), St(() => {
      new vt(n.value);
    }), (u, s) => {
      const o = B("KIcon");
      return d(), A("div", {
        class: J(["form-group", e.formGroupClass])
      }, [
        l("div", kc, [
          l("label", {
            for: e.id,
            class: "input-label-text"
          }, Y(e.labelText), 9, Uc),
          l("input", {
            type: "password",
            "data-bs-input": "",
            class: "form-control input-password",
            id: e.id
          }, null, 8, Qc),
          l("span", Wc, [
            U(o, {
              class: "password-icon-visible icon icon-sm",
              icon: "it-password-visible"
            }),
            U(o, {
              class: "password-icon-invisible icon icon-sm d-none",
              icon: "it-password-invisible"
            })
          ])
        ])
      ], 2);
    };
  }
}), $c = { class: "d-flex" }, Vc = {
  class: "form-group",
  style: { "flex-grow": "2" }
}, Gc = { class: "input-group" }, Zc = ["onKeyup", "value", "placeholder"], Bc = { class: "input-group-append" }, Jc = /* @__PURE__ */ l("span", { class: "visually-hidden" }, "Cerca", -1), Fc = { class: "form-group" }, Rc = {
  key: 0,
  class: "form-group"
}, Xc = /* @__PURE__ */ F({
  __name: "KInputSearch",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    placeholder: { default: "Cerca per nome, tag, parola chiave" },
    moreFilterButton: { type: Boolean, default: !1 }
  },
  emits: ["search", "morefilterclick", "update:modelValue"],
  setup(e, { emit: t }) {
    const i = k(null), n = () => {
      t("search");
    };
    St(() => {
      new vt(i.value);
    });
    const u = (s) => {
      t("update:modelValue", s.target.value);
    };
    return (s, o) => {
      const a = B("KIcon");
      return d(), A("div", $c, [
        l("div", Vc, [
          l("div", Gc, [
            l("input", {
              type: "search",
              style: { "background-color": "#F4F4F4", color: "#757575" },
              class: "form-control",
              onInput: u,
              onKeyup: re(n, ["enter"]),
              value: e.modelValue,
              ref_key: "kdSearchText",
              ref: i,
              placeholder: e.placeholder
            }, null, 40, Zc),
            l("div", Bc, [
              l("button", {
                type: "button",
                class: "btn",
                style: { padding: "0" },
                onClick: n
              }, [
                U(a, {
                  icon: "it-search",
                  class: "icon-white",
                  style: { "background-color": "#757575", padding: "8px", height: "2.4rem", width: "2.4rem" }
                }),
                Jc
              ])
            ])
          ])
        ]),
        l("div", Fc, [
          it(s.$slots, "default")
        ]),
        e.moreFilterButton ? (d(), A("div", Rc, [
          l("button", {
            type: "button",
            class: "btn btn-outline-primary",
            style: { height: "100%", padding: "10px 20px", "margin-left": "20px" },
            onClick: o[0] || (o[0] = (M) => t("morefilterclick"))
          }, "...")
        ])) : _("", !0)
      ]);
    };
  }
}), Hc = { class: "input-group" }, Kc = {
  key: 0,
  class: "input-group-prepend"
}, qc = { class: "input-group-text" }, tL = ["for"], eL = ["id", "onKeyup", "value", "readonly"], iL = { class: "input-group-append" }, nL = /* @__PURE__ */ F({
  __name: "KInputText",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    icon: null,
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(e, { emit: t }) {
    const i = e, n = k(null);
    k(0), jt(
      () => i.modelValue,
      async () => {
        await je(), new vt(n.value);
      }
    ), St(() => {
      new vt(n.value);
    });
    const u = (o) => {
      t("update:modelValue", o.target.value);
    }, s = () => {
      t("enter-pressed");
    };
    return (o, a) => {
      const M = B("KIcon");
      return d(), A("div", {
        class: J(["form-group", e.formGroupClass])
      }, [
        l("div", Hc, [
          e.icon ? (d(), A("div", Kc, [
            l("div", qc, [
              U(M, {
                class: "icon-sm",
                icon: e.icon
              }, null, 8, ["icon"])
            ])
          ])) : _("", !0),
          l("label", {
            for: e.id,
            class: "input-label-text"
          }, Y(e.labelText), 9, tL),
          l("input", {
            type: "text",
            class: J(["form-control input-control-text", i.class]),
            id: e.id,
            ref_key: "kdInputText",
            ref: n,
            onInput: u,
            onKeyup: re(s, ["enter"]),
            value: e.modelValue,
            readonly: i.readonly
          }, null, 42, eL),
          l("div", iL, [
            it(o.$slots, "append-container")
          ])
        ])
      ], 2);
    };
  }
}), uL = ["for"], sL = ["id", "value", "placeholder", "readonly"], oL = /* @__PURE__ */ F({
  __name: "KInputTextArea",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    textClass: { default: "" },
    class: { default: "" },
    placeholder: { default: "" },
    labelText: { default: "" },
    labelClass: { default: "" },
    labelStyle: { default: "" },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const i = e, n = k(null);
    St(() => {
      new vt(n.value);
    });
    const u = (s) => {
      t("update:modelValue", s.target.value);
    };
    return (s, o) => (d(), A("div", {
      class: J(["form-group", i.class])
    }, [
      l("label", {
        for: e.id,
        class: J(["input-label-text", i.labelClass]),
        style: Ft(e.labelStyle)
      }, Y(e.labelText), 15, uL),
      l("textarea", {
        class: J(i.textClass),
        id: e.id,
        ref_key: "kdInputTextArea",
        ref: n,
        onInput: u,
        value: e.modelValue,
        placeholder: e.placeholder,
        readonly: i.readonly
      }, null, 42, sL)
    ], 2));
  }
});
const Ji = (e, t) => {
  const i = e.__vccOpts || e;
  for (const [n, u] of t)
    i[n] = u;
  return i;
}, aL = /* @__PURE__ */ Ji(oL, [["__scopeId", "data-v-3460bd0e"]]), ML = { class: "d-flex justify-content-center" }, rL = { class: "card rounded bg-primary mr-4" }, lL = { class: "card-body" }, cL = ["href"], LL = { class: "d-flex justify-content-center" }, jL = { class: "d-flex justify-content-center" }, gL = { class: "fw-bold text-white text-nowrap" }, IL = { class: "d-flex justify-content-center" }, NL = { class: "d-flex justify-content-center" }, yL = { class: "fw-bold text-white text-nowrap" }, dL = /* @__PURE__ */ F({
  __name: "KLinkCarousel",
  props: {
    items: null,
    numVisible: { default: 3 },
    numScroll: { default: 3 },
    title: { default: "" }
  },
  setup(e) {
    return (t, i) => {
      const n = B("router-link"), u = B("Carousel");
      return d(), K(u, {
        value: e.items,
        numVisible: e.numVisible,
        numScroll: e.numScroll,
        showIndicators: !1
      }, {
        header: X(() => [
          e.title ? (d(), K(b(lo), {
            key: 0,
            title: e.title
          }, null, 8, ["title"])) : _("", !0)
        ]),
        item: X((s) => [
          l("div", ML, [
            l("div", rL, [
              l("div", lL, [
                s.data.openExternal ? (d(), A("a", {
                  key: 0,
                  href: s.data.link,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }, [
                  l("div", LL, [
                    U(Ot, {
                      icon: s.data.icon,
                      class: "icon-white icon-lg pb-2"
                    }, null, 8, ["icon"])
                  ]),
                  l("div", jL, [
                    l("p", gL, Y(s.data.text), 1)
                  ])
                ], 8, cL)) : (d(), K(n, {
                  key: 1,
                  to: s.data.link
                }, {
                  default: X(() => [
                    l("div", IL, [
                      U(Ot, {
                        icon: s.data.icon,
                        class: "icon-white icon-lg pb-2"
                      }, null, 8, ["icon"])
                    ]),
                    l("div", NL, [
                      l("p", yL, Y(s.data.text), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["value", "numVisible", "numScroll"]);
    };
  }
}), SL = { class: "modal-dialog" }, DL = { class: "modal-content" }, AL = { class: "modal-header" }, fL = {
  class: "modal-title h5 no_toc",
  id: "modalCenterTitle"
}, TL = {
  key: 0,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, EL = { class: "modal-body" }, xL = { class: "modal-footer" }, CL = /* @__PURE__ */ F({
  __name: "KModalCenter",
  props: {
    title: { default: "" },
    closeButton: { type: Boolean, default: !0 },
    modelValue: { type: Boolean }
  },
  emits: ["closed", "update:modelValue"],
  setup(e, { emit: t }) {
    const i = e, n = k(null);
    let u = null;
    St(() => {
      u = ou.getOrCreateInstance(n.value, {
        keyboard: !1,
        backdrop: "static"
      }), u && u._element && u._element.addEventListener("hidden.bs.modal", function(a) {
        t("update:modelValue", !1), t("closed");
      });
    }), Un(() => {
      u && u.dispose();
    }), jt(() => i.modelValue, (a) => {
      a === !0 ? s() : o();
    });
    const s = () => {
      u && u.show();
    }, o = () => {
      u && u.hide();
    };
    return (a, M) => {
      const r = B("KIcon");
      return d(), A("div", {
        ref_key: "modalCenter",
        ref: n,
        class: "modal it-dialog-scrollable fade",
        tabindex: "-1",
        role: "dialog",
        id: "modalcenter",
        "aria-labelledby": "modalCenterTitle",
        "aria-hidden": "true"
      }, [
        l("div", SL, [
          l("div", DL, [
            l("div", AL, [
              l("h2", fL, Y(e.title), 1),
              e.closeButton ? (d(), A("button", TL, [
                U(r, { icon: "it-close" })
              ])) : _("", !0)
            ]),
            l("div", EL, [
              it(a.$slots, "default")
            ]),
            l("div", xL, [
              it(a.$slots, "actions")
            ])
          ])
        ])
      ], 512);
    };
  }
}), pL = {
  class: "modal-dialog",
  role: "document"
}, hL = { class: "modal-content perfect-scrollbar" }, mL = {
  class: "modal-body",
  style: { "padding-bottom": "50px" }
}, wL = { class: "container" }, zL = { class: "row variable-gutters" }, OL = { class: "col" }, bL = { class: "modal-title" }, YL = {
  class: "search-link d-md-none",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#search-modal",
  "aria-label": "Chiudi e torna alla pagina precedente",
  "data-focus-mouse": "false"
}, vL = {
  class: "search-link d-none d-md-block",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#search-modal",
  "aria-label": "Chiudi e torna alla pagina precedente"
}, _L = { class: "modal-body" }, ro = /* @__PURE__ */ F({
  __name: "KModalFullPage",
  props: {
    modelValue: { type: Boolean },
    title: { default: "-" }
  },
  emits: ["closed", "update:modelValue"],
  setup(e, { emit: t }) {
    const i = e;
    We();
    const n = "kmodal_" + Math.floor(Math.random() * 65536).toString(16);
    let u = null;
    St(() => {
      const a = document.getElementById(n);
      u = ou.getOrCreateInstance(a, {
        keyboard: !1,
        backdrop: "static",
        focus: !0
      }), u && u._element && u._element.addEventListener("hidden.bs.modal", function(M) {
        t("update:modelValue", !1), t("closed");
      });
    }), Un(() => {
      u && u.dispose();
    }), jt(() => i.modelValue, (a) => {
      a === !0 ? s() : o();
    });
    const s = () => {
      u && u.show();
    }, o = () => {
      u && u.hide();
    };
    return (a, M) => (d(), K(vo, { to: "body" }, [
      l("div", {
        id: n,
        class: "modal fade search-modal",
        tabindex: "-1",
        "data-focus-mouse": "false",
        style: { display: "none" },
        "aria-hidden": "true"
      }, [
        l("div", pL, [
          l("div", hL, [
            l("div", mL, [
              l("div", wL, [
                l("div", zL, [
                  l("div", OL, [
                    l("div", bL, [
                      l("button", YL, [
                        U(Ot, {
                          class: "icon-md",
                          icon: "it-arrow-left"
                        })
                      ]),
                      l("h2", null, Y(e.title), 1),
                      l("button", vL, [
                        U(Ot, { icon: "it-close-big" })
                      ])
                    ]),
                    l("div", _L, [
                      it(a.$slots, "default")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]));
  }
}), kL = { class: "modal-content" }, UL = {
  key: 0,
  class: "modal-header"
}, QL = {
  class: "modal-title h5 no_toc",
  id: "modalrightTitle"
}, WL = {
  key: 0,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, PL = { class: "modal-footer" }, $L = /* @__PURE__ */ F({
  __name: "KModalSlide",
  props: {
    title: null,
    modelValue: { type: Boolean },
    showHeader: { type: Boolean, default: !0 },
    closeButton: { type: Boolean, default: !0 },
    bodyStyle: { default: null },
    dimension: { default: Ze.lg }
  },
  emits: ["closed", "update:modelValue"],
  setup(e, { emit: t }) {
    const i = e, n = k(null);
    let u = null;
    St(() => {
      u = ou.getOrCreateInstance(n.value, {
        keyboard: !1
      }), u && u._element && u._element.addEventListener("hidden.bs.modal", function(M) {
        t("update:modelValue", !1), t("closed");
      });
    }), Un(() => {
      u && u.dispose();
    }), jt(() => i.modelValue, (M) => {
      M === !0 ? s() : o();
    });
    const s = () => {
      u && u.show();
    }, o = () => {
      u && u.hide();
    }, a = et(
      () => {
        let M = {
          width: "70vw!important",
          "max-width": "70vw!important"
        };
        switch (i.dimension) {
          case Ze.sm:
            M = {
              width: "30vw!important",
              "max-width": "30vw!important"
            };
            break;
          case Ze.lg:
            M = {
              width: "50vw!important",
              "max-width": "50vw!important"
            };
            break;
          case Ze.xl:
            M = {
              width: "70vw!important",
              "max-width": "70vw!important"
            };
            break;
        }
        return M;
      }
    );
    return (M, r) => {
      const L = B("KIcon");
      return d(), A("div", {
        ref_key: "modal",
        ref: n,
        class: "modal it-dialog-scrollable fade",
        tabindex: "-1",
        role: "dialog",
        id: "modalright",
        "aria-labelledby": "modalrightTitle"
      }, [
        l("div", {
          class: "modal-dialog modal-dialog-right",
          style: Ft(b(a)),
          role: "document"
        }, [
          l("div", kL, [
            e.showHeader ? (d(), A("div", UL, [
              l("h2", QL, Y(e.title), 1),
              e.closeButton ? (d(), A("button", WL, [
                U(L, { icon: "it-close" })
              ])) : _("", !0)
            ])) : _("", !0),
            l("div", {
              style: Ft(e.bodyStyle),
              class: "modal-body"
            }, [
              it(M.$slots, "default")
            ], 4),
            l("div", PL, [
              it(M.$slots, "actions")
            ])
          ])
        ], 4)
      ], 512);
    };
  }
}), VL = ["aria-label"], GL = { class: "pagination justify-content-center" }, ZL = {
  class: "page-link",
  href: "#"
}, BL = /* @__PURE__ */ l("span", { class: "visually-hidden" }, "Pagina precedente", -1), JL = /* @__PURE__ */ l("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), FL = {
  key: 2,
  class: "page-item"
}, RL = /* @__PURE__ */ l("span", { class: "page-link" }, "...", -1), XL = [
  RL
], HL = {
  key: 0,
  class: "page-link",
  href: "#",
  "aria-current": "page"
}, KL = /* @__PURE__ */ l("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), qL = ["onClick"], tj = {
  key: 3,
  class: "page-item"
}, ej = /* @__PURE__ */ l("span", { class: "page-link" }, "...", -1), ij = [
  ej
], nj = {
  key: 4,
  class: "page-item"
}, uj = /* @__PURE__ */ l("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), sj = {
  key: 5,
  class: "page-item"
}, oj = /* @__PURE__ */ l("span", { class: "visually-hidden" }, "Pagina successiva", -1), aj = { key: 0 }, Mj = /* @__PURE__ */ F({
  __name: "KPaginator",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    arialabel: { default: "Paginatore tabella" },
    class: { default: "" },
    currentPage: { default: 1 },
    totalPages: { default: 0 },
    totalCount: { default: 0 },
    nearPages: { default: 2 },
    showTotalCount: { type: Boolean, default: !1 }
  },
  emits: ["page-selected"],
  setup(e, { emit: t }) {
    const i = e;
    k(0);
    const n = () => {
      t("page-selected", i.currentPage + 1);
    }, u = () => {
      t("page-selected", i.currentPage - 1);
    }, s = (j) => {
      t("page-selected", j);
    }, o = et(() => {
      var j = i.class;
      return i.showTotalCount && (j = j + " pagination-total"), j;
    }), a = et(() => i.currentPage - i.nearPages > 2), M = et(() => i.currentPage + i.nearPages < i.totalPages - 1), r = et(() => i.currentPage < i.totalPages), L = et(() => i.currentPage > 1), c = et(() => {
      var j = i.currentPage - i.nearPages, g = i.currentPage + i.nearPages, I = [];
      for (let y = j; y <= g; y++)
        y > 1 && y < i.totalPages && I.push(y);
      return I;
    });
    return (j, g) => (d(), A("nav", {
      class: J(["pagination-wrapper justify-content-center d-flex", b(o)]),
      "aria-label": e.arialabel
    }, [
      l("ul", GL, [
        b(L) ? (d(), A("li", {
          key: 0,
          class: "page-item",
          onClick: u
        }, [
          l("a", ZL, [
            U(b(Ot), { icon: "it-chevron-left" }),
            BL
          ])
        ])) : _("", !0),
        e.totalCount > 0 ? (d(), A("li", {
          key: 1,
          class: J(["page-item", [{ active: e.currentPage === 1 }]])
        }, [
          e.currentPage === 1 ? (d(), A("a", {
            key: 0,
            class: "page-link",
            href: "#",
            "aria-current": "page",
            onClick: g[0] || (g[0] = (I) => s(1))
          }, [
            JL,
            nt(Y(1))
          ])) : (d(), A("a", {
            key: 1,
            class: "page-link",
            href: "#",
            onClick: g[1] || (g[1] = (I) => s(1))
          }, Y(1)))
        ], 2)) : _("", !0),
        b(a) ? (d(), A("li", FL, XL)) : _("", !0),
        (d(!0), A(gt, null, wt(b(c), (I) => (d(), A("li", {
          key: I,
          class: J(["page-item", [{ active: e.currentPage === I }]])
        }, [
          e.currentPage === I ? (d(), A("a", HL, [
            KL,
            nt(Y(I), 1)
          ])) : (d(), A("a", {
            key: 1,
            class: "page-link",
            href: "#",
            onClick: (y) => s(I)
          }, Y(I), 9, qL))
        ], 2))), 128)),
        b(M) ? (d(), A("li", tj, ij)) : _("", !0),
        e.totalPages > 1 ? (d(), A("li", nj, [
          e.currentPage === e.totalPages ? (d(), A("a", {
            key: 0,
            class: "page-link",
            href: "#",
            "aria-current": "page",
            onClick: g[2] || (g[2] = (I) => s(e.totalPages))
          }, [
            uj,
            nt(Y(e.totalPages), 1)
          ])) : (d(), A("a", {
            key: 1,
            class: "page-link",
            href: "#",
            onClick: g[3] || (g[3] = (I) => s(e.totalPages))
          }, Y(e.totalPages), 1))
        ])) : _("", !0),
        b(r) ? (d(), A("li", sj, [
          l("a", {
            class: "page-link",
            href: "#",
            onClick: n
          }, [
            oj,
            U(b(Ot), { icon: "it-chevron-right" })
          ])
        ])) : _("", !0)
      ]),
      e.showTotalCount ? (d(), A("p", aj, "Totale " + Y(e.totalCount) + " elementi ", 1)) : _("", !0)
    ], 10, VL));
  }
}), rj = { class: "row" }, lj = { class: "col-12 col-lg-4" }, cj = {
  "data-bs-toggle": "sticky",
  "data-bs-stackable": "false",
  "data-bs-padding-top": "120"
}, Lj = {
  class: "navbar it-navscroll-wrapper navbar-expand-lg it-bottom-navscroll it-right-side",
  "data-bs-navscroll": ""
}, jj = /* @__PURE__ */ l("button", {
  class: "custom-navbar-toggler",
  type: "button",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation",
  "data-bs-toggle": "navbarcollapsible",
  "data-bs-target": "#navbarNav",
  "data-focus-mouse": "false"
}, [
  /* @__PURE__ */ l("span", { class: "it-list" }),
  /* @__PURE__ */ nt(" 1. Introduzione ")
], -1), gj = /* @__PURE__ */ l("div", { class: "progress custom-navbar-progressbar" }, [
  /* @__PURE__ */ l("div", {
    class: "progress-bar it-navscroll-progressbar",
    role: "progressbar",
    "aria-valuenow": "0",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: { width: "0%" }
  })
], -1), Ij = {
  class: "navbar-collapsable",
  id: "navbarNav",
  style: { display: "none" },
  "aria-hidden": "true"
}, Nj = /* @__PURE__ */ l("div", {
  class: "overlay fade",
  style: { display: "none" }
}, null, -1), yj = {
  class: "it-back-button",
  href: "#",
  role: "button"
}, dj = /* @__PURE__ */ l("span", null, "Indietro", -1), Sj = { class: "menu-wrapper" }, Dj = { class: "link-list-wrapper" }, Aj = /* @__PURE__ */ l("div", { class: "progress" }, [
  /* @__PURE__ */ l("div", {
    class: "progress-bar it-navscroll-progressbar",
    role: "progressbar",
    "aria-valuenow": "0",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: { width: "0%" }
  })
], -1), fj = { class: "link-list" }, Tj = ["href"], Ej = { class: "col-12 col-lg-8 it-page-sections-container" }, xj = /* @__PURE__ */ F({
  __name: "KNavScroll",
  props: {
    headerText: { default: "Header" }
  },
  setup(e) {
    const t = Qn({
      items: []
    });
    return Zt("navScrollProvider", t), Zt("addItem", (i) => {
      t.items.push(i);
    }), Zt("updateItem", (i, n) => {
      let u = t.items.findIndex((s) => s.computedId === i);
      n.isActive = t.items[u].isActive, t.items[u] = n;
    }), Zt("deleteItem", (i) => {
      let n = t.items.findIndex((u) => u.computedId === i);
      t.items.splice(n, 1);
    }), (i, n) => {
      const u = B("KIcon");
      return d(), A("div", rj, [
        l("div", lj, [
          l("div", cj, [
            l("nav", Lj, [
              jj,
              gj,
              l("div", Ij, [
                Nj,
                l("a", yj, [
                  U(u, {
                    icon: "it-chevron-left",
                    class: "icon-sm icon-primary align-top"
                  }),
                  dj
                ]),
                l("div", Sj, [
                  l("div", Dj, [
                    l("h3", null, Y(e.headerText), 1),
                    Aj,
                    l("ul", fj, [
                      (d(!0), A(gt, null, wt(t.items, (s, o) => (d(), A("li", {
                        key: o,
                        class: "nav-item"
                      }, [
                        l("a", {
                          class: "nav-link",
                          href: s.hash,
                          "data-focus-mouse": "false"
                        }, [
                          l("span", null, Y(s.header), 1)
                        ], 8, Tj)
                      ]))), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        l("div", Ej, [
          it(i.$slots, "default")
        ])
      ]);
    };
  }
}), Cj = ["id"], pj = /* @__PURE__ */ F({
  __name: "KNavScrollItem",
  props: {
    id: null,
    name: null
  },
  setup(e) {
    const t = e, i = Bt("navScrollProvider"), n = Bt("addItem"), u = Bt("updateItem"), s = Bt("deleteItem"), o = t.name, a = t.id ? t.id : t.name.toLowerCase().replace(/ /g, "-"), M = "#" + a;
    return jt(() => Object.assign({}, t), () => {
      u(a, {
        name: t.name,
        header: t.name,
        hash: M,
        index: i.items.length,
        computedId: a
      });
    }), Ls(() => {
      n({
        name: t.name,
        header: o,
        hash: M,
        index: i.items.length,
        computedId: a
      });
    }), ki(() => {
      s(a);
    }), (r, L) => (d(), A(gt, null, [
      l("h2", {
        class: "it-page-section",
        id: b(a)
      }, Y(e.name), 9, Cj),
      it(r.$slots, "default")
    ], 64));
  }
}), hj = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center" }, mj = { class: "mr-2 fw-bold" }, wj = /* @__PURE__ */ F({
  __name: "KNotificationCard",
  props: {
    title: { default: "" },
    body: { default: "" },
    level: { default: Ti.info },
    showPrimaryButton: { type: Boolean, default: !1 },
    showSecondaryButton: { type: Boolean, default: !1 },
    primaryButton: { default: null },
    secondaryButton: { default: null }
  },
  setup(e) {
    const t = e, i = et(() => t.primaryButton && t.primaryButton.label ? t.primaryButton.label : ""), n = et(() => t.secondaryButton && t.secondaryButton.label ? t.secondaryButton.label : ""), u = et(() => t.secondaryButton && t.secondaryButton.class ? t.secondaryButton.class : ""), s = et(() => t.primaryButton && t.primaryButton.class ? t.primaryButton.class : ""), o = et(() => !!t.primaryButton), a = et(() => !!t.primaryButton);
    return (M, r) => (d(), A("div", {
      class: J(["alert k-notification-card mb-3", [b(a) || b(o) ? "alert-icon" : "", t.level != b(Ti).info && t.level != b(Ti).success ? `alert-${t.level.toString()}` : "alert-default"]]),
      role: "alert"
    }, [
      l("div", hj, [
        l("div", null, [
          it(M.$slots, "pre-info-title"),
          l("b", mj, Y(t.title), 1),
          nt(" " + Y(t.body), 1)
        ]),
        l("div", null, [
          e.showPrimaryButton ? (d(), A("button", {
            key: 0,
            type: "button",
            class: J(["btn btn-primary btn-xs float-end px-5", b(s)]),
            onClick: r[0] || (r[0] = (L) => M.$emit("on-primary-button-click"))
          }, [
            it(M.$slots, "primary-button-content", {}, () => [
              nt(Y(b(i)), 1)
            ])
          ], 2)) : _("", !0),
          e.showSecondaryButton ? (d(), A("button", {
            key: 1,
            type: "button",
            class: J(["btn btn-outline-primary btn-xs float-end px-5 mt-md-1 mt-xl-0 me-xl-3 me-md-0 me-1", b(u)]),
            onClick: r[1] || (r[1] = (L) => M.$emit("on-secondary-button-click"))
          }, [
            it(M.$slots, "secondary-button-content", {}, () => [
              nt(Y(b(n)), 1)
            ])
          ], 2)) : _("", !0)
        ])
      ])
    ], 2));
  }
}), zj = { class: "form-check" }, Oj = ["name", "value", "disabled", "id"], bj = ["for"], Yj = /* @__PURE__ */ F({
  __name: "KRadioButton",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: !1 },
    value: null,
    labelText: { default: "" },
    groupName: null,
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const i = e, n = k();
    jt(
      () => i.modelValue,
      async (o) => {
        n.value = o;
      },
      { immediate: !0 }
    );
    const u = (o) => {
      t("update:modelValue", o.target.value);
    }, s = (o) => {
      t("change");
    };
    return (o, a) => (d(), A("div", zj, [
      Mi(l("input", {
        name: e.groupName,
        value: e.value,
        disabled: e.disabled,
        onInput: u,
        "onUpdate:modelValue": a[0] || (a[0] = (M) => n.value = M),
        onChange: s,
        class: J(e.class),
        id: e.id,
        type: "radio"
      }, null, 42, Oj), [
        [_o, n.value]
      ]),
      l("label", { for: e.id }, Y(e.labelText), 9, bj)
    ]));
  }
}), vj = { class: "fw-bold" }, lo = /* @__PURE__ */ F({
  __name: "KSectionHeader",
  props: {
    title: { default: "" },
    rowClass: { default: "" },
    startClass: { default: "" },
    endClass: { default: "" }
  },
  setup(e) {
    return (t, i) => (d(), A("div", {
      class: J(["d-flex align-items-center mb-2", e.rowClass])
    }, [
      l("div", {
        class: J(e.startClass)
      }, [
        l("h4", vj, Y(e.title), 1)
      ], 2),
      l("div", {
        class: J(["ms-auto", e.endClass])
      }, [
        it(t.$slots, "end")
      ], 2)
    ], 2));
  }
}), _j = { class: "select-wrapper" }, kj = ["for"], Uj = ["disabled", "id"], Qj = ["selected", "value"], Wj = /* @__PURE__ */ F({
  __name: "KSelect",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    disabled: { type: Boolean, default: !1 },
    options: null
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const i = e, n = k();
    jt(
      () => i.modelValue,
      (o) => {
        n.value = o;
      },
      { immediate: !0 }
    ), St(() => {
    });
    const u = (o) => {
      const a = o.target.options[o.target.selectedIndex]._value;
      t("update:modelValue", a), t("change", a);
    }, s = (o) => o.value == n.value;
    return (o, a) => (d(), A("div", {
      class: J(["form-group", e.formGroupClass])
    }, [
      l("div", _j, [
        l("label", {
          for: e.id,
          class: "k-select-label-text"
        }, Y(e.labelText), 9, kj),
        l("select", {
          disabled: i.disabled,
          onChange: u,
          class: J(["k-select-control-text", i.class]),
          id: e.id
        }, [
          (d(!0), A(gt, null, wt(i.options, (M) => (d(), A("option", {
            selected: s(M),
            value: M.value,
            key: M.value
          }, Y(M.name), 9, Qj))), 128))
        ], 42, Uj)
      ])
    ], 2));
  }
}), Pj = {
  key: 0,
  class: "d-flex justify-content-center",
  style: { "min-height": "72px" }
}, $j = /* @__PURE__ */ l("div", { class: "progress-spinner-inner" }, null, -1), Vj = /* @__PURE__ */ l("div", { class: "progress-spinner-inner" }, null, -1), Gj = /* @__PURE__ */ l("span", { class: "visually-hidden" }, "Caricamento...", -1), Zj = [
  $j,
  Vj,
  Gj
], Bj = { key: 1 }, au = /* @__PURE__ */ F({
  __name: "KSpinner",
  props: {
    spinnerClass: { default: "" },
    loading: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, i) => e.loading ? (d(), A("div", Pj, [
      l("div", {
        class: J(["progress-spinner progress-spinner-double progress-spinner-active", e.spinnerClass])
      }, Zj, 2)
    ])) : (d(), A("div", Bj, [
      it(t.$slots, "default")
    ]));
  }
}), Jj = { class: "steppers" }, Fj = {
  class: "steppers-header mb-3",
  style: { "background-color": "#f8f8f8" }
}, Rj = { class: "steppers-number" }, Xj = {
  key: 0,
  class: "visually-hidden"
}, Hj = {
  key: 1,
  class: "visually-hidden"
}, Kj = {
  key: 2,
  style: { "font-weight": "600" }
}, qj = {
  key: 4,
  class: "visually-hidden"
}, tg = {
  key: 1,
  class: "k-stepper-title-populated"
}, eg = {
  key: 0,
  class: "k-stepper-inner-title"
}, ig = /* @__PURE__ */ l("br", null, null, -1), ng = { key: 1 }, ug = {
  class: "steppers-index",
  "aria-hidden": "true"
}, sg = /* @__PURE__ */ F({
  __name: "KStepperHeader",
  props: {
    steps: null,
    currentIndex: { default: 1 }
  },
  setup(e) {
    const t = e, i = et(() => t.currentIndex + "/" + t.steps.length);
    return (n, u) => {
      const s = B("KIcon");
      return d(), A("div", Jj, [
        l("ul", Fj, [
          (d(!0), A(gt, null, wt(e.steps, (o) => (d(), A("li", {
            key: o.index,
            class: J([
              { "active no-line": e.currentIndex === o.index },
              { confirmed: e.currentIndex > o.index },
              { "py-1": e.currentIndex > o.index },
              { "py-3": e.currentIndex <= o.index }
            ])
          }, [
            l("table", null, [
              l("tr", null, [
                l("td", null, [
                  l("span", Rj, [
                    e.currentIndex === o.index ? (d(), A("span", Xj, "Step")) : _("", !0),
                    e.currentIndex === o.index ? (d(), A("span", Hj, "Attivo")) : _("", !0),
                    e.currentIndex <= o.index ? (d(), A("span", Kj, Y(o.index), 1)) : _("", !0),
                    e.currentIndex > o.index ? (d(), K(s, {
                      key: 3,
                      class: "steppers-success",
                      icon: "it-check"
                    })) : _("", !0),
                    e.currentIndex > o.index ? (d(), A("span", qj, "Confermato")) : _("", !0)
                  ])
                ]),
                e.currentIndex <= o.index ? (d(), A("td", {
                  key: 0,
                  class: J([{ "k-stepper-title": e.currentIndex === o.index }, { "k-stepper-title-not-populated": e.currentIndex < o.index }])
                }, Y(o.title), 3)) : (d(), A("td", tg, [
                  e.currentIndex > o.index ? (d(), A("span", eg, Y(o.shortTitle), 1)) : _("", !0),
                  ig,
                  e.currentIndex > o.index ? (d(), A("span", ng, Y(o.description), 1)) : _("", !0)
                ]))
              ])
            ])
          ], 2))), 128)),
          l("li", ug, Y(b(i)), 1)
        ])
      ]);
    };
  }
}), og = ["aria-controls", "aria-selected", "href"], ag = {
  key: 0,
  class: "k-tab-counter-highlight bg-primary"
}, Mg = { class: "tab-content" }, rg = /* @__PURE__ */ F({
  __name: "KTabs",
  props: {
    wrapperClass: null,
    navClass: null
  },
  emits: ["changed", "clicked", "to-link"],
  setup(e, { emit: t }) {
    Kt();
    const i = Ui(), n = Qn({
      activeTabHash: "",
      lastActiveTabHash: "",
      tabs: []
    }), u = k(null), s = k([]);
    Zt("tabsProvider", n), Zt("addTab", (a) => {
      n.tabs.push(a);
    }), Zt("updateTab", (a, M) => {
      let r = n.tabs.findIndex((L) => L.computedId === a);
      M.isActive = n.tabs[r].isActive, n.tabs[r] = M;
    }), Zt("deleteTab", (a) => {
      let M = n.tabs.findIndex((r) => r.computedId === a);
      n.tabs.splice(M, 1);
    });
    const o = (a) => n.tabs.find((M) => M.hash === a);
    return St(() => {
      var L;
      if (!n.tabs.length)
        return;
      var a = [].slice.call(u.value.querySelectorAll("a"));
      let M = (L = n.tabs.find((c) => i.matched.some((j) => j.path.includes(c.toLink)))) == null ? void 0 : L.hash, r = !1;
      a.forEach((c) => {
        let j = _t.getOrCreateInstance(c);
        if (s.value.push(j), M)
          M == c.hash && j.show();
        else if (!r) {
          r = !0;
          let g = o(j._element.hash);
          g != null && g.toLink && t("to-link", g.toLink), j.show();
        }
        c.addEventListener("click", (g) => {
          t("clicked", g.currentTarget.hash);
          let I = o(g.currentTarget.hash);
          I != null && I.toLink && t("to-link", I.toLink), t("changed", I);
          var y = document.querySelector(`[href='${g.currentTarget.hash}']`);
          _t.getInstance(y).show();
        });
      });
    }), (a, M) => (d(), A("div", {
      class: J(e.wrapperClass)
    }, [
      l("ul", {
        class: J(["nav nav-tabs", e.navClass]),
        role: "tablist",
        ref_key: "kTab",
        ref: u
      }, [
        (d(!0), A(gt, null, wt(n.tabs, (r, L) => (d(), A("li", {
          key: L,
          class: "nav-item",
          style: { position: "relative" }
        }, [
          l("a", {
            "data-bs-toggle": "tab",
            role: "tab",
            class: J(["nav-link", "px-5", (r.isDisabled, ""), r.isActive ? "active" : ""]),
            "aria-controls": r.hash,
            "aria-selected": r.isActive,
            href: r.hash
          }, Y(r.header), 11, og),
          r.higlightCounter && r.higlightCounter > 0 ? (d(), A("div", ag, Y(r.higlightCounter), 1)) : _("", !0)
        ]))), 128))
      ], 2),
      l("div", Mg, [
        it(a.$slots, "default")
      ])
    ], 2));
  }
}), lg = ["id", "aria-labelledby"], cg = /* @__PURE__ */ F({
  __name: "KTab",
  props: {
    id: null,
    name: null,
    prefix: { default: "" },
    suffix: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    higlightCounter: null,
    toLink: null,
    tabClass: null
  },
  setup(e) {
    const t = e, i = k(null), n = k(!1), u = Bt("tabsProvider"), s = Bt("addTab"), o = Bt("updateTab"), a = Bt("deleteTab"), M = t.prefix + t.name + t.suffix, r = t.id ? t.id : t.name.toLowerCase().replace(/ /g, "-"), L = "#" + (t.isDisabled ? "" : r);
    return jt(
      () => u.activeTabHash,
      () => {
        n.value = L === u.activeTabHash;
      }
    ), jt(() => Object.assign({}, t), () => {
      o(r, {
        name: t.name,
        header: t.prefix + t.name + t.suffix,
        higlightCounter: t.higlightCounter,
        isDisabled: t.isDisabled,
        hash: L,
        toLink: t.toLink,
        index: u.tabs.length,
        computedId: r
      });
    }), Ls(() => {
      s({
        name: t.name,
        header: M,
        higlightCounter: t.higlightCounter,
        isDisabled: t.isDisabled,
        hash: L,
        toLink: t.toLink,
        index: u.tabs.length,
        computedId: r
      });
    }), ki(() => {
      a(r);
    }), St(() => {
    }), (c, j) => (d(), A("div", {
      class: J(["tab-pane p-4 fade", t.tabClass]),
      id: b(r),
      ref_key: "tab",
      ref: i,
      "aria-labelledby": e.id + "-tab",
      role: "tabpanel"
    }, [
      it(c.$slots, "default")
    ], 10, lg));
  }
}), Ru = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  K2ColContainer: La,
  K3ColContainer: ja,
  KBackButton: ga,
  KCard: Ca,
  KCarousel: ql,
  KCheckbox: ic,
  KDataTableActions: Cc,
  KDatePicker: mc,
  KGlobalSearchBar: wc,
  KIcon: Ot,
  KInputChips: _c,
  KInputPassword: Pc,
  KInputText: nL,
  KInputTextArea: aL,
  KInputSearch: Xc,
  KLinkCarousel: dL,
  KModalFullPage: ro,
  KModalSlide: $L,
  KModalCenter: CL,
  KNavScroll: xj,
  KNavScrollItem: pj,
  KNotificationCard: wj,
  KRadioButton: Yj,
  KPaginator: Mj,
  KSelect: Wj,
  KSectionHeader: lo,
  KSpinner: au,
  KStepperHeader: sg,
  KTabs: rg,
  KTab: cg
}, Symbol.toStringTag, { value: "Module" })), Lg = { class: "external-iframe-container" }, jg = ["src"], gg = /* @__PURE__ */ F({
  __name: "ExternalPage",
  setup(e) {
    const t = k(!1), i = Ui(), n = et(() => i.meta.pageTitle), u = et(() => i.meta.pageContent), s = () => {
      t.value = !1, clearTimeout(o);
    };
    let o;
    return St(() => {
      o = setTimeout(() => {
        t.value === !0 && (t.value = !1, console.warn("External page loading timeout.."));
      }, 1e4);
    }), ki(() => clearTimeout(o)), (a, M) => {
      const r = B("PageHeader"), L = B("Page");
      return d(), K(L, { loading: t.value }, {
        default: X(() => [
          U(r, { title: b(n) }, null, 8, ["title"]),
          l("div", Lg, [
            l("iframe", {
              src: b(u),
              onLoad: s,
              class: "external-iframe"
            }, `\r
            `, 40, jg)
          ])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
});
const Ig = /* @__PURE__ */ Ji(gg, [["__scopeId", "data-v-8f51ce9d"]]), Wy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ig
}, Symbol.toStringTag, { value: "Module" })), Ng = { class: "k-layout-centered-wrapper" }, yg = /* @__PURE__ */ F({
  __name: "SplashLayout",
  setup(e) {
    return (t, i) => (d(), A("div", Ng, " Caricamento... "));
  }
}), dg = { class: "k-layout-centered-wrapper" }, Sg = { class: "k-layout-version-badge" }, Dg = /* @__PURE__ */ F({
  __name: "AnonymousLayout",
  setup(e) {
    const t = APP_VERSION;
    return (i, n) => {
      const u = B("router-view");
      return d(), A(gt, null, [
        l("div", dg, [
          U(u)
        ]),
        l("div", Sg, "v. " + Y(b(t)), 1)
      ], 64);
    };
  }
});
var Ag = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, i = Symbol("test"), n = Object(i);
  if (typeof i == "string" || Object.prototype.toString.call(i) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var u = 42;
  t[i] = u;
  for (i in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var s = Object.getOwnPropertySymbols(t);
  if (s.length !== 1 || s[0] !== i || !Object.prototype.propertyIsEnumerable.call(t, i))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(t, i);
    if (o.value !== u || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, Xu = typeof Symbol < "u" && Symbol, fg = Ag, Tg = function() {
  return typeof Xu != "function" || typeof Symbol != "function" || typeof Xu("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : fg();
}, Eg = "Function.prototype.bind called on incompatible ", rn = Array.prototype.slice, xg = Object.prototype.toString, Cg = "[object Function]", pg = function(t) {
  var i = this;
  if (typeof i != "function" || xg.call(i) !== Cg)
    throw new TypeError(Eg + i);
  for (var n = rn.call(arguments, 1), u, s = function() {
    if (this instanceof u) {
      var L = i.apply(
        this,
        n.concat(rn.call(arguments))
      );
      return Object(L) === L ? L : this;
    } else
      return i.apply(
        t,
        n.concat(rn.call(arguments))
      );
  }, o = Math.max(0, i.length - n.length), a = [], M = 0; M < o; M++)
    a.push("$" + M);
  if (u = Function("binder", "return function (" + a.join(",") + "){ return binder.apply(this,arguments); }")(s), i.prototype) {
    var r = function() {
    };
    r.prototype = i.prototype, u.prototype = new r(), r.prototype = null;
  }
  return u;
}, hg = pg, Mu = Function.prototype.bind || hg, mg = Mu, wg = mg.call(Function.call, Object.prototype.hasOwnProperty), q, Oe = SyntaxError, co = Function, xe = TypeError, ln = function(e) {
  try {
    return co('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Le = Object.getOwnPropertyDescriptor;
if (Le)
  try {
    Le({}, "");
  } catch {
    Le = null;
  }
var cn = function() {
  throw new xe();
}, zg = Le ? function() {
  try {
    return arguments.callee, cn;
  } catch {
    try {
      return Le(arguments, "callee").get;
    } catch {
      return cn;
    }
  }
}() : cn, ye = Tg(), Vt = Object.getPrototypeOf || function(e) {
  return e.__proto__;
}, De = {}, Og = typeof Uint8Array > "u" ? q : Vt(Uint8Array), Ce = {
  "%AggregateError%": typeof AggregateError > "u" ? q : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? q : ArrayBuffer,
  "%ArrayIteratorPrototype%": ye ? Vt([][Symbol.iterator]()) : q,
  "%AsyncFromSyncIteratorPrototype%": q,
  "%AsyncFunction%": De,
  "%AsyncGenerator%": De,
  "%AsyncGeneratorFunction%": De,
  "%AsyncIteratorPrototype%": De,
  "%Atomics%": typeof Atomics > "u" ? q : Atomics,
  "%BigInt%": typeof BigInt > "u" ? q : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? q : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? q : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? q : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? q : FinalizationRegistry,
  "%Function%": co,
  "%GeneratorFunction%": De,
  "%Int8Array%": typeof Int8Array > "u" ? q : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? q : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? q : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": ye ? Vt(Vt([][Symbol.iterator]())) : q,
  "%JSON%": typeof JSON == "object" ? JSON : q,
  "%Map%": typeof Map > "u" ? q : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !ye ? q : Vt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? q : Promise,
  "%Proxy%": typeof Proxy > "u" ? q : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? q : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? q : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !ye ? q : Vt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? q : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": ye ? Vt(""[Symbol.iterator]()) : q,
  "%Symbol%": ye ? Symbol : q,
  "%SyntaxError%": Oe,
  "%ThrowTypeError%": zg,
  "%TypedArray%": Og,
  "%TypeError%": xe,
  "%Uint8Array%": typeof Uint8Array > "u" ? q : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? q : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? q : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? q : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? q : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? q : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? q : WeakSet
}, bg = function e(t) {
  var i;
  if (t === "%AsyncFunction%")
    i = ln("async function () {}");
  else if (t === "%GeneratorFunction%")
    i = ln("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    i = ln("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var n = e("%AsyncGeneratorFunction%");
    n && (i = n.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var u = e("%AsyncGenerator%");
    u && (i = Vt(u.prototype));
  }
  return Ce[t] = i, i;
}, Hu = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, gi = Mu, bi = wg, Yg = gi.call(Function.call, Array.prototype.concat), vg = gi.call(Function.apply, Array.prototype.splice), Ku = gi.call(Function.call, String.prototype.replace), Yi = gi.call(Function.call, String.prototype.slice), _g = gi.call(Function.call, RegExp.prototype.exec), kg = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Ug = /\\(\\)?/g, Qg = function(t) {
  var i = Yi(t, 0, 1), n = Yi(t, -1);
  if (i === "%" && n !== "%")
    throw new Oe("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && i !== "%")
    throw new Oe("invalid intrinsic syntax, expected opening `%`");
  var u = [];
  return Ku(t, kg, function(s, o, a, M) {
    u[u.length] = a ? Ku(M, Ug, "$1") : o || s;
  }), u;
}, Wg = function(t, i) {
  var n = t, u;
  if (bi(Hu, n) && (u = Hu[n], n = "%" + u[0] + "%"), bi(Ce, n)) {
    var s = Ce[n];
    if (s === De && (s = bg(n)), typeof s > "u" && !i)
      throw new xe("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: u,
      name: n,
      value: s
    };
  }
  throw new Oe("intrinsic " + t + " does not exist!");
}, ru = function(t, i) {
  if (typeof t != "string" || t.length === 0)
    throw new xe("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof i != "boolean")
    throw new xe('"allowMissing" argument must be a boolean');
  if (_g(/^%?[^%]*%?$/, t) === null)
    throw new Oe("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = Qg(t), u = n.length > 0 ? n[0] : "", s = Wg("%" + u + "%", i), o = s.name, a = s.value, M = !1, r = s.alias;
  r && (u = r[0], vg(n, Yg([0, 1], r)));
  for (var L = 1, c = !0; L < n.length; L += 1) {
    var j = n[L], g = Yi(j, 0, 1), I = Yi(j, -1);
    if ((g === '"' || g === "'" || g === "`" || I === '"' || I === "'" || I === "`") && g !== I)
      throw new Oe("property names with quotes must have matching quotes");
    if ((j === "constructor" || !c) && (M = !0), u += "." + j, o = "%" + u + "%", bi(Ce, o))
      a = Ce[o];
    else if (a != null) {
      if (!(j in a)) {
        if (!i)
          throw new xe("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (Le && L + 1 >= n.length) {
        var y = Le(a, j);
        c = !!y, c && "get" in y && !("originalValue" in y.get) ? a = y.get : a = a[j];
      } else
        c = bi(a, j), a = a[j];
      c && !M && (Ce[o] = a);
    }
  }
  return a;
}, Lo = { exports: {} };
(function(e) {
  var t = Mu, i = ru, n = i("%Function.prototype.apply%"), u = i("%Function.prototype.call%"), s = i("%Reflect.apply%", !0) || t.call(u, n), o = i("%Object.getOwnPropertyDescriptor%", !0), a = i("%Object.defineProperty%", !0), M = i("%Math.max%");
  if (a)
    try {
      a({}, "a", { value: 1 });
    } catch {
      a = null;
    }
  e.exports = function(c) {
    var j = s(t, u, arguments);
    if (o && a) {
      var g = o(j, "length");
      g.configurable && a(
        j,
        "length",
        { value: 1 + M(0, c.length - (arguments.length - 1)) }
      );
    }
    return j;
  };
  var r = function() {
    return s(t, n, arguments);
  };
  a ? a(e.exports, "apply", { value: r }) : e.exports.apply = r;
})(Lo);
var jo = ru, go = Lo.exports, Pg = go(jo("String.prototype.indexOf")), $g = function(t, i) {
  var n = jo(t, !!i);
  return typeof n == "function" && Pg(t, ".prototype.") > -1 ? go(n) : n;
};
const Vg = {}, Gg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vg
}, Symbol.toStringTag, { value: "Module" })), Zg = /* @__PURE__ */ ea(Gg);
var lu = typeof Map == "function" && Map.prototype, Ln = Object.getOwnPropertyDescriptor && lu ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, vi = lu && Ln && typeof Ln.get == "function" ? Ln.get : null, Bg = lu && Map.prototype.forEach, cu = typeof Set == "function" && Set.prototype, jn = Object.getOwnPropertyDescriptor && cu ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, _i = cu && jn && typeof jn.get == "function" ? jn.get : null, Jg = cu && Set.prototype.forEach, Fg = typeof WeakMap == "function" && WeakMap.prototype, Xe = Fg ? WeakMap.prototype.has : null, Rg = typeof WeakSet == "function" && WeakSet.prototype, He = Rg ? WeakSet.prototype.has : null, Xg = typeof WeakRef == "function" && WeakRef.prototype, qu = Xg ? WeakRef.prototype.deref : null, Hg = Boolean.prototype.valueOf, Kg = Object.prototype.toString, qg = Function.prototype.toString, t4 = String.prototype.match, Lu = String.prototype.slice, Jt = String.prototype.replace, e4 = String.prototype.toUpperCase, ts = String.prototype.toLowerCase, Io = RegExp.prototype.test, es = Array.prototype.concat, mt = Array.prototype.join, i4 = Array.prototype.slice, is = Math.floor, zn = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, gn = Object.getOwnPropertySymbols, On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, be = typeof Symbol == "function" && typeof Symbol.iterator == "object", yt = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === be ? "object" : "symbol") ? Symbol.toStringTag : null, No = Object.prototype.propertyIsEnumerable, ns = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function us(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || Io.call(/e/, t))
    return t;
  var i = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var n = e < 0 ? -is(-e) : is(e);
    if (n !== e) {
      var u = String(n), s = Lu.call(t, u.length + 1);
      return Jt.call(u, i, "$&_") + "." + Jt.call(Jt.call(s, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Jt.call(t, i, "$&_");
}
var bn = Zg, ss = bn.custom, os = So(ss) ? ss : null, n4 = function e(t, i, n, u) {
  var s = i || {};
  if (Gt(s, "quoteStyle") && s.quoteStyle !== "single" && s.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (Gt(s, "maxStringLength") && (typeof s.maxStringLength == "number" ? s.maxStringLength < 0 && s.maxStringLength !== 1 / 0 : s.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = Gt(s, "customInspect") ? s.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (Gt(s, "indent") && s.indent !== null && s.indent !== "	" && !(parseInt(s.indent, 10) === s.indent && s.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (Gt(s, "numericSeparator") && typeof s.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var a = s.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return Ao(t, s);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var M = String(t);
    return a ? us(t, M) : M;
  }
  if (typeof t == "bigint") {
    var r = String(t) + "n";
    return a ? us(t, r) : r;
  }
  var L = typeof s.depth > "u" ? 5 : s.depth;
  if (typeof n > "u" && (n = 0), n >= L && L > 0 && typeof t == "object")
    return Yn(t) ? "[Array]" : "[Object]";
  var c = A4(s, n);
  if (typeof u > "u")
    u = [];
  else if (Do(u, t) >= 0)
    return "[Circular]";
  function j(w, f, S) {
    if (f && (u = i4.call(u), u.push(f)), S) {
      var D = {
        depth: s.depth
      };
      return Gt(s, "quoteStyle") && (D.quoteStyle = s.quoteStyle), e(w, D, n + 1, u);
    }
    return e(w, s, n + 1, u);
  }
  if (typeof t == "function" && !as(t)) {
    var g = L4(t), I = Di(t, j);
    return "[Function" + (g ? ": " + g : " (anonymous)") + "]" + (I.length > 0 ? " { " + mt.call(I, ", ") + " }" : "");
  }
  if (So(t)) {
    var y = be ? Jt.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : On.call(t);
    return typeof t == "object" && !be ? $e(y) : y;
  }
  if (d4(t)) {
    for (var C = "<" + ts.call(String(t.nodeName)), x = t.attributes || [], p = 0; p < x.length; p++)
      C += " " + x[p].name + "=" + yo(u4(x[p].value), "double", s);
    return C += ">", t.childNodes && t.childNodes.length && (C += "..."), C += "</" + ts.call(String(t.nodeName)) + ">", C;
  }
  if (Yn(t)) {
    if (t.length === 0)
      return "[]";
    var T = Di(t, j);
    return c && !D4(T) ? "[" + vn(T, c) + "]" : "[ " + mt.call(T, ", ") + " ]";
  }
  if (o4(t)) {
    var E = Di(t, j);
    return !("cause" in Error.prototype) && "cause" in t && !No.call(t, "cause") ? "{ [" + String(t) + "] " + mt.call(es.call("[cause]: " + j(t.cause), E), ", ") + " }" : E.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + mt.call(E, ", ") + " }";
  }
  if (typeof t == "object" && o) {
    if (os && typeof t[os] == "function" && bn)
      return bn(t, { depth: L - n });
    if (o !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (j4(t)) {
    var O = [];
    return Bg.call(t, function(w, f) {
      O.push(j(f, t, !0) + " => " + j(w, t));
    }), Ms("Map", vi.call(t), O, c);
  }
  if (N4(t)) {
    var v = [];
    return Jg.call(t, function(w) {
      v.push(j(w, t));
    }), Ms("Set", _i.call(t), v, c);
  }
  if (g4(t))
    return In("WeakMap");
  if (y4(t))
    return In("WeakSet");
  if (I4(t))
    return In("WeakRef");
  if (M4(t))
    return $e(j(Number(t)));
  if (l4(t))
    return $e(j(zn.call(t)));
  if (r4(t))
    return $e(Hg.call(t));
  if (a4(t))
    return $e(j(String(t)));
  if (!s4(t) && !as(t)) {
    var V = Di(t, j), Z = ns ? ns(t) === Object.prototype : t instanceof Object || t.constructor === Object, $ = t instanceof Object ? "" : "null prototype", h = !Z && yt && Object(t) === t && yt in t ? Lu.call(te(t), 8, -1) : $ ? "Object" : "", Q = Z || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", W = Q + (h || $ ? "[" + mt.call(es.call([], h || [], $ || []), ": ") + "] " : "");
    return V.length === 0 ? W + "{}" : c ? W + "{" + vn(V, c) + "}" : W + "{ " + mt.call(V, ", ") + " }";
  }
  return String(t);
};
function yo(e, t, i) {
  var n = (i.quoteStyle || t) === "double" ? '"' : "'";
  return n + e + n;
}
function u4(e) {
  return Jt.call(String(e), /"/g, "&quot;");
}
function Yn(e) {
  return te(e) === "[object Array]" && (!yt || !(typeof e == "object" && yt in e));
}
function s4(e) {
  return te(e) === "[object Date]" && (!yt || !(typeof e == "object" && yt in e));
}
function as(e) {
  return te(e) === "[object RegExp]" && (!yt || !(typeof e == "object" && yt in e));
}
function o4(e) {
  return te(e) === "[object Error]" && (!yt || !(typeof e == "object" && yt in e));
}
function a4(e) {
  return te(e) === "[object String]" && (!yt || !(typeof e == "object" && yt in e));
}
function M4(e) {
  return te(e) === "[object Number]" && (!yt || !(typeof e == "object" && yt in e));
}
function r4(e) {
  return te(e) === "[object Boolean]" && (!yt || !(typeof e == "object" && yt in e));
}
function So(e) {
  if (be)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !On)
    return !1;
  try {
    return On.call(e), !0;
  } catch {
  }
  return !1;
}
function l4(e) {
  if (!e || typeof e != "object" || !zn)
    return !1;
  try {
    return zn.call(e), !0;
  } catch {
  }
  return !1;
}
var c4 = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function Gt(e, t) {
  return c4.call(e, t);
}
function te(e) {
  return Kg.call(e);
}
function L4(e) {
  if (e.name)
    return e.name;
  var t = t4.call(qg.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function Do(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var i = 0, n = e.length; i < n; i++)
    if (e[i] === t)
      return i;
  return -1;
}
function j4(e) {
  if (!vi || !e || typeof e != "object")
    return !1;
  try {
    vi.call(e);
    try {
      _i.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function g4(e) {
  if (!Xe || !e || typeof e != "object")
    return !1;
  try {
    Xe.call(e, Xe);
    try {
      He.call(e, He);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function I4(e) {
  if (!qu || !e || typeof e != "object")
    return !1;
  try {
    return qu.call(e), !0;
  } catch {
  }
  return !1;
}
function N4(e) {
  if (!_i || !e || typeof e != "object")
    return !1;
  try {
    _i.call(e);
    try {
      vi.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function y4(e) {
  if (!He || !e || typeof e != "object")
    return !1;
  try {
    He.call(e, He);
    try {
      Xe.call(e, Xe);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function d4(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function Ao(e, t) {
  if (e.length > t.maxStringLength) {
    var i = e.length - t.maxStringLength, n = "... " + i + " more character" + (i > 1 ? "s" : "");
    return Ao(Lu.call(e, 0, t.maxStringLength), t) + n;
  }
  var u = Jt.call(Jt.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, S4);
  return yo(u, "single", t);
}
function S4(e) {
  var t = e.charCodeAt(0), i = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return i ? "\\" + i : "\\x" + (t < 16 ? "0" : "") + e4.call(t.toString(16));
}
function $e(e) {
  return "Object(" + e + ")";
}
function In(e) {
  return e + " { ? }";
}
function Ms(e, t, i, n) {
  var u = n ? vn(i, n) : mt.call(i, ", ");
  return e + " (" + t + ") {" + u + "}";
}
function D4(e) {
  for (var t = 0; t < e.length; t++)
    if (Do(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function A4(e, t) {
  var i;
  if (e.indent === "	")
    i = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    i = mt.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: i,
    prev: mt.call(Array(t + 1), i)
  };
}
function vn(e, t) {
  if (e.length === 0)
    return "";
  var i = `
` + t.prev + t.base;
  return i + mt.call(e, "," + i) + `
` + t.prev;
}
function Di(e, t) {
  var i = Yn(e), n = [];
  if (i) {
    n.length = e.length;
    for (var u = 0; u < e.length; u++)
      n[u] = Gt(e, u) ? t(e[u], e) : "";
  }
  var s = typeof gn == "function" ? gn(e) : [], o;
  if (be) {
    o = {};
    for (var a = 0; a < s.length; a++)
      o["$" + s[a]] = s[a];
  }
  for (var M in e)
    !Gt(e, M) || i && String(Number(M)) === M && M < e.length || be && o["$" + M] instanceof Symbol || (Io.call(/[^\w$]/, M) ? n.push(t(M, e) + ": " + t(e[M], e)) : n.push(M + ": " + t(e[M], e)));
  if (typeof gn == "function")
    for (var r = 0; r < s.length; r++)
      No.call(e, s[r]) && n.push("[" + t(s[r]) + "]: " + t(e[s[r]], e));
  return n;
}
var ju = ru, Pe = $g, f4 = n4, T4 = ju("%TypeError%"), Ai = ju("%WeakMap%", !0), fi = ju("%Map%", !0), E4 = Pe("WeakMap.prototype.get", !0), x4 = Pe("WeakMap.prototype.set", !0), C4 = Pe("WeakMap.prototype.has", !0), p4 = Pe("Map.prototype.get", !0), h4 = Pe("Map.prototype.set", !0), m4 = Pe("Map.prototype.has", !0), gu = function(e, t) {
  for (var i = e, n; (n = i.next) !== null; i = n)
    if (n.key === t)
      return i.next = n.next, n.next = e.next, e.next = n, n;
}, w4 = function(e, t) {
  var i = gu(e, t);
  return i && i.value;
}, z4 = function(e, t, i) {
  var n = gu(e, t);
  n ? n.value = i : e.next = {
    key: t,
    next: e.next,
    value: i
  };
}, O4 = function(e, t) {
  return !!gu(e, t);
}, b4 = function() {
  var t, i, n, u = {
    assert: function(s) {
      if (!u.has(s))
        throw new T4("Side channel does not contain " + f4(s));
    },
    get: function(s) {
      if (Ai && s && (typeof s == "object" || typeof s == "function")) {
        if (t)
          return E4(t, s);
      } else if (fi) {
        if (i)
          return p4(i, s);
      } else if (n)
        return w4(n, s);
    },
    has: function(s) {
      if (Ai && s && (typeof s == "object" || typeof s == "function")) {
        if (t)
          return C4(t, s);
      } else if (fi) {
        if (i)
          return m4(i, s);
      } else if (n)
        return O4(n, s);
      return !1;
    },
    set: function(s, o) {
      Ai && s && (typeof s == "object" || typeof s == "function") ? (t || (t = new Ai()), x4(t, s, o)) : fi ? (i || (i = new fi()), h4(i, s, o)) : (n || (n = { key: {}, next: null }), z4(n, s, o));
    }
  };
  return u;
}, Y4 = String.prototype.replace, v4 = /%20/g, Nn = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Iu = {
  default: Nn.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return Y4.call(e, v4, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: Nn.RFC1738,
  RFC3986: Nn.RFC3986
}, _4 = Iu, yn = Object.prototype.hasOwnProperty, oe = Array.isArray, ht = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), k4 = function(t) {
  for (; t.length > 1; ) {
    var i = t.pop(), n = i.obj[i.prop];
    if (oe(n)) {
      for (var u = [], s = 0; s < n.length; ++s)
        typeof n[s] < "u" && u.push(n[s]);
      i.obj[i.prop] = u;
    }
  }
}, fo = function(t, i) {
  for (var n = i && i.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, u = 0; u < t.length; ++u)
    typeof t[u] < "u" && (n[u] = t[u]);
  return n;
}, U4 = function e(t, i, n) {
  if (!i)
    return t;
  if (typeof i != "object") {
    if (oe(t))
      t.push(i);
    else if (t && typeof t == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !yn.call(Object.prototype, i)) && (t[i] = !0);
    else
      return [t, i];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(i);
  var u = t;
  return oe(t) && !oe(i) && (u = fo(t, n)), oe(t) && oe(i) ? (i.forEach(function(s, o) {
    if (yn.call(t, o)) {
      var a = t[o];
      a && typeof a == "object" && s && typeof s == "object" ? t[o] = e(a, s, n) : t.push(s);
    } else
      t[o] = s;
  }), t) : Object.keys(i).reduce(function(s, o) {
    var a = i[o];
    return yn.call(s, o) ? s[o] = e(s[o], a, n) : s[o] = a, s;
  }, u);
}, Q4 = function(t, i) {
  return Object.keys(i).reduce(function(n, u) {
    return n[u] = i[u], n;
  }, t);
}, W4 = function(e, t, i) {
  var n = e.replace(/\+/g, " ");
  if (i === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, P4 = function(t, i, n, u, s) {
  if (t.length === 0)
    return t;
  var o = t;
  if (typeof t == "symbol" ? o = Symbol.prototype.toString.call(t) : typeof t != "string" && (o = String(t)), n === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(L) {
      return "%26%23" + parseInt(L.slice(2), 16) + "%3B";
    });
  for (var a = "", M = 0; M < o.length; ++M) {
    var r = o.charCodeAt(M);
    if (r === 45 || r === 46 || r === 95 || r === 126 || r >= 48 && r <= 57 || r >= 65 && r <= 90 || r >= 97 && r <= 122 || s === _4.RFC1738 && (r === 40 || r === 41)) {
      a += o.charAt(M);
      continue;
    }
    if (r < 128) {
      a = a + ht[r];
      continue;
    }
    if (r < 2048) {
      a = a + (ht[192 | r >> 6] + ht[128 | r & 63]);
      continue;
    }
    if (r < 55296 || r >= 57344) {
      a = a + (ht[224 | r >> 12] + ht[128 | r >> 6 & 63] + ht[128 | r & 63]);
      continue;
    }
    M += 1, r = 65536 + ((r & 1023) << 10 | o.charCodeAt(M) & 1023), a += ht[240 | r >> 18] + ht[128 | r >> 12 & 63] + ht[128 | r >> 6 & 63] + ht[128 | r & 63];
  }
  return a;
}, $4 = function(t) {
  for (var i = [{ obj: { o: t }, prop: "o" }], n = [], u = 0; u < i.length; ++u)
    for (var s = i[u], o = s.obj[s.prop], a = Object.keys(o), M = 0; M < a.length; ++M) {
      var r = a[M], L = o[r];
      typeof L == "object" && L !== null && n.indexOf(L) === -1 && (i.push({ obj: o, prop: r }), n.push(L));
    }
  return k4(i), t;
}, V4 = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, G4 = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, Z4 = function(t, i) {
  return [].concat(t, i);
}, B4 = function(t, i) {
  if (oe(t)) {
    for (var n = [], u = 0; u < t.length; u += 1)
      n.push(i(t[u]));
    return n;
  }
  return i(t);
}, To = {
  arrayToObject: fo,
  assign: Q4,
  combine: Z4,
  compact: $4,
  decode: W4,
  encode: P4,
  isBuffer: G4,
  isRegExp: V4,
  maybeMap: B4,
  merge: U4
}, Eo = b4, _n = To, Ke = Iu, J4 = Object.prototype.hasOwnProperty, rs = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, i) {
    return t + "[" + i + "]";
  },
  repeat: function(t) {
    return t;
  }
}, bt = Array.isArray, F4 = String.prototype.split, R4 = Array.prototype.push, xo = function(e, t) {
  R4.apply(e, bt(t) ? t : [t]);
}, X4 = Date.prototype.toISOString, ls = Ke.default, Lt = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: _n.encode,
  encodeValuesOnly: !1,
  format: ls,
  formatter: Ke.formatters[ls],
  indices: !1,
  serializeDate: function(t) {
    return X4.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, H4 = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, dn = {}, K4 = function e(t, i, n, u, s, o, a, M, r, L, c, j, g, I, y, C) {
  for (var x = t, p = C, T = 0, E = !1; (p = p.get(dn)) !== void 0 && !E; ) {
    var O = p.get(t);
    if (T += 1, typeof O < "u") {
      if (O === T)
        throw new RangeError("Cyclic object value");
      E = !0;
    }
    typeof p.get(dn) > "u" && (T = 0);
  }
  if (typeof M == "function" ? x = M(i, x) : x instanceof Date ? x = c(x) : n === "comma" && bt(x) && (x = _n.maybeMap(x, function(z) {
    return z instanceof Date ? c(z) : z;
  })), x === null) {
    if (s)
      return a && !I ? a(i, Lt.encoder, y, "key", j) : i;
    x = "";
  }
  if (H4(x) || _n.isBuffer(x)) {
    if (a) {
      var v = I ? i : a(i, Lt.encoder, y, "key", j);
      if (n === "comma" && I) {
        for (var V = F4.call(String(x), ","), Z = "", $ = 0; $ < V.length; ++$)
          Z += ($ === 0 ? "" : ",") + g(a(V[$], Lt.encoder, y, "value", j));
        return [g(v) + (u && bt(x) && V.length === 1 ? "[]" : "") + "=" + Z];
      }
      return [g(v) + "=" + g(a(x, Lt.encoder, y, "value", j))];
    }
    return [g(i) + "=" + g(String(x))];
  }
  var h = [];
  if (typeof x > "u")
    return h;
  var Q;
  if (n === "comma" && bt(x))
    Q = [{ value: x.length > 0 ? x.join(",") || null : void 0 }];
  else if (bt(M))
    Q = M;
  else {
    var W = Object.keys(x);
    Q = r ? W.sort(r) : W;
  }
  for (var w = u && bt(x) && x.length === 1 ? i + "[]" : i, f = 0; f < Q.length; ++f) {
    var S = Q[f], D = typeof S == "object" && typeof S.value < "u" ? S.value : x[S];
    if (!(o && D === null)) {
      var N = bt(x) ? typeof n == "function" ? n(w, S) : w : w + (L ? "." + S : "[" + S + "]");
      C.set(t, T);
      var m = Eo();
      m.set(dn, C), xo(h, e(
        D,
        N,
        n,
        u,
        s,
        o,
        a,
        M,
        r,
        L,
        c,
        j,
        g,
        I,
        y,
        m
      ));
    }
  }
  return h;
}, q4 = function(t) {
  if (!t)
    return Lt;
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var i = t.charset || Lt.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = Ke.default;
  if (typeof t.format < "u") {
    if (!J4.call(Ke.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    n = t.format;
  }
  var u = Ke.formatters[n], s = Lt.filter;
  return (typeof t.filter == "function" || bt(t.filter)) && (s = t.filter), {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : Lt.addQueryPrefix,
    allowDots: typeof t.allowDots > "u" ? Lt.allowDots : !!t.allowDots,
    charset: i,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : Lt.charsetSentinel,
    delimiter: typeof t.delimiter > "u" ? Lt.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : Lt.encode,
    encoder: typeof t.encoder == "function" ? t.encoder : Lt.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : Lt.encodeValuesOnly,
    filter: s,
    format: n,
    formatter: u,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : Lt.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : Lt.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : Lt.strictNullHandling
  };
}, tI = function(e, t) {
  var i = e, n = q4(t), u, s;
  typeof n.filter == "function" ? (s = n.filter, i = s("", i)) : bt(n.filter) && (s = n.filter, u = s);
  var o = [];
  if (typeof i != "object" || i === null)
    return "";
  var a;
  t && t.arrayFormat in rs ? a = t.arrayFormat : t && "indices" in t ? a = t.indices ? "indices" : "repeat" : a = "indices";
  var M = rs[a];
  if (t && "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var r = M === "comma" && t && t.commaRoundTrip;
  u || (u = Object.keys(i)), n.sort && u.sort(n.sort);
  for (var L = Eo(), c = 0; c < u.length; ++c) {
    var j = u[c];
    n.skipNulls && i[j] === null || xo(o, K4(
      i[j],
      j,
      M,
      r,
      n.strictNullHandling,
      n.skipNulls,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      L
    ));
  }
  var g = o.join(n.delimiter), I = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? I += "utf8=%26%2310003%3B&" : I += "utf8=%E2%9C%93&"), g.length > 0 ? I + g : "";
}, Ye = To, kn = Object.prototype.hasOwnProperty, eI = Array.isArray, lt = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: Ye.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, iI = function(e) {
  return e.replace(/&#(\d+);/g, function(t, i) {
    return String.fromCharCode(parseInt(i, 10));
  });
}, Co = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, nI = "utf8=%26%2310003%3B", uI = "utf8=%E2%9C%93", sI = function(t, i) {
  var n = {}, u = i.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, s = i.parameterLimit === 1 / 0 ? void 0 : i.parameterLimit, o = u.split(i.delimiter, s), a = -1, M, r = i.charset;
  if (i.charsetSentinel)
    for (M = 0; M < o.length; ++M)
      o[M].indexOf("utf8=") === 0 && (o[M] === uI ? r = "utf-8" : o[M] === nI && (r = "iso-8859-1"), a = M, M = o.length);
  for (M = 0; M < o.length; ++M)
    if (M !== a) {
      var L = o[M], c = L.indexOf("]="), j = c === -1 ? L.indexOf("=") : c + 1, g, I;
      j === -1 ? (g = i.decoder(L, lt.decoder, r, "key"), I = i.strictNullHandling ? null : "") : (g = i.decoder(L.slice(0, j), lt.decoder, r, "key"), I = Ye.maybeMap(
        Co(L.slice(j + 1), i),
        function(y) {
          return i.decoder(y, lt.decoder, r, "value");
        }
      )), I && i.interpretNumericEntities && r === "iso-8859-1" && (I = iI(I)), L.indexOf("[]=") > -1 && (I = eI(I) ? [I] : I), kn.call(n, g) ? n[g] = Ye.combine(n[g], I) : n[g] = I;
    }
  return n;
}, oI = function(e, t, i, n) {
  for (var u = n ? t : Co(t, i), s = e.length - 1; s >= 0; --s) {
    var o, a = e[s];
    if (a === "[]" && i.parseArrays)
      o = [].concat(u);
    else {
      o = i.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var M = a.charAt(0) === "[" && a.charAt(a.length - 1) === "]" ? a.slice(1, -1) : a, r = parseInt(M, 10);
      !i.parseArrays && M === "" ? o = { 0: u } : !isNaN(r) && a !== M && String(r) === M && r >= 0 && i.parseArrays && r <= i.arrayLimit ? (o = [], o[r] = u) : M !== "__proto__" && (o[M] = u);
    }
    u = o;
  }
  return u;
}, aI = function(t, i, n, u) {
  if (!!t) {
    var s = n.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, o = /(\[[^[\]]*])/, a = /(\[[^[\]]*])/g, M = n.depth > 0 && o.exec(s), r = M ? s.slice(0, M.index) : s, L = [];
    if (r) {
      if (!n.plainObjects && kn.call(Object.prototype, r) && !n.allowPrototypes)
        return;
      L.push(r);
    }
    for (var c = 0; n.depth > 0 && (M = a.exec(s)) !== null && c < n.depth; ) {
      if (c += 1, !n.plainObjects && kn.call(Object.prototype, M[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      L.push(M[1]);
    }
    return M && L.push("[" + s.slice(M.index) + "]"), oI(L, i, n, u);
  }
}, MI = function(t) {
  if (!t)
    return lt;
  if (t.decoder !== null && t.decoder !== void 0 && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var i = typeof t.charset > "u" ? lt.charset : t.charset;
  return {
    allowDots: typeof t.allowDots > "u" ? lt.allowDots : !!t.allowDots,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : lt.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : lt.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : lt.arrayLimit,
    charset: i,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : lt.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : lt.comma,
    decoder: typeof t.decoder == "function" ? t.decoder : lt.decoder,
    delimiter: typeof t.delimiter == "string" || Ye.isRegExp(t.delimiter) ? t.delimiter : lt.delimiter,
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : lt.depth,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : lt.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : lt.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : lt.plainObjects,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : lt.strictNullHandling
  };
}, rI = function(e, t) {
  var i = MI(t);
  if (e === "" || e === null || typeof e > "u")
    return i.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof e == "string" ? sI(e, i) : e, u = i.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, s = Object.keys(n), o = 0; o < s.length; ++o) {
    var a = s[o], M = aI(a, n[a], i, typeof e == "string");
    u = Ye.merge(u, M, i);
  }
  return i.allowSparse === !0 ? u : Ye.compact(u);
}, lI = tI, cI = rI, LI = Iu, jI = {
  formats: LI,
  parse: cI,
  stringify: lI
};
const Sn = Bo.create({
  headers: { "Content-type": "application/json" },
  withCredentials: !0,
  paramsSerializer: (e) => jI.stringify(e, { arrayFormat: "repeat" })
});
function po() {
  return { api: Sn, execApiCall: async (n, u = null) => {
    u && (u.value = !0);
    try {
      return await n;
    } catch (s) {
      return console.log("Error executing api call: " + s), null;
    } finally {
      u && (u.value = !1);
    }
  }, configureApiUrl: (n) => {
    Sn.defaults.baseURL = n;
  }, initializePlatform: async () => {
    try {
      const n = await Sn.get("platform/info");
      if (n && n.status === 200 && n.data)
        return {
          title: n.data.intranetTitle,
          modules: n.data.intranetModules
        };
    } catch {
    }
    return null;
  } };
}
const { api: gI } = po();
class ho {
  constructor() {
    Tt(this, "_lastResponseStatus", null);
    Tt(this, "tryExecute", async (t) => {
      this._lastResponseStatus = null;
      try {
        return await t;
      } catch (i) {
        console.error("Server communication error.. " + i);
        const n = i;
        return n && n.isAxiosError && n.response && (console.warn("Error status " + n.response.status + " requesting endpoint " + n.config.url), this._lastResponseStatus = n.response.status, n.response.status == 400 && (console.error(n.response.data), n.response.data), n.response.status == 500 ? console.error(n.response.data) : n.response.status == 403 || n.response.status == 401), null;
      }
    });
  }
  get api() {
    return gI;
  }
  handleApiResponse(t) {
    if (!!t)
      return t.success || console.warn("Server response valid but request unsuccessful.." + JSON.stringify(t.messages)), t.data;
  }
  handleApiResultSuccess(t) {
    if (!!t)
      return t.success || console.warn("Server response valid but request unsuccessful.." + JSON.stringify(t.messages)), t.success;
  }
}
class II extends ho {
  async login(t, i) {
    let n = "account/login-custom";
    const u = localStorage.getItem("k-app-type");
    u == "intranet" ? n = "account/login-int" : u == "extranet" && (n = "account/login-ext");
    const s = await this.tryExecute(
      this.api.post(n, { username: t, password: i })
    );
    return this._lastResponseStatus == 422 ? {
      userName: t,
      passwordExpired: !0,
      defaultLanguageId: "",
      refreshToken: "",
      siteId: ""
    } : s.data;
  }
  async logout() {
    return (await this.tryExecute(
      this.api.get("account/logout")
    )).data;
  }
  async refresh() {
    return (await this.tryExecute(
      this.api.get("account/refresh")
    )).data;
  }
  async getLoggedUserInfo() {
    return (await this.tryExecute(
      this.api.get("account/me")
    )).data;
  }
  async getUserFavourites() {
    return (await this.tryExecute(this.api.get("account/favourites"))).data;
  }
  async changePassword(t, i, n) {
    const u = await this.tryExecute(
      this.api.post("account/change-password", { currentpassword: t, newpassword: i, confirmnewpassword: n })
    );
    return console.log(u.data), u.data;
  }
  async changeExpiredPassword(t, i, n, u) {
    const s = await this.tryExecute(
      this.api.post("account/change-expired-password", { username: t, currentpassword: i, newpassword: n, confirmnewpassword: u })
    );
    return console.log(s.data), s.data;
  }
}
const ie = new II(), { execApiCall: ne } = po(), ee = gs("kappa-user-store", {
  state: () => ({
    userAuthData: void 0,
    user: null,
    userInfo: null,
    userFavourites: [],
    systemFavourites: [],
    userRoutes: []
  }),
  getters: {
    isLogged(e) {
      return e.userAuthData && e.userAuthData.userName ? e.userAuthData.userName.length > 0 && e.userAuthData.passwordExpired !== !0 : !1;
    }
  },
  actions: {
    async changePassword(e, t, i) {
      return await ne(ie.changePassword(e, t, i));
    },
    async changeExpiredPassword(e, t, i) {
      const n = await ne(ie.changeExpiredPassword(this.userAuthData.userName, e, t, i));
      return n && n.success === !0 ? (await this.login(this.userAuthData.userName, t), !0) : !1;
    },
    async login(e, t) {
      const i = await ne(ie.login(e.trim(), t.trim()));
      i && i.userName && (this.userAuthData = i, i.passwordExpired !== !0 && await this.initUser());
    },
    async refreshToken() {
      const e = await ne(ie.refresh());
      e && e.userName && (this.userAuthData = e);
    },
    async logout() {
      await ne(ie.logout()) && this.$reset();
    },
    async initUser() {
      const e = ne(ie.getLoggedUserInfo()), t = ne(ie.getUserFavourites()), [i, n] = await Promise.all([e, t]);
      i && i.user && (this.user = i, this.userInfo = i.user, this.userLastAccess = i.lastAccess), n && (this.userFavourites = n.filter((u) => u.category.indexOf("SYSTEM.") > 0), this.systemFavourites = n.filter((u) => u.category.indexOf("SYSTEM.") == 0));
    }
  }
}), NI = {
  key: 0,
  class: "container"
}, yI = { class: "row justify-content-center" }, dI = { class: "col-lg-3 d-none d-lg-block scroll-filter-wrapper" }, SI = /* @__PURE__ */ l("h2", {
  class: "visually-hidden",
  id: "filter"
}, "filtri da applicare", -1), DI = { class: "categoy-list pb-4" }, AI = /* @__PURE__ */ l("legend", { class: "h6 text-uppercase category-list__title" }, "Tipologie", -1), fI = { class: "form-check" }, TI = { class: "checkbox-body border-light py-3" }, EI = ["id", "value"], xI = ["for"], CI = { class: "col-lg-8 offset-lg-1" }, pI = { class: "d-flex justify-content-between align-items-center border-bottom border-light pb-3 mb-2" }, hI = /* @__PURE__ */ l("h2", {
  class: "visually-hidden",
  id: "search-result"
}, "Risultati di ricerca", -1), mI = { class: "search-results u-grey-light" }, wI = { class: "numResult" }, zI = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal-categories",
  class: "btn p-0 pe-2 d-lg-none"
}, OI = { class: "rounded-icon" }, bI = /* @__PURE__ */ l("span", { class: "t-primary title-xsmall-semi-bold ms-1" }, "Filtra", -1), YI = ["disabled"], vI = { class: "container p-0" }, _I = { class: "row flex-column-reverse flex-lg-row" }, kI = { class: "col-12 pt-3" }, UI = { class: "card shadow-sm px-4 pt-4 pb-4 rounded" }, QI = /* @__PURE__ */ l("span", { class: "visually-hidden" }, "Categoria:", -1), WI = { class: "card-header border-0 p-0" }, PI = { class: "text-decoration-none title-xsmall-bold mb-2 category text-uppercase" }, $I = { class: "card-body p-0 my-2" }, VI = { class: "green-title-big t-primary" }, GI = ["href"], ZI = ["innerHTML"], BI = { class: "container p-0" }, JI = { class: "d-flex justify-content-center" }, FI = ["disabled"], RI = /* @__PURE__ */ l("span", { class: "" }, "Carica altri risultati", -1), XI = [
  RI
], HI = /* @__PURE__ */ F({
  __name: "KModalSearchResults",
  setup(e) {
    const t = We();
    return (i, n) => {
      const u = B("router-link");
      return b(t).lastSearchResultCount >= 0 && b(t).results && b(t).results.length >= 0 ? (d(), A("div", NI, [
        l("div", yI, [
          l("div", dI, [
            SI,
            l("fieldset", null, [
              l("div", DI, [
                AI,
                l("ul", null, [
                  (d(!0), A(gt, null, wt(b(t).sourcesFilters, (s) => (d(), A("li", {
                    key: s.source
                  }, [
                    l("div", fI, [
                      l("div", TI, [
                        Mi(l("input", {
                          type: "checkbox",
                          id: s.source,
                          value: s,
                          "onUpdate:modelValue": n[0] || (n[0] = (o) => b(t).resultSourceSelected = o),
                          class: "",
                          "data-focus-mouse": "false"
                        }, null, 8, EI), [
                          [cs, b(t).resultSourceSelected]
                        ]),
                        l("label", {
                          for: s.source,
                          class: "subtitle-small_semi-bold mb-0 category-list__list active"
                        }, Y(s.source) + " (" + Y(s.resultsCount) + ") ", 9, xI)
                      ])
                    ])
                  ]))), 128))
                ])
              ])
            ])
          ]),
          l("div", CI, [
            l("div", pI, [
              hI,
              l("span", mI, [
                l("span", wI, Y(b(t).totalResultsCount), 1),
                nt(" Risultati")
              ]),
              l("button", zI, [
                l("span", OI, [
                  U(Ot, {
                    class: "icon-primary icon-xs",
                    "aria-hidden": "true",
                    icon: "it-funnel"
                  })
                ]),
                bI
              ]),
              l("button", {
                type: "button",
                class: "btn d-none d-lg-block btn-result",
                disabled: b(t).lastSearchResultCount < 0,
                onClick: n[1] || (n[1] = (...s) => b(t).resetSearch && b(t).resetSearch(...s))
              }, " Rimuovi tutti i filtri ", 8, YI)
            ]),
            l("div", vI, [
              l("div", _I, [
                l("div", kI, [
                  U(au, {
                    loading: b(t).searchingMore
                  }, {
                    default: X(() => [
                      (d(!0), A(gt, null, wt(b(t).filteredResults, (s, o) => (d(), A("div", {
                        key: o,
                        class: "cmp-card-latest-messages mb-3 mb-30",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#",
                        id: ""
                      }, [
                        l("div", UI, [
                          QI,
                          l("div", WI, [
                            l("span", PI, Y(s.source), 1)
                          ]),
                          l("div", $I, [
                            l("h3", VI, [
                              s.urlExternal === !0 ? (d(), A("a", {
                                key: 0,
                                href: s.url,
                                target: "_blank",
                                class: "text-decoration-none",
                                "data-element": "service-link"
                              }, Y(s.title), 9, GI)) : (d(), K(u, {
                                key: 1,
                                to: { path: s.url },
                                class: "text-decoration-none",
                                "data-element": "service-link"
                              }, {
                                default: X(() => [
                                  nt(Y(s.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            ]),
                            l("p", {
                              class: "text-paragraph",
                              innerHTML: s.description
                            }, null, 8, ZI)
                          ])
                        ])
                      ]))), 128))
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            l("div", BI, [
              l("div", JI, [
                l("button", {
                  type: "button",
                  disabled: b(t).searchingMore || b(t).lastSearchResultCount == 0,
                  onClick: n[2] || (n[2] = (s) => b(t).executeGlobalSearchMoreResult()),
                  class: "btn btn-outline-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
                }, XI, 8, FI)
              ])
            ])
          ])
        ])
      ])) : _("", !0);
    };
  }
}), KI = ["onSubmit"], qI = { class: "container" }, tN = { class: "row variable-gutters" }, eN = { class: "col" }, iN = { class: "form-group autocomplete-wrapper" }, nN = {
  for: "kd-global-search-input",
  class: "visually-hidden"
}, uN = {
  class: "autocomplete-icon",
  "aria-hidden": "true",
  style: { left: "24px" }
}, sN = ["disabled"], oN = /* @__PURE__ */ F({
  __name: "KModalSearch",
  props: {
    title: { default: "Cerca" },
    searchTextHint: { default: "Cerca nel sito" },
    searchButtonText: { default: "Cerca" }
  },
  emits: ["closed", "startSearch"],
  setup(e, { emit: t }) {
    const i = We(), n = () => {
      t("closed");
    }, u = k(!1), s = k(null);
    jt(() => i.isSearchGlobalModalOpened, (a, M) => {
      console.log(`${M} -> ${a}`), M != a && a === !0 && je(() => {
        je(() => {
          s.value && s.value.focus();
        });
      });
    });
    const o = async () => {
      t("startSearch", i.searchText), u.value = !0;
      try {
        await i.executeGlobalSearch(i.searchText);
      } finally {
        u.value = !1;
      }
    };
    return (a, M) => (d(), K(ro, {
      title: e.title,
      modelValue: b(i).isSearchGlobalModalOpened,
      "onUpdate:modelValue": M[1] || (M[1] = (r) => b(i).isSearchGlobalModalOpened = r),
      onClosed: n
    }, {
      default: X(() => [
        l("form", {
          onSubmit: ko(o, ["prevent"])
        }, [
          l("div", qI, [
            l("div", tN, [
              l("div", eN, [
                l("div", iN, [
                  l("label", nN, Y(e.searchTextHint), 1),
                  Mi(l("input", {
                    type: "search",
                    "onUpdate:modelValue": M[0] || (M[0] = (r) => b(i).searchText = r),
                    class: "ps-5",
                    placeholder: "Cerca nel sito",
                    id: "kd-global-search-input",
                    name: "kd-global-search-input",
                    ref_key: "kdglobalsearchinput",
                    ref: s
                  }, null, 512), [
                    [js, b(i).searchText]
                  ]),
                  l("span", uN, [
                    U(Ot, { icon: "it-search" })
                  ]),
                  l("button", {
                    type: "submit",
                    disabled: b(i).searching,
                    class: "btn btn-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
                  }, Y(e.searchButtonText), 9, sN)
                ])
              ])
            ])
          ])
        ], 40, KI),
        U(au, {
          loading: b(i).searching
        }, {
          default: X(() => [
            U(HI)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]));
  }
}), aN = { class: "flex align-items-center layout-topbar" }, MN = /* @__PURE__ */ l("span", { class: "pi pi-bars" }, null, -1), rN = [
  MN
], lN = { class: "flex-grow-1 flex-shrink-1 flex align-items-center justify-content-start" }, cN = ["src"], LN = /* @__PURE__ */ l("div", { class: "flex-shrink-0 flex align-items-center justify-content-center" }, [
  /* @__PURE__ */ l("div", { class: "hidden md:inline-flex layout-topbar-icons" })
], -1), jN = { class: "flex-grow-1 flex-shrink-1 flex align-items-center justify-content-end" }, gN = /* @__PURE__ */ l("span", { class: "visually-hidden" }, "Cerca", -1), IN = {
  class: "avatar-wrapper avatar-extra-text",
  style: { "margin-bottom": "0" }
}, NN = ["title"], yN = { "aria-hidden": "true" }, dN = { class: "visually-hidden" }, SN = { class: "extra-text" }, DN = { style: { "font-size": "0.6em", "margin-top": "-5px" } }, AN = { style: { width: "200px" } }, fN = /* @__PURE__ */ F({
  __name: "AppTopbar",
  emits: ["menu-toggle"],
  setup(e, { emit: t }) {
    const { toDateTimeString: i } = Is(), n = Kt(), u = (I) => {
      t("menu-toggle", I);
    }, s = k(), o = (I) => {
      s.value.toggle(I);
    }, a = ee(), M = et(() => a.user && a.user.displayName && a.user.displayName.length > 0 ? a.user.displayName : "unknown"), r = et(() => {
      var I = M.value.match(/\b(\w)/g);
      return I.join("").toUpperCase();
    }), L = () => {
      a.logout();
    }, c = () => {
      n.push("/changepassword");
    }, j = We(), g = et(() => j.plugins.length > 0);
    return (I, y) => {
      const C = B("router-link"), x = B("KIcon");
      return d(), A("div", aN, [
        l("div", { class: "flex-grow-0 flex-shrink-0 flex align-items-center justify-content-center layout-topbar-button-menu" }, [
          l("button", {
            class: "p-link layout-menu-button",
            onClick: u
          }, rN)
        ]),
        l("div", lN, [
          U(C, {
            to: "/",
            class: "layout-topbar-logo"
          }, {
            default: X(() => [
              l("img", {
                alt: "logo",
                src: "/logo.png",
                style: { height: "50px" }
              }, null, 8, cN)
            ]),
            _: 1
          })
        ]),
        LN,
        l("div", jN, [
          b(g) ? (d(), A("a", {
            key: 0,
            class: "avatar size-lg",
            href: "#",
            onClick: y[0] || (y[0] = (p) => b(j).isSearchGlobalModalOpened = !0)
          }, [
            U(x, { icon: "it-search" }),
            gN
          ])) : _("", !0),
          l("div", IN, [
            l("a", {
              class: "avatar avatar-primary size-lg",
              href: "#",
              onClick: o,
              "data-bs-toggle": "tooltip",
              "data-bs-html": "true",
              "data-bs-placement": "top",
              title: b(M)
            }, [
              l("p", yN, Y(b(r)), 1),
              l("span", dN, Y(b(M)), 1)
            ], 8, NN),
            l("div", SN, [
              l("span", null, [
                l("a", {
                  href: "#",
                  onClick: o
                }, Y(b(M)), 1)
              ]),
              l("div", DN, " Ultimo accesso: " + Y(b(i)(b(a).userLastAccess)), 1)
            ])
          ]),
          U(b(Jo), {
            ref_key: "opUser",
            ref: s,
            dismissable: !0
          }, {
            default: X(() => [
              l("div", AN, [
                l("div", null, [
                  U(b(Nu), {
                    label: "Modifica password",
                    onClick: c,
                    class: "p-button-text"
                  }),
                  U(b(Nu), {
                    label: "Logout",
                    onClick: L,
                    class: "p-button-text"
                  })
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]),
        b(g) ? (d(), K(oN, { key: 0 })) : _("", !0)
      ]);
    };
  }
}), TN = { key: 0 }, EN = {
  key: 0,
  style: { opacity: "1" }
}, xN = ["alt", "title", "src"], CN = ["alt", "title", "src"], pN = /* @__PURE__ */ F({
  __name: "AppSubmenu",
  props: {
    items: null,
    root: { type: Boolean, default: !1 }
  },
  emits: ["menuitem-click"],
  setup(e, { emit: t }) {
    const i = (L) => L && (L.startsWith("\\") || L.startsWith("/") || L.startsWith(".")) ? L : `/${L}`, n = k(null), u = (L, c, j) => {
      if (c.disabled) {
        L.preventDefault();
        return;
      }
      !c.to && !c.url && L.preventDefault(), c.command && c.command({ originalEvent: L, item: c }), n.value = j === n.value ? null : j, t("menuitem-click", {
        originalEvent: L,
        item: c
      });
    }, s = (L) => typeof L.visible == "function" ? L.visible() : L.visible !== !1, o = (L) => {
      L && L.isOpened && L.isOpened === !0 ? L.isOpened = !1 : L.isOpened = !0;
    }, a = Ui(), M = Kt(), r = (L) => {
      if (!L.to)
        return !1;
      const c = M.currentRoute.value;
      return c && c.fullPath ? L.to == "/" ? c.fullPath == L.to : c.fullPath.indexOf(L.to) >= 0 : L.activeAliases && L.activeAliases.length > 0 ? L.activeAliases.some((j) => a.fullPath.indexOf(j) >= 0) : !1;
    };
    return (L, c) => {
      const j = B("router-link"), g = B("AppSubmenu", !0);
      return e.items ? (d(), A("ul", TN, [
        (d(!0), A(gt, null, wt(e.items, (I, y) => (d(), A(gt, null, [
          s(I) && !I.separator ? (d(), A("li", {
            key: y,
            class: J([{ active: r(I) }]),
            role: "none"
          }, [
            I.items ? (d(), A("a", EN, [
              I.icon ? (d(), A("i", {
                key: 0,
                class: J(I.icon)
              }, null, 2)) : _("", !0),
              I.iconAsset ? (d(), A("img", {
                key: 1,
                alt: I.label,
                title: I.label,
                src: i(I.iconAsset),
                style: { width: "36px" }
              }, null, 8, xN)) : _("", !0),
              l("span", null, Y(I.label), 1),
              U(b(Ot), {
                icon: I.isOpened ? "it-collapse" : "it-expand",
                class: "ms-auto icon-white btn-menu-collapse",
                onClick: (C) => o(I)
              }, null, 8, ["icon", "onClick"])
            ])) : (d(), K(j, {
              key: 1,
              to: I.to,
              class: J([I.class, "p-ripple", { "active-route": r(I), "p-disabled": I.disabled }]),
              onClick: (C) => u(C, I, y),
              exact: ""
            }, {
              default: X(() => [
                I.icon && I.icon.length > 0 ? (d(), A("i", {
                  key: 0,
                  class: J(I.icon),
                  style: { margin: "0 5px" }
                }, null, 2)) : _("", !0),
                I.iconAsset ? (d(), A("img", {
                  key: 1,
                  alt: I.label,
                  title: I.label,
                  src: i(I.iconAsset),
                  style: { width: "36px" }
                }, null, 8, CN)) : _("", !0),
                l("span", null, Y(I.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class", "onClick"])),
            U(Dn, { name: "layout-submenu-wrapper" }, {
              default: X(() => [
                I.isOpened ? (d(), K(g, {
                  key: 0,
                  items: s(I) && I.items,
                  onMenuitemClick: c[0] || (c[0] = (C) => L.$emit("menuitem-click", C))
                }, null, 8, ["items"])) : _("", !0)
              ]),
              _: 2
            }, 1024)
          ], 2)) : _("", !0),
          s(I) && I.separator ? (d(), A("li", {
            class: "p-menu-separator",
            style: Ft(I.style),
            key: "separator" + y,
            role: "separator"
          }, null, 4)) : _("", !0)
        ], 64))), 256))
      ])) : _("", !0);
    };
  }
}), hN = { class: "layout-menu-container" }, mN = /* @__PURE__ */ l("span", { class: "pi pi-bars" }, null, -1), wN = [
  mN
], zN = /* @__PURE__ */ F({
  __name: "AppMenu",
  emits: ["menu-toggle", "menuitem-click"],
  setup(e, { emit: t }) {
    const i = Kt();
    ee();
    const n = et(() => {
      const M = i.getRoutes().filter((c) => c.meta.menu).sort((c, j) => c.meta.menu.order - j.meta.menu.order);
      let r = {};
      const L = [];
      return M.forEach((c) => {
        if (c.meta.menu && c.meta.menu.group && c.meta.menu.group.length > 0) {
          const j = c.meta.menu.group;
          Object.keys(r).indexOf(j) < 0 && (r[j] = Qn({
            label: j,
            iconAsset: c.meta.menu.iconAsset,
            items: [],
            isOpened: !1
          }), L.push(r[j]));
          let g = [];
          c.meta.menu.activationAliases && (g = c.meta.menu.activationAliases), r[j].items.push({
            label: s(c),
            to: u(c),
            activeAliases: g
          });
        } else {
          let j = c.meta.menu.icon;
          j && j.length > 0 && j.startsWith("pi") == !1 && (j = "ms-Icon ms-Icon--" + j);
          let g = {
            label: s(c),
            icon: j,
            iconAsset: c.meta.menu.iconAsset,
            visible: c.meta.menu.hidden !== !0,
            to: u(c),
            activeAliases: []
          };
          L.push(g);
        }
      }), L;
    }), u = (M) => {
      let r = M.path;
      const L = M.meta.menu.defaultParams;
      if (L)
        for (let c = 0; c < L.length; c++) {
          const g = L[c].split(":");
          r = r.replace(`:${g[0]}`, g[1]);
        }
      return r;
    }, s = (M) => M.meta.menu.label, o = (M) => {
      t("menu-toggle", M);
    }, a = (M) => {
      t("menuitem-click", M);
    };
    return (M, r) => (d(), A("div", hN, [
      l("div", { class: "layout-menu-button-container" }, [
        l("button", {
          class: "p-link layout-menu-button",
          onClick: o
        }, wN)
      ]),
      U(pN, {
        items: b(n),
        class: "layout-menu",
        root: !0,
        onMenuitemClick: a
      }, null, 8, ["items"])
    ]));
  }
}), ON = /* @__PURE__ */ F({
  __name: "StandardLayout",
  setup(e) {
    const t = Ui();
    Kt();
    const i = k("static"), n = k("light"), u = k(!1), s = k(!1), o = k(!1), a = k(!1), M = k(!1);
    jt(
      () => t,
      () => {
        a.value = !1;
      },
      { immediate: !0 }
    );
    const r = () => window.innerWidth > 1024, L = () => {
      M.value || (s.value = !1, o.value = !1), M.value = !1;
    }, c = () => {
      M.value = !0, r() ? i.value === "overlay" ? (o.value === !0 && (s.value = !0), s.value = !s.value, o.value = !1) : i.value === "static" && (u.value = !u.value) : o.value = !o.value;
    }, j = () => M.value = !0, g = (T) => {
      T.item && !T.item.items && (s.value = !1, o.value = !1);
    }, I = (T, E) => {
      T.classList ? T.classList.add(E) : T.className += " " + E;
    }, y = (T, E) => {
      T.classList ? T.classList.remove(E) : T.className = T.className.replace(new RegExp("(^|\\b)" + E.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }, C = () => r() ? i.value === "static" ? !u.value : i.value === "overlay" ? s.value : !0 : !0, x = et(() => ["layout-wrapper", {
      "layout-overlay": i.value === "overlay",
      "layout-static": i.value === "static",
      "layout-static-sidebar-inactive": u.value && i.value === "static",
      "layout-overlay-sidebar-active": s.value && i.value === "overlay",
      "layout-mobile-sidebar-active": o.value
    }]), p = et(() => ["layout-sidebar", {
      "layout-sidebar-dark": n.value === "dark",
      "layout-sidebar-light": n.value === "light",
      "layout-sidebar-compact": !C()
    }]);
    return et(() => n.value === "dark" ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg"), Uo(() => {
      o.value ? I(document.body, "body-overflow-hidden") : y(document.body, "body-overflow-hidden");
    }), (T, E) => {
      const O = B("router-view");
      return d(), A("div", {
        class: J(b(x)),
        onClick: L
      }, [
        U(fN, { onMenuToggle: c }),
        U(Dn, { name: "layout-sidebar" }, {
          default: X(() => [
            l("div", {
              class: J(b(p)),
              onClick: j
            }, [
              U(zN, {
                onMenuToggle: c,
                onMenuitemClick: g
              })
            ], 2)
          ]),
          _: 1
        }),
        l("div", {
          class: J(["layout-main", { "layout-main-compact": !C() }])
        }, [
          U(O, null, {
            default: X(({ Component: v }) => [
              U(Dn, {
                name: "fade",
                mode: "out-in"
              }, {
                default: X(() => [
                  (d(), K(Qo(v)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ], 2)
      ], 2);
    };
  }
});
function Py() {
  const e = {
    splash: yg,
    default: ON,
    anonymous: Dg
  };
  return { appStarting: k(!1), layouts: e };
}
let Ve = null;
function mo() {
  return { loadConfig: (n) => {
    Ve = n;
  }, getTitle: () => {
    let n = APP_NAME;
    const u = localStorage.getItem("k-app-name");
    return u && u.trim().length > 0 && (n = u.trim()), n;
  }, getModule: (n) => Ve != null && Ve.modules && Ve.modules.length > 0 ? Ve.modules.find((u) => u.key == n) : null };
}
function $y() {
  return { biAccordion: (t) => {
    Vr.getOrCreateInstance(t);
  } };
}
class Vy {
  constructor(t) {
    Tt(this, "propertyName", "");
    Tt(this, "code", "");
    Tt(this, "text");
    Tt(this, "type", "");
    this.text = t;
  }
}
class Gy {
  constructor() {
    Tt(this, "pageIndex");
    Tt(this, "pageSize");
    Tt(this, "sortField");
    Tt(this, "sortOrder");
  }
}
var bN = /* @__PURE__ */ ((e) => (e[e.Descending = -1] = "Descending", e[e.Ascending = 1] = "Ascending", e))(bN || {});
class YN extends ho {
  async getTreeFromNode(t) {
    return (await this.tryExecute(
      this.api.get("CMS/node-tree/" + t)
    )).data;
  }
}
const Zy = new YN(), vN = { class: "login" }, _N = { class: "p-float-label" }, kN = /* @__PURE__ */ l("label", { for: "username" }, "Username", -1), UN = { class: "p-float-label" }, QN = /* @__PURE__ */ l("label", { for: "password" }, "Password", -1), WN = { class: "msg-area" }, PN = /* @__PURE__ */ F({
  __name: "Login",
  setup(e) {
    const { getTitle: t } = mo(), i = t(), n = Kt(), u = ee(), s = k(!1), o = k(""), a = k(""), M = Qi(), r = async () => {
      if (j.value = "", o.value.length > 0 && a.value.length > 0)
        if (s.value = !0, await u.login(o.value, a.value), s.value = !1, !u.isLogged)
          u.userAuthData && u.userAuthData.passwordExpired === !0 ? (M.add({ severity: "info", summary: "Cambio password", detail: "La password deve essere cambiata per il primo utilizzo.", life: 3e3 }), n.push("/newpassword")) : j.value = "Nome utente o password non validi.";
        else {
          let g = "/";
          if (n.currentRoute.value.query) {
            let I = n.currentRoute.value.query.returnUrl;
            I && I.length > 0 && (g = I.toString());
          }
          n.push(g);
        }
      else
        j.value = "Specificare nome utente e password per proseguire.";
    }, L = () => {
      u.logout();
    }, c = et(() => u.isLogged), j = k("");
    return (g, I) => {
      const y = B("InputText"), C = B("Password"), x = B("Button"), p = B("Card"), T = B("router-link"), E = B("Message");
      return d(), A("div", vN, [
        b(c) ? (d(), K(p, {
          key: 1,
          class: "login-card"
        }, {
          content: X(() => [
            U(T, {
              to: "/",
              "active-class": "active"
            }, {
              default: X(() => [
                nt("Home")
              ]),
              _: 1
            }),
            l("p", null, " login state: " + Y(b(c) ? "Logged In" : "NOT logged in"), 1)
          ]),
          footer: X(() => [
            U(x, {
              label: "Esci",
              onClick: L
            })
          ]),
          _: 1
        })) : (d(), K(p, {
          key: 0,
          class: "login-card"
        }, {
          title: X(() => [
            nt(Y(b(i)) + " Login ", 1)
          ]),
          content: X(() => [
            l("p", null, [
              l("span", _N, [
                U(y, {
                  id: "username",
                  type: "text",
                  modelValue: o.value,
                  "onUpdate:modelValue": I[0] || (I[0] = (O) => o.value = O),
                  onKeyup: re(r, ["enter"]),
                  class: "w-full"
                }, null, 8, ["modelValue", "onKeyup"]),
                kN
              ])
            ]),
            l("p", null, [
              l("span", UN, [
                U(C, {
                  modelValue: a.value,
                  "onUpdate:modelValue": I[1] || (I[1] = (O) => a.value = O),
                  onKeyup: re(r, ["enter"]),
                  toggleMask: "",
                  promptLabel: "false",
                  feedback: !1,
                  class: "w-full"
                }, null, 8, ["modelValue", "onKeyup"]),
                QN
              ])
            ])
          ]),
          footer: X(() => [
            U(x, {
              label: "Accedi",
              loading: s.value,
              onClick: r
            }, null, 8, ["loading"])
          ]),
          _: 1
        })),
        l("div", WN, [
          j.value && j.value.length > 0 ? (d(), K(E, {
            key: 0,
            severity: "error",
            closable: !1
          }, {
            default: X(() => [
              nt(Y(j.value), 1)
            ]),
            _: 1
          })) : _("", !0)
        ])
      ]);
    };
  }
});
const $N = {}, VN = /* @__PURE__ */ l("h1", null, "404", -1);
function GN(e, t) {
  const i = B("router-link");
  return d(), A(gt, null, [
    VN,
    U(i, {
      to: "/",
      "active-class": "active"
    }, {
      default: X(() => [
        nt("Home")
      ]),
      _: 1
    })
  ], 64);
}
const ZN = /* @__PURE__ */ Ji($N, [["render", GN]]), BN = {}, JN = /* @__PURE__ */ l("h1", null, "NOT AUTHORIZED", -1);
function FN(e, t) {
  const i = B("router-link");
  return d(), A(gt, null, [
    JN,
    U(i, {
      to: "/login",
      "active-class": "active"
    }, {
      default: X(() => [
        nt("Please login")
      ]),
      _: 1
    })
  ], 64);
}
const RN = /* @__PURE__ */ Ji(BN, [["render", FN]]), XN = { class: "card" }, HN = { class: "field" }, KN = /* @__PURE__ */ l("label", { for: "vecchiapassword" }, "Vecchia Password", -1), qN = { class: "field" }, ty = /* @__PURE__ */ l("label", { for: "nuovapassword" }, "Nuova Password", -1), ey = { class: "field" }, iy = /* @__PURE__ */ l("label", { for: "confermanuovapassword" }, "Conferma Nuova Password", -1), ny = { class: "msg-area" }, uy = /* @__PURE__ */ F({
  __name: "ChangePassword",
  setup(e) {
    const t = k(""), i = k(""), n = k(""), u = k(""), s = ee(), o = Qi();
    Fo();
    const a = k(!1), M = async () => {
      if (i.value != null && (i.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!]+$/.test(i.value) == !1)) {
        u.value = "La password deve essere lunga almeno 8 caratteri. Pu\xF2 contenere lettere, numeri e i caratteri ~_&*%@$!";
        return;
      }
      if (i.value != n.value) {
        u.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (i.value == t.value) {
        u.value = "La nuova password deve essere diversa da quella attuale.";
        return;
      }
      if (t.value.length > 0 && i.value.length > 0 && n.value.length > 0) {
        a.value = !0;
        const r = await s.changePassword(t.value, i.value, n.value);
        a.value = !1, r ? r.success ? (o.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), u.value = "", t.value = "", i.value = "", n.value = "") : (u.value = "Si \xE8 verificato un problema.", r.details.length > 0 && (u.value = r.details[0].message)) : u.value = "Si \xE8 verificato un problema.";
      } else
        u.value = "Specificare la vecchia password e la nuova password per proseguire.";
    };
    return St(async () => {
    }), (r, L) => {
      const c = B("PageHeader"), j = B("Password"), g = B("Button"), I = B("Message"), y = B("Page");
      return d(), K(y, null, {
        default: X(() => [
          U(c, { title: "Modifica Password" }),
          l("div", XN, [
            l("div", HN, [
              KN,
              U(j, {
                id: "vecchiapassword",
                modelValue: t.value,
                "onUpdate:modelValue": L[0] || (L[0] = (C) => t.value = C),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            l("div", qN, [
              ty,
              U(j, {
                id: "nuovapassword",
                modelValue: i.value,
                "onUpdate:modelValue": L[1] || (L[1] = (C) => i.value = C),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            l("div", ey, [
              iy,
              U(j, {
                id: "confermanuovapassword",
                modelValue: n.value,
                "onUpdate:modelValue": L[2] || (L[2] = (C) => n.value = C),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            l("div", null, [
              U(g, {
                label: "Salva",
                loading: a.value,
                onClick: M
              }, null, 8, ["loading"])
            ])
          ]),
          l("div", ny, [
            u.value && u.value.length > 0 ? (d(), K(I, {
              key: 0,
              severity: "error",
              closable: !1
            }, {
              default: X(() => [
                nt(Y(u.value), 1)
              ]),
              _: 1
            })) : _("", !0)
          ])
        ]),
        _: 1
      });
    };
  }
});
const sy = { class: "p-float-label" }, oy = /* @__PURE__ */ l("label", { for: "oldpassword" }, "Vecchia Password", -1), ay = {
  class: "p-float-label",
  style: { margin: "25px 0" }
}, My = /* @__PURE__ */ l("label", { for: "newpassword" }, "Nuova Password", -1), ry = { class: "p-float-label" }, ly = /* @__PURE__ */ l("label", { for: "newpasswordconfirm" }, "Conferma Nuova Password", -1), cy = { class: "msg-area" }, Ly = /* @__PURE__ */ F({
  __name: "NewPassword",
  setup(e) {
    const t = k(""), i = k(""), n = k(""), u = k(""), s = Kt(), o = ee(), a = k(!1), M = async () => {
      if (u.value = "", i.value != null && (i.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!]+$/.test(i.value) == !1)) {
        u.value = "La password deve essere lunga almeno 8 caratteri. Pu\xF2 contenere lettere, numeri e i caratteri ~_&*%@$!";
        return;
      }
      if (i.value != n.value) {
        u.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (i.value == t.value) {
        u.value = "La nuova password deve essere diversa da quella attuale.";
        return;
      }
      if (t.value.length > 0 && i.value.length > 0 && n.value.length > 0) {
        a.value = !0;
        const r = await o.changeExpiredPassword(t.value, i.value, n.value);
        a.value = !1, r ? s.push("/") : u.value = "Si \xE8 verificato un problema.";
      } else
        u.value = "Specificare la vecchia password e la nuova password per proseguire.";
    };
    return (r, L) => {
      const c = B("Password"), j = B("Message"), g = B("Button"), I = B("Card");
      return d(), K(I, { style: { padding: "10px" } }, {
        title: X(() => [
          nt(" Cambio password per primo utilizzo ")
        ]),
        content: X(() => [
          l("p", null, [
            l("span", sy, [
              U(c, {
                id: "oldpassword",
                modelValue: t.value,
                "onUpdate:modelValue": L[0] || (L[0] = (y) => t.value = y),
                onKeyup: re(M, ["enter"]),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue", "onKeyup"]),
              oy
            ])
          ]),
          l("p", null, [
            l("span", ay, [
              U(c, {
                id: "newpassword",
                modelValue: i.value,
                "onUpdate:modelValue": L[1] || (L[1] = (y) => i.value = y),
                onKeyup: re(M, ["enter"]),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue", "onKeyup"]),
              My
            ])
          ]),
          l("p", null, [
            l("span", ry, [
              U(c, {
                id: "newpasswordconfirm",
                modelValue: n.value,
                "onUpdate:modelValue": L[2] || (L[2] = (y) => n.value = y),
                onKeyup: re(M, ["enter"]),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue", "onKeyup"]),
              ly
            ])
          ]),
          l("div", cy, [
            u.value && u.value.length > 0 ? (d(), K(j, {
              key: 0,
              severity: "error",
              closable: !1
            }, {
              default: X(() => [
                nt(Y(u.value), 1)
              ]),
              _: 1
            })) : _("", !0)
          ])
        ]),
        footer: X(() => [
          U(g, {
            label: "Salva",
            loading: a.value,
            onClick: M
          }, null, 8, ["loading"])
        ]),
        _: 1
      });
    };
  }
}), jy = { class: "login" }, gy = /* @__PURE__ */ l("p", null, [
  /* @__PURE__ */ nt(" Non ricordi la password?"),
  /* @__PURE__ */ l("br"),
  /* @__PURE__ */ nt("Inserisci la tua mail, riceverai un codice di verifica all'indirizzo specificato e le istruzioni per poterla modificare. ")
], -1), Iy = { class: "field" }, Ny = /* @__PURE__ */ l("label", { for: "mail" }, "Indirizzo e-mail", -1), yy = { class: "msg-area" }, dy = /* @__PURE__ */ F({
  __name: "ResetPassword",
  setup(e) {
    const { getTitle: t } = mo(), i = t(), n = k(""), u = k("");
    ee();
    const s = Qi(), o = k(!1), a = async () => {
      u.value = "", n.value.length > 0 ? (s.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), u.value = "", n.value = "") : u.value = "Specificare l'indirizzo e-mail.";
    };
    return (M, r) => {
      const L = B("Button"), c = B("Card"), j = B("Message");
      return d(), A("div", jy, [
        U(c, { class: "login-card" }, {
          title: X(() => [
            nt(Y(b(i)), 1)
          ]),
          content: X(() => [
            gy,
            l("p", null, [
              l("div", Iy, [
                Ny,
                Mi(l("input", {
                  type: "text",
                  id: "mail",
                  "onUpdate:modelValue": r[0] || (r[0] = (g) => n.value = g),
                  class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                }, null, 512), [
                  [js, n.value]
                ])
              ])
            ])
          ]),
          footer: X(() => [
            U(L, {
              label: "Invia la richiesta",
              loading: o.value,
              onClick: a
            }, null, 8, ["loading"])
          ]),
          _: 1
        }),
        l("div", yy, [
          u.value && u.value.length > 0 ? (d(), K(j, {
            key: 0,
            severity: "error",
            closable: !1
          }, {
            default: X(() => [
              nt(Y(u.value), 1)
            ]),
            _: 1
          })) : _("", !0)
        ])
      ]);
    };
  }
});
const Sy = { class: "login" }, Dy = /* @__PURE__ */ l("p", null, " Inserisci una nuova password per completare l'operazione di reset. ", -1), Ay = { class: "field" }, fy = /* @__PURE__ */ l("label", { for: "nuovapassword" }, "Nuova Password", -1), Ty = { class: "field" }, Ey = /* @__PURE__ */ l("label", { for: "confermanuovapassword" }, "Conferma Nuova Password", -1), xy = { class: "msg-area" }, Cy = /* @__PURE__ */ F({
  __name: "ResetPassword2",
  setup(e) {
    const t = APP_NAME, i = k(""), n = k(""), u = k("");
    ee();
    const s = Qi(), o = k(!1), a = async () => {
      u.value = "", i.value.length > 0 && n.value.length > 0 && i.value == n.value ? (s.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), u.value = "", i.value = "", n.value = "") : u.value = "Specificare la nuova password e la sua conferma.";
    };
    return (M, r) => {
      const L = B("Password"), c = B("Button"), j = B("Card"), g = B("Message");
      return d(), A("div", Sy, [
        U(j, { class: "login-card" }, {
          title: X(() => [
            nt(Y(b(t)), 1)
          ]),
          content: X(() => [
            Dy,
            l("p", null, [
              l("div", Ay, [
                fy,
                U(L, {
                  id: "nuovapassword",
                  modelValue: i.value,
                  "onUpdate:modelValue": r[0] || (r[0] = (I) => i.value = I),
                  toggleMask: "",
                  promptLabel: "false",
                  feedback: !1,
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ]),
              l("div", Ty, [
                Ey,
                U(L, {
                  id: "confermanuovapassword",
                  modelValue: n.value,
                  "onUpdate:modelValue": r[1] || (r[1] = (I) => n.value = I),
                  toggleMask: "",
                  promptLabel: "false",
                  feedback: !1,
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          footer: X(() => [
            U(c, {
              label: "Salva la nuova password",
              loading: o.value,
              onClick: a
            }, null, 8, ["loading"])
          ]),
          _: 1
        }),
        l("div", xy, [
          u.value && u.value.length > 0 ? (d(), K(g, {
            key: 0,
            severity: "error",
            closable: !1
          }, {
            default: X(() => [
              nt(Y(u.value), 1)
            ]),
            _: 1
          })) : _("", !0)
        ])
      ]);
    };
  }
});
const py = [
  {
    path: "/login",
    component: PN,
    meta: { layout: "anonymous" }
  },
  {
    path: "/forbidden",
    component: RN,
    meta: { layout: "anonymous" }
  },
  {
    path: "/404",
    component: ZN,
    meta: { layout: "anonymous" }
  },
  {
    path: "/changepassword",
    component: uy,
    meta: {
      requiresAuth: !0
    }
  },
  {
    path: "/newpassword",
    component: Ly,
    meta: { layout: "anonymous" }
  },
  {
    path: "/resetpassword",
    component: dy,
    meta: { layout: "anonymous" }
  },
  {
    path: "/resetpassword2",
    component: Cy,
    meta: { layout: "anonymous" }
  }
], hy = (e, t, i = null) => {
  const n = py;
  Object.keys(e).forEach((o) => {
    n.push(...e[o]);
  }), n.push({ path: "/:pathMatch(.*)*", name: "not-found", redirect: "/404" });
  const u = Go({
    history: Zo({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 }.VITE_ROUTE_BASE_PATH),
    routes: n
  }), s = (o, a, M) => {
    if (i) {
      const r = i(o, a);
      r && r.length > 0 ? M(r) : M();
    } else
      M();
  };
  return u.beforeEach(async (o, a, M) => {
    const r = ee();
    if (o.matched.some((L) => L.meta.requiresAuth === !0))
      if (r.isLogged)
        s(o.fullPath, a.fullPath, M);
      else if (await r.refreshToken(), r.isLogged)
        s(o.fullPath, a.fullPath, M);
      else {
        let L = "/login";
        o.fullPath && o.fullPath.length > 0 && (L += "?returnUrl=" + o.fullPath), M(L);
      }
    else
      M();
  }), u;
};
function wo(e) {
  for (const t in Ru)
    e.component(t, Ru[t]);
  At.extend(ca), e.component("Page", Ho), e.component("PageHeader", ta), e.component("PageHeaderFull", la);
}
const By = { install: wo }, Jy = (e) => {
  localStorage.setItem("k-app-name", e.appName), localStorage.setItem("k-app-type", e.appType);
  const t = Wo(e.rootElement);
  t.use(wo);
  const i = hy(e.optionalModules, e.routeBasePath, e.routerBeforeNavigateGuard);
  t.use(i);
  const n = Vo();
  if (t.use(n), e.globalSearchPlugins && e.globalSearchPlugins.length > 0) {
    const u = We();
    e.globalSearchPlugins.forEach((s) => u.addSearchPlugin(s));
  }
  return t;
};
export {
  Vy as ApiResponseMessage,
  Gy as BaseFinder,
  ho as BaseService,
  Wy as ExternalPage,
  Ge as InputChipsType,
  La as K2ColContainer,
  ja as K3ColContainer,
  ga as KBackButton,
  Ca as KCard,
  ql as KCarousel,
  ic as KCheckbox,
  Cc as KDataTableActions,
  mc as KDatePicker,
  wc as KGlobalSearchBar,
  Ot as KIcon,
  _c as KInputChips,
  Pc as KInputPassword,
  Xc as KInputSearch,
  nL as KInputText,
  aL as KInputTextArea,
  dL as KLinkCarousel,
  CL as KModalCenter,
  ro as KModalFullPage,
  $L as KModalSlide,
  xj as KNavScroll,
  pj as KNavScrollItem,
  wj as KNotificationCard,
  Mj as KPaginator,
  Yj as KRadioButton,
  lo as KSectionHeader,
  Wj as KSelect,
  au as KSpinner,
  sg as KStepperHeader,
  cg as KTab,
  rg as KTabs,
  Ze as ModalDimension,
  Ti as NotiticationLevel,
  bN as SortingOrder,
  Wt as TwoColumnLayoutRatio,
  Zy as cmsService,
  Jy as createKappaApp,
  By as default,
  $y as useBootstrapItalia,
  mo as useConfig,
  Is as useFilters,
  We as useGlobalSearchStore,
  Py as useLayouts,
  po as usePlatformApi,
  ee as useUserStore
};
